/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from '../API'

type GeneratedMutation<InputType, OutputType> = string & {
	__generatedMutationInput: InputType
	__generatedMutationOutput: OutputType
}

export const addOfflineIds =
	/* GraphQL */ `mutation AddOfflineIds($quoteId: ID!, $username: String!) {
  addOfflineIds(quoteId: $quoteId, username: $username) {
    status
    message
  }
}
` as GeneratedMutation<
		APITypes.AddOfflineIdsMutationVariables,
		APITypes.AddOfflineIdsMutation
	>
export const removeOfflineIds =
	/* GraphQL */ `mutation RemoveOfflineIds($quoteId: ID!, $username: String!) {
  removeOfflineIds(quoteId: $quoteId, username: $username) {
    status
    message
  }
}
` as GeneratedMutation<
		APITypes.RemoveOfflineIdsMutationVariables,
		APITypes.RemoveOfflineIdsMutation
	>
export const removeFreelancerFromProject =
	/* GraphQL */ `mutation RemoveFreelancerFromProject($projectId: ID!, $freelancerId: ID!) {
  removeFreelancerFromProject(
    projectId: $projectId
    freelancerId: $freelancerId
  ) {
    status
    message
  }
}
` as GeneratedMutation<
		APITypes.RemoveFreelancerFromProjectMutationVariables,
		APITypes.RemoveFreelancerFromProjectMutation
	>
export const createQuoteInfoCostlines =
	/* GraphQL */ `mutation CreateQuoteInfoCostlines(
  $input: QuoteInfoInputDetails
  $quoteType: String!
  $budgetSections: [String!]
) {
  createQuoteInfoCostlines(
    input: $input
    quoteType: $quoteType
    budgetSections: $budgetSections
  ) {
    status
    message
  }
}
` as GeneratedMutation<
		APITypes.CreateQuoteInfoCostlinesMutationVariables,
		APITypes.CreateQuoteInfoCostlinesMutation
	>
export const createBlankQuoteInfoCostlines =
	/* GraphQL */ `mutation CreateBlankQuoteInfoCostlines(
  $input: QuoteInfoInputDetails
  $quoteType: String!
) {
  createBlankQuoteInfoCostlines(input: $input, quoteType: $quoteType) {
    status
    message
  }
}
` as GeneratedMutation<
		APITypes.CreateBlankQuoteInfoCostlinesMutationVariables,
		APITypes.CreateBlankQuoteInfoCostlinesMutation
	>
export const createQuoteFromJson = /* GraphQL */ `mutation CreateQuoteFromJson(
  $input: QuoteInfoInputDetails
  $budgetSections: [String!]
  $quoteJson: QuoteJsonInputDetails!
) {
  createQuoteFromJson(
    input: $input
    budgetSections: $budgetSections
    quoteJson: $quoteJson
  ) {
    status
    message
  }
}
` as GeneratedMutation<
	APITypes.CreateQuoteFromJsonMutationVariables,
	APITypes.CreateQuoteFromJsonMutation
>
export const duplicateQuote = /* GraphQL */ `mutation DuplicateQuote(
  $quoteId: ID!
  $quoteNumber: String
  $bidLetter: Boolean
  $recapTable: Boolean
  $budgetColumn: [String]
  $budgetCategories: [String]
) {
  duplicateQuote(
    quoteId: $quoteId
    quoteNumber: $quoteNumber
    bidLetter: $bidLetter
    recapTable: $recapTable
    budgetColumn: $budgetColumn
    budgetCategories: $budgetCategories
  ) {
    status
    message
  }
}
` as GeneratedMutation<
	APITypes.DuplicateQuoteMutationVariables,
	APITypes.DuplicateQuoteMutation
>
export const startAiQuote =
	/* GraphQL */ `mutation StartAiQuote($input: StartAiQuoteInput!) {
  startAiQuote(input: $input) {
    status
    quoteId
    runId
  }
}
` as GeneratedMutation<
		APITypes.StartAiQuoteMutationVariables,
		APITypes.StartAiQuoteMutation
	>
export const newQuoteFromTemplate =
	/* GraphQL */ `mutation NewQuoteFromTemplate(
  $quoteId: ID!
  $parentProjectId: ID!
  $quoteNumber: String
) {
  newQuoteFromTemplate(
    quoteId: $quoteId
    parentProjectId: $parentProjectId
    quoteNumber: $quoteNumber
  ) {
    status
    message
  }
}
` as GeneratedMutation<
		APITypes.NewQuoteFromTemplateMutationVariables,
		APITypes.NewQuoteFromTemplateMutation
	>
export const moveQuote =
	/* GraphQL */ `mutation MoveQuote($quoteId: ID!, $parentProjectId: ID!, $quoteNumber: String) {
  moveQuote(
    quoteId: $quoteId
    parentProjectId: $parentProjectId
    quoteNumber: $quoteNumber
  ) {
    status
    message
  }
}
` as GeneratedMutation<
		APITypes.MoveQuoteMutationVariables,
		APITypes.MoveQuoteMutation
	>
export const moveProject = /* GraphQL */ `mutation MoveProject(
  $projectId: ID!
  $tenantId: ID!
  $parentTeamId: ID!
  $parentSubTeamId: ID!
  $childFreelancers: [ID!]
) {
  moveProject(
    projectId: $projectId
    tenantId: $tenantId
    parentTeamId: $parentTeamId
    parentSubTeamId: $parentSubTeamId
    childFreelancers: $childFreelancers
  ) {
    status
    message
  }
}
` as GeneratedMutation<
	APITypes.MoveProjectMutationVariables,
	APITypes.MoveProjectMutation
>
export const updateQuoteMarginsAndOverhead =
	/* GraphQL */ `mutation UpdateQuoteMarginsAndOverhead(
  $quoteId: ID!
  $updateGlobalMargins: Boolean
  $updateGlobalOverheads: Boolean
  $updateGlobalExchangeRate: Boolean
  $updateOT: Boolean
  $updateQuoteCurrency: Boolean
) {
  updateQuoteMarginsAndOverhead(
    quoteId: $quoteId
    updateGlobalMargins: $updateGlobalMargins
    updateGlobalOverheads: $updateGlobalOverheads
    updateGlobalExchangeRate: $updateGlobalExchangeRate
    updateOT: $updateOT
    updateQuoteCurrency: $updateQuoteCurrency
  ) {
    status
    message
  }
}
` as GeneratedMutation<
		APITypes.UpdateQuoteMarginsAndOverheadMutationVariables,
		APITypes.UpdateQuoteMarginsAndOverheadMutation
	>
export const updateQuoteMarginsAndOverhead2 =
	/* GraphQL */ `mutation UpdateQuoteMarginsAndOverhead2(
  $quoteId: ID!
  $updateGlobalMargins: Boolean
  $updateGlobalOverheads: Boolean
  $updateGlobalExchangeRate: Boolean
  $updateOT: Boolean
  $updateQuoteCurrency: Boolean
) {
  updateQuoteMarginsAndOverhead2(
    quoteId: $quoteId
    updateGlobalMargins: $updateGlobalMargins
    updateGlobalOverheads: $updateGlobalOverheads
    updateGlobalExchangeRate: $updateGlobalExchangeRate
    updateOT: $updateOT
    updateQuoteCurrency: $updateQuoteCurrency
  ) {
    status
    message
  }
}
` as GeneratedMutation<
		APITypes.UpdateQuoteMarginsAndOverhead2MutationVariables,
		APITypes.UpdateQuoteMarginsAndOverhead2Mutation
	>
export const calculateMarginsAndTotals =
	/* GraphQL */ `mutation CalculateMarginsAndTotals($quoteId: ID!) {
  calculateMarginsAndTotals(quoteId: $quoteId) {
    status
    message
  }
}
` as GeneratedMutation<
		APITypes.CalculateMarginsAndTotalsMutationVariables,
		APITypes.CalculateMarginsAndTotalsMutation
	>
export const deleteClientById =
	/* GraphQL */ `mutation DeleteClientById($clientId: ID!) {
  deleteClientById(clientId: $clientId) {
    status
    message
  }
}
` as GeneratedMutation<
		APITypes.DeleteClientByIdMutationVariables,
		APITypes.DeleteClientByIdMutation
	>
export const deleteProjectById =
	/* GraphQL */ `mutation DeleteProjectById($projectId: ID!) {
  deleteProjectById(projectId: $projectId) {
    status
    message
  }
}
` as GeneratedMutation<
		APITypes.DeleteProjectByIdMutationVariables,
		APITypes.DeleteProjectByIdMutation
	>
export const deleteQuoteById =
	/* GraphQL */ `mutation DeleteQuoteById($quoteId: ID!) {
  deleteQuoteById(quoteId: $quoteId) {
    status
    message
  }
}
` as GeneratedMutation<
		APITypes.DeleteQuoteByIdMutationVariables,
		APITypes.DeleteQuoteByIdMutation
	>
export const fetchUpdatedTransactions =
	/* GraphQL */ `mutation FetchUpdatedTransactions($companyTenantId: ID!) {
  fetchUpdatedTransactions(companyTenantId: $companyTenantId) {
    status
    isSuccessful
  }
}
` as GeneratedMutation<
		APITypes.FetchUpdatedTransactionsMutationVariables,
		APITypes.FetchUpdatedTransactionsMutation
	>
export const addBank = /* GraphQL */ `mutation AddBank($companyTenantId: ID!) {
  addBank(companyTenantId: $companyTenantId) {
    status
    isSuccessful
  }
}
` as GeneratedMutation<
	APITypes.AddBankMutationVariables,
	APITypes.AddBankMutation
>
export const fetchItemsAndBankAndAccounts =
	/* GraphQL */ `mutation FetchItemsAndBankAndAccounts($companyTenantId: ID!) {
  fetchItemsAndBankAndAccounts(companyTenantId: $companyTenantId) {
    itemsArray {
      id
      status
      status_code_info
      status_code_description
      bank_id
    }
    banksArray {
      id
      name
      country_code
      logo_url
      authentication_type
      url
      is_highlighted
      primary_color
      secondary_color
      parent_name
      capabilities
      payment {
        nb_max_transactions
        max_size_label
        multiple_dates_payments
        sender_iban_available
      }
      channel_type
      display_order
    }
    accountsArray {
      id
      name
      balance
      status
      status_code_info
      status_code_description
      updated_at
      type
      currency_code
      item_id
      bank_id
      loan_details {
        next_payment_date
        next_payment_amount
        maturity_date
        opening_date
        interest_rate
        type
        borrowed_capital
        repaid_capital
        remaining_capital
      }
      savings_details {
        opening_date
        interest_rate
        ceiling
      }
      is_pro
      iban
    }
  }
}
` as GeneratedMutation<
		APITypes.FetchItemsAndBankAndAccountsMutationVariables,
		APITypes.FetchItemsAndBankAndAccountsMutation
	>
export const createOrUpdateSelectedAccountDetails =
	/* GraphQL */ `mutation CreateOrUpdateSelectedAccountDetails(
  $companyTenantId: ID!
  $selectedAccounts: [AccountsInput]
) {
  createOrUpdateSelectedAccountDetails(
    companyTenantId: $companyTenantId
    selectedAccounts: $selectedAccounts
  ) {
    status
    isSuccessful
  }
}
` as GeneratedMutation<
		APITypes.CreateOrUpdateSelectedAccountDetailsMutationVariables,
		APITypes.CreateOrUpdateSelectedAccountDetailsMutation
	>
export const editItem =
	/* GraphQL */ `mutation EditItem($companyTenantId: ID!, $itemId: String) {
  editItem(companyTenantId: $companyTenantId, itemId: $itemId) {
    status
    isSuccessful
  }
}
` as GeneratedMutation<
		APITypes.EditItemMutationVariables,
		APITypes.EditItemMutation
	>
export const deleteItem =
	/* GraphQL */ `mutation DeleteItem($companyTenantId: ID!, $itemId: String) {
  deleteItem(companyTenantId: $companyTenantId, itemId: $itemId) {
    status
    isSuccessful
  }
}
` as GeneratedMutation<
		APITypes.DeleteItemMutationVariables,
		APITypes.DeleteItemMutation
	>
export const redirectToSCA =
	/* GraphQL */ `mutation RedirectToSCA($companyTenantId: ID!, $itemId: String) {
  redirectToSCA(companyTenantId: $companyTenantId, itemId: $itemId) {
    status
    isSuccessful
  }
}
` as GeneratedMutation<
		APITypes.RedirectToSCAMutationVariables,
		APITypes.RedirectToSCAMutation
	>
export const validateProAccounts =
	/* GraphQL */ `mutation ValidateProAccounts($companyTenantId: ID!, $itemId: String) {
  validateProAccounts(companyTenantId: $companyTenantId, itemId: $itemId) {
    status
    isSuccessful
  }
}
` as GeneratedMutation<
		APITypes.ValidateProAccountsMutationVariables,
		APITypes.ValidateProAccountsMutation
	>
export const addPettyCashInvoice = /* GraphQL */ `mutation AddPettyCashInvoice(
  $companyTenantId: ID!
  $userName: String
  $currentTransactionId: ID!
  $pettyCashData: PettyCashPreparePurchaseDataType
) {
  addPettyCashInvoice(
    companyTenantId: $companyTenantId
    userName: $userName
    currentTransactionId: $currentTransactionId
    pettyCashData: $pettyCashData
  ) {
    status
    isSuccessful
  }
}
` as GeneratedMutation<
	APITypes.AddPettyCashInvoiceMutationVariables,
	APITypes.AddPettyCashInvoiceMutation
>
export const createMasterQuote =
	/* GraphQL */ `mutation CreateMasterQuote($primaryQuote: ID!, $secondaryQuotes: [String!]!) {
  createMasterQuote(
    primaryQuote: $primaryQuote
    secondaryQuotes: $secondaryQuotes
  ) {
    status
    message
  }
}
` as GeneratedMutation<
		APITypes.CreateMasterQuoteMutationVariables,
		APITypes.CreateMasterQuoteMutation
	>
export const createMergedQuoteTemplate =
	/* GraphQL */ `mutation CreateMergedQuoteTemplate(
  $primaryQuote: ID!
  $secondaryQuotes: [String!]!
) {
  createMergedQuoteTemplate(
    primaryQuote: $primaryQuote
    secondaryQuotes: $secondaryQuotes
  ) {
    status
    message
  }
}
` as GeneratedMutation<
		APITypes.CreateMergedQuoteTemplateMutationVariables,
		APITypes.CreateMergedQuoteTemplateMutation
	>
export const addSecondaryToMasterQuote =
	/* GraphQL */ `mutation AddSecondaryToMasterQuote(
  $primaryQuote: ID!
  $secondaryQuotes: [ID!]!
) {
  addSecondaryToMasterQuote(
    primaryQuote: $primaryQuote
    secondaryQuotes: $secondaryQuotes
  ) {
    status
    message
  }
}
` as GeneratedMutation<
		APITypes.AddSecondaryToMasterQuoteMutationVariables,
		APITypes.AddSecondaryToMasterQuoteMutation
	>
export const detachMemberQuoteFromMasterQuote =
	/* GraphQL */ `mutation DetachMemberQuoteFromMasterQuote(
  $masterQuoteId: ID!
  $memberQuoteId: ID!
) {
  detachMemberQuoteFromMasterQuote(
    masterQuoteId: $masterQuoteId
    memberQuoteId: $memberQuoteId
  ) {
    status
    reason
    blockingQuoteId
    message
  }
}
` as GeneratedMutation<
		APITypes.DetachMemberQuoteFromMasterQuoteMutationVariables,
		APITypes.DetachMemberQuoteFromMasterQuoteMutation
	>
export const syncRecapInfo =
	/* GraphQL */ `mutation SyncRecapInfo($quoteId: ID!) {
  syncRecapInfo(quoteId: $quoteId) {
    status
    message
  }
}
` as GeneratedMutation<
		APITypes.SyncRecapInfoMutationVariables,
		APITypes.SyncRecapInfoMutation
	>
export const addFractionalSortKey =
	/* GraphQL */ `mutation AddFractionalSortKey($quoteId: ID!) {
  addFractionalSortKey(quoteId: $quoteId) {
    status
    message
  }
}
` as GeneratedMutation<
		APITypes.AddFractionalSortKeyMutationVariables,
		APITypes.AddFractionalSortKeyMutation
	>
export const toggleArchivePreparePurchase =
	/* GraphQL */ `mutation ToggleArchivePreparePurchase(
  $companyTenantId: ID!
  $preparePurchaseId: ID!
) {
  toggleArchivePreparePurchase(
    companyTenantId: $companyTenantId
    preparePurchaseId: $preparePurchaseId
  ) {
    status
    isSuccessful
  }
}
` as GeneratedMutation<
		APITypes.ToggleArchivePreparePurchaseMutationVariables,
		APITypes.ToggleArchivePreparePurchaseMutation
	>
export const handleMoveToPrepareFromExport =
	/* GraphQL */ `mutation HandleMoveToPrepareFromExport(
  $companyTenantId: ID!
  $preparePurchaseId: ID!
) {
  handleMoveToPrepareFromExport(
    companyTenantId: $companyTenantId
    preparePurchaseId: $preparePurchaseId
  ) {
    status
    isSuccessful
  }
}
` as GeneratedMutation<
		APITypes.HandleMoveToPrepareFromExportMutationVariables,
		APITypes.HandleMoveToPrepareFromExportMutation
	>
export const moveBackToReview =
	/* GraphQL */ `mutation MoveBackToReview($companyTenantId: ID!, $preparePurchaseId: String!) {
  moveBackToReview(
    companyTenantId: $companyTenantId
    preparePurchaseId: $preparePurchaseId
  ) {
    status
    isSuccessful
  }
}
` as GeneratedMutation<
		APITypes.MoveBackToReviewMutationVariables,
		APITypes.MoveBackToReviewMutation
	>
export const updatePaymentStatus = /* GraphQL */ `mutation UpdatePaymentStatus(
  $companyTenantId: ID!
  $preparePurchaseId: ID!
  $date: AWSDateTime
) {
  updatePaymentStatus(
    companyTenantId: $companyTenantId
    preparePurchaseId: $preparePurchaseId
    date: $date
  ) {
    status
    isSuccessful
  }
}
` as GeneratedMutation<
	APITypes.UpdatePaymentStatusMutationVariables,
	APITypes.UpdatePaymentStatusMutation
>
export const dailyUpdatePaymentStatusFromPreparePurchase =
	/* GraphQL */ `mutation DailyUpdatePaymentStatusFromPreparePurchase(
  $companyTenantId: ID!
  $preparePurchaseIdArray: [ID!]!
) {
  dailyUpdatePaymentStatusFromPreparePurchase(
    companyTenantId: $companyTenantId
    preparePurchaseIdArray: $preparePurchaseIdArray
  ) {
    status
    isSuccessful
  }
}
` as GeneratedMutation<
		APITypes.DailyUpdatePaymentStatusFromPreparePurchaseMutationVariables,
		APITypes.DailyUpdatePaymentStatusFromPreparePurchaseMutation
	>
export const dailyUpdatePaymentStatusFromPurchases =
	/* GraphQL */ `mutation DailyUpdatePaymentStatusFromPurchases(
  $companyTenantId: ID!
  $purchaseId: ID!
) {
  dailyUpdatePaymentStatusFromPurchases(
    companyTenantId: $companyTenantId
    purchaseId: $purchaseId
  ) {
    status
    isSuccessful
  }
}
` as GeneratedMutation<
		APITypes.DailyUpdatePaymentStatusFromPurchasesMutationVariables,
		APITypes.DailyUpdatePaymentStatusFromPurchasesMutation
	>
export const markAsToPay =
	/* GraphQL */ `mutation MarkAsToPay($companyTenantId: ID!, $selected: [String]) {
  markAsToPay(companyTenantId: $companyTenantId, selected: $selected) {
    status
    isSuccessful
  }
}
` as GeneratedMutation<
		APITypes.MarkAsToPayMutationVariables,
		APITypes.MarkAsToPayMutation
	>
export const bulkUndoToPay =
	/* GraphQL */ `mutation BulkUndoToPay($companyTenantId: ID!, $selected: [String]) {
  bulkUndoToPay(companyTenantId: $companyTenantId, selected: $selected) {
    status
    isSuccessful
  }
}
` as GeneratedMutation<
		APITypes.BulkUndoToPayMutationVariables,
		APITypes.BulkUndoToPayMutation
	>
export const bulkMarkAsPaid = /* GraphQL */ `mutation BulkMarkAsPaid(
  $companyTenantId: ID!
  $selected: [String]
  $date: AWSDateTime
) {
  bulkMarkAsPaid(
    companyTenantId: $companyTenantId
    selected: $selected
    date: $date
  ) {
    status
    isSuccessful
  }
}
` as GeneratedMutation<
	APITypes.BulkMarkAsPaidMutationVariables,
	APITypes.BulkMarkAsPaidMutation
>
export const bulkUnmarkAsPaid =
	/* GraphQL */ `mutation BulkUnmarkAsPaid($companyTenantId: ID!, $selected: [String]) {
  bulkUnmarkAsPaid(companyTenantId: $companyTenantId, selected: $selected) {
    status
    isSuccessful
  }
}
` as GeneratedMutation<
		APITypes.BulkUnmarkAsPaidMutationVariables,
		APITypes.BulkUnmarkAsPaidMutation
	>
export const undoToPay =
	/* GraphQL */ `mutation UndoToPay($companyTenantId: ID!, $rowId: String) {
  undoToPay(companyTenantId: $companyTenantId, rowId: $rowId) {
    status
    isSuccessful
  }
}
` as GeneratedMutation<
		APITypes.UndoToPayMutationVariables,
		APITypes.UndoToPayMutation
	>
export const markAsPendingReconciliation =
	/* GraphQL */ `mutation MarkAsPendingReconciliation(
  $companyTenantId: ID!
  $preparePurchaseIdArray: [String]
) {
  markAsPendingReconciliation(
    companyTenantId: $companyTenantId
    preparePurchaseIdArray: $preparePurchaseIdArray
  ) {
    status
    isSuccessful
  }
}
` as GeneratedMutation<
		APITypes.MarkAsPendingReconciliationMutationVariables,
		APITypes.MarkAsPendingReconciliationMutation
	>
export const updateLastExportedDate =
	/* GraphQL */ `mutation UpdateLastExportedDate(
  $companyTenantId: ID!
  $preparePurchaseIdArray: [String]
) {
  updateLastExportedDate(
    companyTenantId: $companyTenantId
    preparePurchaseIdArray: $preparePurchaseIdArray
  ) {
    status
    isSuccessful
  }
}
` as GeneratedMutation<
		APITypes.UpdateLastExportedDateMutationVariables,
		APITypes.UpdateLastExportedDateMutation
	>
export const bulkUndoPendingReconciliation =
	/* GraphQL */ `mutation BulkUndoPendingReconciliation(
  $companyTenantId: ID!
  $selected: [String]
) {
  bulkUndoPendingReconciliation(
    companyTenantId: $companyTenantId
    selected: $selected
  ) {
    status
    isSuccessful
  }
}
` as GeneratedMutation<
		APITypes.BulkUndoPendingReconciliationMutationVariables,
		APITypes.BulkUndoPendingReconciliationMutation
	>
export const assign = /* GraphQL */ `mutation Assign(
  $companyTenantId: ID!
  $preparePurchaseId: String
  $invoiceDetails: InvoiceDetailsType
  $operation: String
  $quoteIdArray: [String]
) {
  assign(
    companyTenantId: $companyTenantId
    preparePurchaseId: $preparePurchaseId
    invoiceDetails: $invoiceDetails
    operation: $operation
    quoteIdArray: $quoteIdArray
  ) {
    status
    isSuccessful
  }
}
` as GeneratedMutation<
	APITypes.AssignMutationVariables,
	APITypes.AssignMutation
>
export const assignDirectlyToExports =
	/* GraphQL */ `mutation AssignDirectlyToExports(
  $companyTenantId: ID!
  $preparePurchaseId: String
  $operation: String
) {
  assignDirectlyToExports(
    companyTenantId: $companyTenantId
    preparePurchaseId: $preparePurchaseId
    operation: $operation
  ) {
    status
    isSuccessful
  }
}
` as GeneratedMutation<
		APITypes.AssignDirectlyToExportsMutationVariables,
		APITypes.AssignDirectlyToExportsMutation
	>
export const createOrUpdateCurrency =
	/* GraphQL */ `mutation CreateOrUpdateCurrency($companyTenantId: ID!) {
  createOrUpdateCurrency(companyTenantId: $companyTenantId) {
    status
    isSuccessful
  }
}
` as GeneratedMutation<
		APITypes.CreateOrUpdateCurrencyMutationVariables,
		APITypes.CreateOrUpdateCurrencyMutation
	>
export const updateInvoiceLastExportedDate =
	/* GraphQL */ `mutation UpdateInvoiceLastExportedDate(
  $companyTenantId: ID!
  $invoiceIdArray: [String]
) {
  updateInvoiceLastExportedDate(
    companyTenantId: $companyTenantId
    invoiceIdArray: $invoiceIdArray
  ) {
    status
    isSuccessful
  }
}
` as GeneratedMutation<
		APITypes.UpdateInvoiceLastExportedDateMutationVariables,
		APITypes.UpdateInvoiceLastExportedDateMutation
	>
export const updateCostLineLabel =
	/* GraphQL */ `mutation UpdateCostLineLabel($quoteId: ID!) {
  updateCostLineLabel(quoteId: $quoteId) {
    status
    message
  }
}
` as GeneratedMutation<
		APITypes.UpdateCostLineLabelMutationVariables,
		APITypes.UpdateCostLineLabelMutation
	>
export const generatePaymentsLink =
	/* GraphQL */ `mutation GeneratePaymentsLink($companyTenantId: ID!, $rowId: String) {
  generatePaymentsLink(companyTenantId: $companyTenantId, rowId: $rowId) {
    status
    isSuccessful
  }
}
` as GeneratedMutation<
		APITypes.GeneratePaymentsLinkMutationVariables,
		APITypes.GeneratePaymentsLinkMutation
	>
export const sendClientInvoiceEmail =
	/* GraphQL */ `mutation SendClientInvoiceEmail(
  $companyTenantId: ID!
  $username: String
  $invoiceId: ID
  $bucketName: String
  $key: String
  $emailData: EmailData
  $currentLanguage: String
  $companyName: String
) {
  sendClientInvoiceEmail(
    companyTenantId: $companyTenantId
    username: $username
    invoiceId: $invoiceId
    bucketName: $bucketName
    key: $key
    emailData: $emailData
    currentLanguage: $currentLanguage
    companyName: $companyName
  ) {
    status
    isSuccessful
  }
}
` as GeneratedMutation<
		APITypes.SendClientInvoiceEmailMutationVariables,
		APITypes.SendClientInvoiceEmailMutation
	>
export const generateAiBidLetter =
	/* GraphQL */ `mutation GenerateAiBidLetter($quoteId: ID!) {
  generateAiBidLetter(quoteId: $quoteId) {
    status
    message
  }
}
` as GeneratedMutation<
		APITypes.GenerateAiBidLetterMutationVariables,
		APITypes.GenerateAiBidLetterMutation
	>
export const fillCostlinesFromBudgetTotal =
	/* GraphQL */ `mutation FillCostlinesFromBudgetTotal(
  $quoteId: ID!
  $totalBudget: Float!
  $totalCrewBudget: Float!
  $totalPostProdBudget: Float
  $crewPrepNumberOfDays: Int!
  $crewShootNumberOfDays: Int!
) {
  fillCostlinesFromBudgetTotal(
    quoteId: $quoteId
    totalBudget: $totalBudget
    totalCrewBudget: $totalCrewBudget
    totalPostProdBudget: $totalPostProdBudget
    crewPrepNumberOfDays: $crewPrepNumberOfDays
    crewShootNumberOfDays: $crewShootNumberOfDays
  ) {
    status
    message
  }
}
` as GeneratedMutation<
		APITypes.FillCostlinesFromBudgetTotalMutationVariables,
		APITypes.FillCostlinesFromBudgetTotalMutation
	>
export const createFreelanceBillingRecord =
	/* GraphQL */ `mutation CreateFreelanceBillingRecord(
  $projectId: ID!
  $freelancerId: ID!
  $tenantId: ID!
) {
  createFreelanceBillingRecord(
    projectId: $projectId
    freelancerId: $freelancerId
    tenantId: $tenantId
  ) {
    status
    message
  }
}
` as GeneratedMutation<
		APITypes.CreateFreelanceBillingRecordMutationVariables,
		APITypes.CreateFreelanceBillingRecordMutation
	>
export const refundFreelancer =
	/* GraphQL */ `mutation RefundFreelancer($projectId: ID!, $freelancerId: ID!, $tenantId: ID!) {
  refundFreelancer(
    projectId: $projectId
    freelancerId: $freelancerId
    tenantId: $tenantId
  ) {
    status
    message
  }
}
` as GeneratedMutation<
		APITypes.RefundFreelancerMutationVariables,
		APITypes.RefundFreelancerMutation
	>
export const createAuditEvent = /* GraphQL */ `mutation CreateAuditEvent(
  $input: CreateAuditEventInput!
  $condition: ModelAuditEventConditionInput
) {
  createAuditEvent(input: $input, condition: $condition) {
    tenantId
    sk
    id
    ts
    action
    outcome
    reason
    actor {
      type
      id
      email
    }
    source {
      type
      ip
      userAgent
      sessionId
    }
    entity {
      type
      id
      externalId
      provider
    }
    entityKey
    before
    after
    metadata
    correlationId
    requestId
    idempotencyKey
    env
    hash
    prevHash
    ttl
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedMutation<
	APITypes.CreateAuditEventMutationVariables,
	APITypes.CreateAuditEventMutation
>
export const updateAuditEvent = /* GraphQL */ `mutation UpdateAuditEvent(
  $input: UpdateAuditEventInput!
  $condition: ModelAuditEventConditionInput
) {
  updateAuditEvent(input: $input, condition: $condition) {
    tenantId
    sk
    id
    ts
    action
    outcome
    reason
    actor {
      type
      id
      email
    }
    source {
      type
      ip
      userAgent
      sessionId
    }
    entity {
      type
      id
      externalId
      provider
    }
    entityKey
    before
    after
    metadata
    correlationId
    requestId
    idempotencyKey
    env
    hash
    prevHash
    ttl
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedMutation<
	APITypes.UpdateAuditEventMutationVariables,
	APITypes.UpdateAuditEventMutation
>
export const deleteAuditEvent = /* GraphQL */ `mutation DeleteAuditEvent(
  $input: DeleteAuditEventInput!
  $condition: ModelAuditEventConditionInput
) {
  deleteAuditEvent(input: $input, condition: $condition) {
    tenantId
    sk
    id
    ts
    action
    outcome
    reason
    actor {
      type
      id
      email
    }
    source {
      type
      ip
      userAgent
      sessionId
    }
    entity {
      type
      id
      externalId
      provider
    }
    entityKey
    before
    after
    metadata
    correlationId
    requestId
    idempotencyKey
    env
    hash
    prevHash
    ttl
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedMutation<
	APITypes.DeleteAuditEventMutationVariables,
	APITypes.DeleteAuditEventMutation
>
export const createBankAccountInfo =
	/* GraphQL */ `mutation CreateBankAccountInfo(
  $input: CreateBankAccountInfoInput!
  $condition: ModelBankAccountInfoConditionInput
) {
  createBankAccountInfo(input: $input, condition: $condition) {
    id
    tenantId
    activeFlag
    isSelected
    name
    balance
    status
    status_code_info
    status_code_description
    updated_at
    type
    currency_code
    item_id
    bank_id
    loan_details {
      next_payment_date
      next_payment_amount
      maturity_date
      opening_date
      interest_rate
      type
      borrowed_capital
      repaid_capital
      remaining_capital
    }
    savings_details {
      opening_date
      interest_rate
      ceiling
    }
    is_pro
    iban
    balanceHistory {
      balance
      updated_at
    }
    lastUpdatedTransactionDate
    _deleted
    _version
    _lastChangedAt
    createdOn
    updatedOn
  }
}
` as GeneratedMutation<
		APITypes.CreateBankAccountInfoMutationVariables,
		APITypes.CreateBankAccountInfoMutation
	>
export const updateBankAccountInfo =
	/* GraphQL */ `mutation UpdateBankAccountInfo(
  $input: UpdateBankAccountInfoInput!
  $condition: ModelBankAccountInfoConditionInput
) {
  updateBankAccountInfo(input: $input, condition: $condition) {
    id
    tenantId
    activeFlag
    isSelected
    name
    balance
    status
    status_code_info
    status_code_description
    updated_at
    type
    currency_code
    item_id
    bank_id
    loan_details {
      next_payment_date
      next_payment_amount
      maturity_date
      opening_date
      interest_rate
      type
      borrowed_capital
      repaid_capital
      remaining_capital
    }
    savings_details {
      opening_date
      interest_rate
      ceiling
    }
    is_pro
    iban
    balanceHistory {
      balance
      updated_at
    }
    lastUpdatedTransactionDate
    _deleted
    _version
    _lastChangedAt
    createdOn
    updatedOn
  }
}
` as GeneratedMutation<
		APITypes.UpdateBankAccountInfoMutationVariables,
		APITypes.UpdateBankAccountInfoMutation
	>
export const deleteBankAccountInfo =
	/* GraphQL */ `mutation DeleteBankAccountInfo(
  $input: DeleteBankAccountInfoInput!
  $condition: ModelBankAccountInfoConditionInput
) {
  deleteBankAccountInfo(input: $input, condition: $condition) {
    id
    tenantId
    activeFlag
    isSelected
    name
    balance
    status
    status_code_info
    status_code_description
    updated_at
    type
    currency_code
    item_id
    bank_id
    loan_details {
      next_payment_date
      next_payment_amount
      maturity_date
      opening_date
      interest_rate
      type
      borrowed_capital
      repaid_capital
      remaining_capital
    }
    savings_details {
      opening_date
      interest_rate
      ceiling
    }
    is_pro
    iban
    balanceHistory {
      balance
      updated_at
    }
    lastUpdatedTransactionDate
    _deleted
    _version
    _lastChangedAt
    createdOn
    updatedOn
  }
}
` as GeneratedMutation<
		APITypes.DeleteBankAccountInfoMutationVariables,
		APITypes.DeleteBankAccountInfoMutation
	>
export const createBankTransactions =
	/* GraphQL */ `mutation CreateBankTransactions(
  $input: CreateBankTransactionsInput!
  $condition: ModelBankTransactionsConditionInput
) {
  createBankTransactions(input: $input, condition: $condition) {
    id
    tenantId
    activeFlag
    flag
    clean_description
    bank_description
    amount
    date
    updated_at
    currency_code
    is_deleted
    category_id
    account_id
    account_name
    is_future
    show_client_side
    projectId
    projectName
    status
    tags
    transactionType
    uniqueTransactionId
    invoices {
      items {
        id
        tenantId
        proposalId
        quoteType
        activeFlag
        originalInvoiceId
        creditInvoiceGenerated
        archivedDate
        paidDate
        paymentStatus
        quoteName
        quoteNumber
        projectName
        projectNumber
        clientId
        contactId
        clientName
        contactName
        clientTaxType
        clientEmail
        clientAddress
        clientCountry
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        title
        invoiceNumber
        poNumber
        invoiceAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        clientNote
        isDetailed
        isClientTaxRate
        bankProfileNumber
        invoicesBankProfileName
        invoicesBank
        invoicesIban
        invoicesBic
        invoicesAccountName
        invoiceDate
        invoiceDueDate
        description
        creditComments
        invoiceType
        proposalsDraft {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
          salesAccNumberType
        }
        taxDetails {
          taxRate
          taxPercentage
          taxAmount
          taxableAmount
        }
        salesAccNumberType
        sectionDetails {
          type
          amount
        }
        sectionDetailsByQuote {
          type
          amount
        }
        sectionDetailsByAccSection {
          type
          amount
        }
        proposals {
          id
          tenantId
          activeFlag
          quoteId
          quoteType
          clientId
          contactId
          status
          noofInvoices
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientTaxType
          clientName
          contactName
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          paymentTerms
          total
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          proposalsBankProfileName
          proposalsBank
          proposalsIban
          proposalsBic
          proposalsAccountName
          createdOn
          updatedOn
          poDate
          poName
          poAmount
          poCurrency
          poNotes
          poVersion
          prevStatus
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          _deleted
          _version
          _lastChangedAt
        }
        createdOn
        updatedOn
        uniqueTransactionId
        assignedTenantId
        assignedTenantName
        showBidLetter
        companyLogo
        lastExportedDate
        emailSent
        draftEmailData {
          toEmail
          toCC
          toBCC
          subject
          body
          template
        }
        emailHistory {
          date
          subject
        }
        billitInboxItemId
        billitPeppolStatus
        billitPeppolError
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    preparePurchase {
      items {
        id
        tenantId
        activeFlag
        uniqueTransactionId
        flag
        invoiceName
        ocrInvoiceName
        fileName
        ocrFileName
        invoiceDate
        ocrInvoiceDate
        paymentDate
        ocrPaymentDate
        paymentStatus
        preparePurchasePaidDate
        supplier
        ocrSupplier
        po
        ocrPO
        costlineName
        costlineName_fr
        projectName
        totalAmount
        taxAmount
        netAmountDetails {
          netAmount
          category
          projectId
          projectName
          projectNumber
          costlineId
          costlineName
          costlineName_fr
        }
        taxAmountDetails {
          taxAmount
          vatAccount
          vatIntracom
        }
        netAmount
        ocrTotalAmount
        ocrTaxAmount
        ocrNetAmount
        currency
        ocrCurrency
        type
        status
        currentPage
        prevPage
        archivedDate
        category
        ocrCategory
        note
        ocrNote
        invoiceDocuments {
          bucket
          region
          key
          identityId
        }
        poId
        quoteId
        supplierId
        costlineId
        projectId
        ocrStatus
        vatAccount
        ocrData {
          bucket
          region
          key
          identityId
        }
        invoiceKey
        paymentMethods
        vatIntracom
        bankAccountNumber
        paymentReference
        paymentReferenceType
        bankAccountName
        supplierAccountingNumber
        supplierAccountingName
        projectNumber
        quoteNumber
        lastExportedDate
        preparePurchaseToPayDate
        fullPurchaseNumber
        bridgePaymentLinkId
        billitInboxItemId
        billitPeppolFileId
        billitSenderPeppolId
        billitImportDate
        createdOn
        updatedOn
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    miscAccNo
    _deleted
    _version
    _lastChangedAt
    createdOn
    updatedOn
  }
}
` as GeneratedMutation<
		APITypes.CreateBankTransactionsMutationVariables,
		APITypes.CreateBankTransactionsMutation
	>
export const updateBankTransactions =
	/* GraphQL */ `mutation UpdateBankTransactions(
  $input: UpdateBankTransactionsInput!
  $condition: ModelBankTransactionsConditionInput
) {
  updateBankTransactions(input: $input, condition: $condition) {
    id
    tenantId
    activeFlag
    flag
    clean_description
    bank_description
    amount
    date
    updated_at
    currency_code
    is_deleted
    category_id
    account_id
    account_name
    is_future
    show_client_side
    projectId
    projectName
    status
    tags
    transactionType
    uniqueTransactionId
    invoices {
      items {
        id
        tenantId
        proposalId
        quoteType
        activeFlag
        originalInvoiceId
        creditInvoiceGenerated
        archivedDate
        paidDate
        paymentStatus
        quoteName
        quoteNumber
        projectName
        projectNumber
        clientId
        contactId
        clientName
        contactName
        clientTaxType
        clientEmail
        clientAddress
        clientCountry
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        title
        invoiceNumber
        poNumber
        invoiceAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        clientNote
        isDetailed
        isClientTaxRate
        bankProfileNumber
        invoicesBankProfileName
        invoicesBank
        invoicesIban
        invoicesBic
        invoicesAccountName
        invoiceDate
        invoiceDueDate
        description
        creditComments
        invoiceType
        proposalsDraft {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
          salesAccNumberType
        }
        taxDetails {
          taxRate
          taxPercentage
          taxAmount
          taxableAmount
        }
        salesAccNumberType
        sectionDetails {
          type
          amount
        }
        sectionDetailsByQuote {
          type
          amount
        }
        sectionDetailsByAccSection {
          type
          amount
        }
        proposals {
          id
          tenantId
          activeFlag
          quoteId
          quoteType
          clientId
          contactId
          status
          noofInvoices
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientTaxType
          clientName
          contactName
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          paymentTerms
          total
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          proposalsBankProfileName
          proposalsBank
          proposalsIban
          proposalsBic
          proposalsAccountName
          createdOn
          updatedOn
          poDate
          poName
          poAmount
          poCurrency
          poNotes
          poVersion
          prevStatus
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          _deleted
          _version
          _lastChangedAt
        }
        createdOn
        updatedOn
        uniqueTransactionId
        assignedTenantId
        assignedTenantName
        showBidLetter
        companyLogo
        lastExportedDate
        emailSent
        draftEmailData {
          toEmail
          toCC
          toBCC
          subject
          body
          template
        }
        emailHistory {
          date
          subject
        }
        billitInboxItemId
        billitPeppolStatus
        billitPeppolError
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    preparePurchase {
      items {
        id
        tenantId
        activeFlag
        uniqueTransactionId
        flag
        invoiceName
        ocrInvoiceName
        fileName
        ocrFileName
        invoiceDate
        ocrInvoiceDate
        paymentDate
        ocrPaymentDate
        paymentStatus
        preparePurchasePaidDate
        supplier
        ocrSupplier
        po
        ocrPO
        costlineName
        costlineName_fr
        projectName
        totalAmount
        taxAmount
        netAmountDetails {
          netAmount
          category
          projectId
          projectName
          projectNumber
          costlineId
          costlineName
          costlineName_fr
        }
        taxAmountDetails {
          taxAmount
          vatAccount
          vatIntracom
        }
        netAmount
        ocrTotalAmount
        ocrTaxAmount
        ocrNetAmount
        currency
        ocrCurrency
        type
        status
        currentPage
        prevPage
        archivedDate
        category
        ocrCategory
        note
        ocrNote
        invoiceDocuments {
          bucket
          region
          key
          identityId
        }
        poId
        quoteId
        supplierId
        costlineId
        projectId
        ocrStatus
        vatAccount
        ocrData {
          bucket
          region
          key
          identityId
        }
        invoiceKey
        paymentMethods
        vatIntracom
        bankAccountNumber
        paymentReference
        paymentReferenceType
        bankAccountName
        supplierAccountingNumber
        supplierAccountingName
        projectNumber
        quoteNumber
        lastExportedDate
        preparePurchaseToPayDate
        fullPurchaseNumber
        bridgePaymentLinkId
        billitInboxItemId
        billitPeppolFileId
        billitSenderPeppolId
        billitImportDate
        createdOn
        updatedOn
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    miscAccNo
    _deleted
    _version
    _lastChangedAt
    createdOn
    updatedOn
  }
}
` as GeneratedMutation<
		APITypes.UpdateBankTransactionsMutationVariables,
		APITypes.UpdateBankTransactionsMutation
	>
export const deleteBankTransactions =
	/* GraphQL */ `mutation DeleteBankTransactions(
  $input: DeleteBankTransactionsInput!
  $condition: ModelBankTransactionsConditionInput
) {
  deleteBankTransactions(input: $input, condition: $condition) {
    id
    tenantId
    activeFlag
    flag
    clean_description
    bank_description
    amount
    date
    updated_at
    currency_code
    is_deleted
    category_id
    account_id
    account_name
    is_future
    show_client_side
    projectId
    projectName
    status
    tags
    transactionType
    uniqueTransactionId
    invoices {
      items {
        id
        tenantId
        proposalId
        quoteType
        activeFlag
        originalInvoiceId
        creditInvoiceGenerated
        archivedDate
        paidDate
        paymentStatus
        quoteName
        quoteNumber
        projectName
        projectNumber
        clientId
        contactId
        clientName
        contactName
        clientTaxType
        clientEmail
        clientAddress
        clientCountry
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        title
        invoiceNumber
        poNumber
        invoiceAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        clientNote
        isDetailed
        isClientTaxRate
        bankProfileNumber
        invoicesBankProfileName
        invoicesBank
        invoicesIban
        invoicesBic
        invoicesAccountName
        invoiceDate
        invoiceDueDate
        description
        creditComments
        invoiceType
        proposalsDraft {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
          salesAccNumberType
        }
        taxDetails {
          taxRate
          taxPercentage
          taxAmount
          taxableAmount
        }
        salesAccNumberType
        sectionDetails {
          type
          amount
        }
        sectionDetailsByQuote {
          type
          amount
        }
        sectionDetailsByAccSection {
          type
          amount
        }
        proposals {
          id
          tenantId
          activeFlag
          quoteId
          quoteType
          clientId
          contactId
          status
          noofInvoices
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientTaxType
          clientName
          contactName
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          paymentTerms
          total
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          proposalsBankProfileName
          proposalsBank
          proposalsIban
          proposalsBic
          proposalsAccountName
          createdOn
          updatedOn
          poDate
          poName
          poAmount
          poCurrency
          poNotes
          poVersion
          prevStatus
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          _deleted
          _version
          _lastChangedAt
        }
        createdOn
        updatedOn
        uniqueTransactionId
        assignedTenantId
        assignedTenantName
        showBidLetter
        companyLogo
        lastExportedDate
        emailSent
        draftEmailData {
          toEmail
          toCC
          toBCC
          subject
          body
          template
        }
        emailHistory {
          date
          subject
        }
        billitInboxItemId
        billitPeppolStatus
        billitPeppolError
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    preparePurchase {
      items {
        id
        tenantId
        activeFlag
        uniqueTransactionId
        flag
        invoiceName
        ocrInvoiceName
        fileName
        ocrFileName
        invoiceDate
        ocrInvoiceDate
        paymentDate
        ocrPaymentDate
        paymentStatus
        preparePurchasePaidDate
        supplier
        ocrSupplier
        po
        ocrPO
        costlineName
        costlineName_fr
        projectName
        totalAmount
        taxAmount
        netAmountDetails {
          netAmount
          category
          projectId
          projectName
          projectNumber
          costlineId
          costlineName
          costlineName_fr
        }
        taxAmountDetails {
          taxAmount
          vatAccount
          vatIntracom
        }
        netAmount
        ocrTotalAmount
        ocrTaxAmount
        ocrNetAmount
        currency
        ocrCurrency
        type
        status
        currentPage
        prevPage
        archivedDate
        category
        ocrCategory
        note
        ocrNote
        invoiceDocuments {
          bucket
          region
          key
          identityId
        }
        poId
        quoteId
        supplierId
        costlineId
        projectId
        ocrStatus
        vatAccount
        ocrData {
          bucket
          region
          key
          identityId
        }
        invoiceKey
        paymentMethods
        vatIntracom
        bankAccountNumber
        paymentReference
        paymentReferenceType
        bankAccountName
        supplierAccountingNumber
        supplierAccountingName
        projectNumber
        quoteNumber
        lastExportedDate
        preparePurchaseToPayDate
        fullPurchaseNumber
        bridgePaymentLinkId
        billitInboxItemId
        billitPeppolFileId
        billitSenderPeppolId
        billitImportDate
        createdOn
        updatedOn
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    miscAccNo
    _deleted
    _version
    _lastChangedAt
    createdOn
    updatedOn
  }
}
` as GeneratedMutation<
		APITypes.DeleteBankTransactionsMutationVariables,
		APITypes.DeleteBankTransactionsMutation
	>
export const createBillitInboxTracker =
	/* GraphQL */ `mutation CreateBillitInboxTracker(
  $input: CreateBillitInboxTrackerInput!
  $condition: ModelBillitInboxTrackerConditionInput
) {
  createBillitInboxTracker(input: $input, condition: $condition) {
    id
    tenantId
    billitInboxItemId
    billitPeppolFileId
    preparePurchaseId
    senderPeppolId
    documentType
    status
    errorMessage
    rawUblData
    responseType
    responseCode
    referencedDocumentId
    senderName
    receiverName
    statusReasonCode
    statusReason
    effectiveDate
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedMutation<
		APITypes.CreateBillitInboxTrackerMutationVariables,
		APITypes.CreateBillitInboxTrackerMutation
	>
export const updateBillitInboxTracker =
	/* GraphQL */ `mutation UpdateBillitInboxTracker(
  $input: UpdateBillitInboxTrackerInput!
  $condition: ModelBillitInboxTrackerConditionInput
) {
  updateBillitInboxTracker(input: $input, condition: $condition) {
    id
    tenantId
    billitInboxItemId
    billitPeppolFileId
    preparePurchaseId
    senderPeppolId
    documentType
    status
    errorMessage
    rawUblData
    responseType
    responseCode
    referencedDocumentId
    senderName
    receiverName
    statusReasonCode
    statusReason
    effectiveDate
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedMutation<
		APITypes.UpdateBillitInboxTrackerMutationVariables,
		APITypes.UpdateBillitInboxTrackerMutation
	>
export const deleteBillitInboxTracker =
	/* GraphQL */ `mutation DeleteBillitInboxTracker(
  $input: DeleteBillitInboxTrackerInput!
  $condition: ModelBillitInboxTrackerConditionInput
) {
  deleteBillitInboxTracker(input: $input, condition: $condition) {
    id
    tenantId
    billitInboxItemId
    billitPeppolFileId
    preparePurchaseId
    senderPeppolId
    documentType
    status
    errorMessage
    rawUblData
    responseType
    responseCode
    referencedDocumentId
    senderName
    receiverName
    statusReasonCode
    statusReason
    effectiveDate
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedMutation<
		APITypes.DeleteBillitInboxTrackerMutationVariables,
		APITypes.DeleteBillitInboxTrackerMutation
	>
export const createClients = /* GraphQL */ `mutation CreateClients(
  $input: CreateClientsInput!
  $condition: ModelClientsConditionInput
) {
  createClients(input: $input, condition: $condition) {
    id
    name
    email
    tenantId
    parentTeamId
    offlineIds
    activeFlag
    teamCount
    projects {
      items {
        id
        name
        tenantId
        freelancers
        childFreelancers
        offlineIds
        parentProjectId
        parentClientId
        activeFlag
        type
        parentTeamId
        parentSubTeamId
        isSubTeam
        projectType
        projectGroup
        parentCompanyId
        projectNumber
        subTeamCount
        createdOn
        updatedOn
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedMutation<
	APITypes.CreateClientsMutationVariables,
	APITypes.CreateClientsMutation
>
export const updateClients = /* GraphQL */ `mutation UpdateClients(
  $input: UpdateClientsInput!
  $condition: ModelClientsConditionInput
) {
  updateClients(input: $input, condition: $condition) {
    id
    name
    email
    tenantId
    parentTeamId
    offlineIds
    activeFlag
    teamCount
    projects {
      items {
        id
        name
        tenantId
        freelancers
        childFreelancers
        offlineIds
        parentProjectId
        parentClientId
        activeFlag
        type
        parentTeamId
        parentSubTeamId
        isSubTeam
        projectType
        projectGroup
        parentCompanyId
        projectNumber
        subTeamCount
        createdOn
        updatedOn
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedMutation<
	APITypes.UpdateClientsMutationVariables,
	APITypes.UpdateClientsMutation
>
export const deleteClients = /* GraphQL */ `mutation DeleteClients(
  $input: DeleteClientsInput!
  $condition: ModelClientsConditionInput
) {
  deleteClients(input: $input, condition: $condition) {
    id
    name
    email
    tenantId
    parentTeamId
    offlineIds
    activeFlag
    teamCount
    projects {
      items {
        id
        name
        tenantId
        freelancers
        childFreelancers
        offlineIds
        parentProjectId
        parentClientId
        activeFlag
        type
        parentTeamId
        parentSubTeamId
        isSubTeam
        projectType
        projectGroup
        parentCompanyId
        projectNumber
        subTeamCount
        createdOn
        updatedOn
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedMutation<
	APITypes.DeleteClientsMutationVariables,
	APITypes.DeleteClientsMutation
>
export const createComments = /* GraphQL */ `mutation CreateComments(
  $input: CreateCommentsInput!
  $condition: ModelCommentsConditionInput
) {
  createComments(input: $input, condition: $condition) {
    id
    quoteId
    activeFlag
    text
    parentId
    sectionId
    ownerEmail
    ownerSub
    status
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedMutation<
	APITypes.CreateCommentsMutationVariables,
	APITypes.CreateCommentsMutation
>
export const updateComments = /* GraphQL */ `mutation UpdateComments(
  $input: UpdateCommentsInput!
  $condition: ModelCommentsConditionInput
) {
  updateComments(input: $input, condition: $condition) {
    id
    quoteId
    activeFlag
    text
    parentId
    sectionId
    ownerEmail
    ownerSub
    status
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedMutation<
	APITypes.UpdateCommentsMutationVariables,
	APITypes.UpdateCommentsMutation
>
export const deleteComments = /* GraphQL */ `mutation DeleteComments(
  $input: DeleteCommentsInput!
  $condition: ModelCommentsConditionInput
) {
  deleteComments(input: $input, condition: $condition) {
    id
    quoteId
    activeFlag
    text
    parentId
    sectionId
    ownerEmail
    ownerSub
    status
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedMutation<
	APITypes.DeleteCommentsMutationVariables,
	APITypes.DeleteCommentsMutation
>
export const createCompany = /* GraphQL */ `mutation CreateCompany(
  $input: CreateCompanyInput!
  $condition: ModelCompanyConditionInput
) {
  createCompany(input: $input, condition: $condition) {
    id
    tenantId
    name
    email
    phone
    website
    registrationNumber
    vatNumber
    addressLine1
    addressLine2
    pdfPrimaryColor
    pdfSecondaryColor
    logoImage {
      bucket
      region
      key
      identityId
    }
    logoImage2 {
      bucket
      region
      key
      identityId
    }
    logoImage3 {
      bucket
      region
      key
      identityId
    }
    logoImage4 {
      bucket
      region
      key
      identityId
    }
    logoImageText
    logoImage2Text
    logoImage3Text
    logoImage4Text
    invoiceCount
    purchaseOrderInvoiceCount
    invoicingYear
    bank
    iban
    bic
    accountName
    bankProfileName
    bankProfileName2
    bank2
    iban2
    bic2
    accountName2
    bankProfileName3
    bank3
    iban3
    bic3
    accountName3
    bankProfileName4
    bank4
    iban4
    bic4
    accountName4
    bankProfileName5
    bank5
    iban5
    bic5
    accountName5
    accountCurrency
    country
    duplicateQuoteCounter
    exportInfo {
      exportDate
      user
    }
    companyEmailId
    createPurchaseRecap
    termsAndCondition1
    termsAndCondition2
    poTANDC1 {
      bucket
      region
      key
      identityId
    }
    soundProdTAndC1 {
      bucket
      region
      key
      identityId
    }
    soundProdTAndC2 {
      bucket
      region
      key
      identityId
    }
    editorialTAndC {
      bucket
      region
      key
      identityId
    }
    commercialTAndC {
      bucket
      region
      key
      identityId
    }
    setDesignTAndC {
      bucket
      region
      key
      identityId
    }
    wardrobeTAndC {
      bucket
      region
      key
      identityId
    }
    editorialEnglishTAndC {
      bucket
      region
      key
      identityId
    }
    commercialEnglishTAndC {
      bucket
      region
      key
      identityId
    }
    setDesignEnglishTAndC {
      bucket
      region
      key
      identityId
    }
    wardrobeEnglishTAndC {
      bucket
      region
      key
      identityId
    }
    digitalTAndC {
      bucket
      region
      key
      identityId
    }
    animationTAndC {
      bucket
      region
      key
      identityId
    }
    animationEnglishTAndC {
      bucket
      region
      key
      identityId
    }
    frenchApfpTAndC1 {
      bucket
      region
      key
      identityId
    }
    frenchApfpTAndC2 {
      bucket
      region
      key
      identityId
    }
    blankQuoteTAndC {
      bucket
      region
      key
      identityId
    }
    blankQuoteEnglishTAndC {
      bucket
      region
      key
      identityId
    }
    aicpTAndC {
      bucket
      region
      key
      identityId
    }
    purchaseTags {
      title
      color
    }
    favouriteProjects {
      id
      name
      selectedDate
    }
    teamCount
    subTeamCount
    projectCount {
      type
      count
      year
      name
    }
    projectGroupCount {
      type
      count
      year
      name
    }
    quoteCount {
      type
      count
      year
      name
    }
    quoteTemplateDetails {
      type
      quoteId
      parentTeamId
      parentSubTeamId
      quoteName
    }
    quoteAccountingCategoryAllow
    quoteAccountingCategory {
      name
    }
    quoteTertiaryCategoryAllow
    quoteTertiaryCategory {
      name
    }
    taxRateType
    salesAccNumberType
    salesAccByCostlineDetails {
      id
      EUName
      EUNumber
      InternationalName
      InternationalNumber
      LocalName
      LocalNumber
    }
    salesAccQuoteTypeDetails {
      type
      EUName
      EUNumber
      InternationalName
      InternationalNumber
      LocalName
      LocalNumber
    }
    aicpEUName
    aicpEUNumber
    aicpInternationalName
    aicpInternationalNumber
    aicpLocalName
    aicpLocalNumber
    apfpEUName
    apfpEUNumber
    apfpInternationalName
    apfpInternationalNumber
    apfpLocalName
    apfpLocalNumber
    photoEUName
    photoEUNumber
    photoInternationalName
    photoInternationalNumber
    photoLocalName
    photoLocalNumber
    postProdEUName
    postProdEUNumber
    postProdInternationalName
    postProdInternationalNumber
    postProdLocalName
    postProdLocalNumber
    vat20
    vat10
    specialEnglishInvoiceNote
    specialFrenchInvoiceNote
    costCategoriesFields {
      id
      name
    }
    costVatFields {
      number
      name
      text
    }
    miscAccNosFields {
      name
      number
      text
    }
    clientsSubAcc
    suppliersSubAcc
    userBridgeApiLoginDetails {
      uuid
      email
    }
    userBankingAutehticationDetails {
      access_token
      expires_at
      user {
        uuid
        email
      }
    }
    isLoggedIntoBanking
    lastUpdatedTransactionDate
    vatIntracom {
      type
      debitNumber
      debitName
      creditNumber
      creditName
    }
    sendCostlinesToReviewPage
    sendOverheadsToReviewPage
    activateDeliveryDate
    defaultProjectType
    paymentTerms
    localOtNumberOfHours
    exeOtNumberOfHours
    projectNumberCustomisation {
      seperator
      first
      second
      third
    }
    useOneProjectNumber
    commonProjectNumber
    individualSuppliersSubAcc
    clientsSalesAccountNumber
    suppliersCostAccountNumber
    quoteNumberCustomisation {
      seperator
      first
      second
      third
    }
    useOneQuoteNumber
    commonQuoteNumber
    commonProjectGroupFlag
    commonProjectGroup
    restrictProjectGroup
    salesLedgerName
    purchasesLedgerName
    ledgerNames {
      bankProfileName
      bridgeBankAccountId
      number
      name
      label
    }
    quoteJsonDetails {
      name
      quoteType
      categories {
        Bucket
        Key
        identityId
      }
      subcategories {
        Bucket
        Key
        identityId
      }
      costline {
        Bucket
        Key
        identityId
      }
    }
    purchaseCount
    invoiceNumberPrefix
    poNumberPrefix
    emailTemplateArray {
      id
      language
      name
      subject
      body
    }
    billitPartyId
    billitApiKey
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedMutation<
	APITypes.CreateCompanyMutationVariables,
	APITypes.CreateCompanyMutation
>
export const updateCompany = /* GraphQL */ `mutation UpdateCompany(
  $input: UpdateCompanyInput!
  $condition: ModelCompanyConditionInput
) {
  updateCompany(input: $input, condition: $condition) {
    id
    tenantId
    name
    email
    phone
    website
    registrationNumber
    vatNumber
    addressLine1
    addressLine2
    pdfPrimaryColor
    pdfSecondaryColor
    logoImage {
      bucket
      region
      key
      identityId
    }
    logoImage2 {
      bucket
      region
      key
      identityId
    }
    logoImage3 {
      bucket
      region
      key
      identityId
    }
    logoImage4 {
      bucket
      region
      key
      identityId
    }
    logoImageText
    logoImage2Text
    logoImage3Text
    logoImage4Text
    invoiceCount
    purchaseOrderInvoiceCount
    invoicingYear
    bank
    iban
    bic
    accountName
    bankProfileName
    bankProfileName2
    bank2
    iban2
    bic2
    accountName2
    bankProfileName3
    bank3
    iban3
    bic3
    accountName3
    bankProfileName4
    bank4
    iban4
    bic4
    accountName4
    bankProfileName5
    bank5
    iban5
    bic5
    accountName5
    accountCurrency
    country
    duplicateQuoteCounter
    exportInfo {
      exportDate
      user
    }
    companyEmailId
    createPurchaseRecap
    termsAndCondition1
    termsAndCondition2
    poTANDC1 {
      bucket
      region
      key
      identityId
    }
    soundProdTAndC1 {
      bucket
      region
      key
      identityId
    }
    soundProdTAndC2 {
      bucket
      region
      key
      identityId
    }
    editorialTAndC {
      bucket
      region
      key
      identityId
    }
    commercialTAndC {
      bucket
      region
      key
      identityId
    }
    setDesignTAndC {
      bucket
      region
      key
      identityId
    }
    wardrobeTAndC {
      bucket
      region
      key
      identityId
    }
    editorialEnglishTAndC {
      bucket
      region
      key
      identityId
    }
    commercialEnglishTAndC {
      bucket
      region
      key
      identityId
    }
    setDesignEnglishTAndC {
      bucket
      region
      key
      identityId
    }
    wardrobeEnglishTAndC {
      bucket
      region
      key
      identityId
    }
    digitalTAndC {
      bucket
      region
      key
      identityId
    }
    animationTAndC {
      bucket
      region
      key
      identityId
    }
    animationEnglishTAndC {
      bucket
      region
      key
      identityId
    }
    frenchApfpTAndC1 {
      bucket
      region
      key
      identityId
    }
    frenchApfpTAndC2 {
      bucket
      region
      key
      identityId
    }
    blankQuoteTAndC {
      bucket
      region
      key
      identityId
    }
    blankQuoteEnglishTAndC {
      bucket
      region
      key
      identityId
    }
    aicpTAndC {
      bucket
      region
      key
      identityId
    }
    purchaseTags {
      title
      color
    }
    favouriteProjects {
      id
      name
      selectedDate
    }
    teamCount
    subTeamCount
    projectCount {
      type
      count
      year
      name
    }
    projectGroupCount {
      type
      count
      year
      name
    }
    quoteCount {
      type
      count
      year
      name
    }
    quoteTemplateDetails {
      type
      quoteId
      parentTeamId
      parentSubTeamId
      quoteName
    }
    quoteAccountingCategoryAllow
    quoteAccountingCategory {
      name
    }
    quoteTertiaryCategoryAllow
    quoteTertiaryCategory {
      name
    }
    taxRateType
    salesAccNumberType
    salesAccByCostlineDetails {
      id
      EUName
      EUNumber
      InternationalName
      InternationalNumber
      LocalName
      LocalNumber
    }
    salesAccQuoteTypeDetails {
      type
      EUName
      EUNumber
      InternationalName
      InternationalNumber
      LocalName
      LocalNumber
    }
    aicpEUName
    aicpEUNumber
    aicpInternationalName
    aicpInternationalNumber
    aicpLocalName
    aicpLocalNumber
    apfpEUName
    apfpEUNumber
    apfpInternationalName
    apfpInternationalNumber
    apfpLocalName
    apfpLocalNumber
    photoEUName
    photoEUNumber
    photoInternationalName
    photoInternationalNumber
    photoLocalName
    photoLocalNumber
    postProdEUName
    postProdEUNumber
    postProdInternationalName
    postProdInternationalNumber
    postProdLocalName
    postProdLocalNumber
    vat20
    vat10
    specialEnglishInvoiceNote
    specialFrenchInvoiceNote
    costCategoriesFields {
      id
      name
    }
    costVatFields {
      number
      name
      text
    }
    miscAccNosFields {
      name
      number
      text
    }
    clientsSubAcc
    suppliersSubAcc
    userBridgeApiLoginDetails {
      uuid
      email
    }
    userBankingAutehticationDetails {
      access_token
      expires_at
      user {
        uuid
        email
      }
    }
    isLoggedIntoBanking
    lastUpdatedTransactionDate
    vatIntracom {
      type
      debitNumber
      debitName
      creditNumber
      creditName
    }
    sendCostlinesToReviewPage
    sendOverheadsToReviewPage
    activateDeliveryDate
    defaultProjectType
    paymentTerms
    localOtNumberOfHours
    exeOtNumberOfHours
    projectNumberCustomisation {
      seperator
      first
      second
      third
    }
    useOneProjectNumber
    commonProjectNumber
    individualSuppliersSubAcc
    clientsSalesAccountNumber
    suppliersCostAccountNumber
    quoteNumberCustomisation {
      seperator
      first
      second
      third
    }
    useOneQuoteNumber
    commonQuoteNumber
    commonProjectGroupFlag
    commonProjectGroup
    restrictProjectGroup
    salesLedgerName
    purchasesLedgerName
    ledgerNames {
      bankProfileName
      bridgeBankAccountId
      number
      name
      label
    }
    quoteJsonDetails {
      name
      quoteType
      categories {
        Bucket
        Key
        identityId
      }
      subcategories {
        Bucket
        Key
        identityId
      }
      costline {
        Bucket
        Key
        identityId
      }
    }
    purchaseCount
    invoiceNumberPrefix
    poNumberPrefix
    emailTemplateArray {
      id
      language
      name
      subject
      body
    }
    billitPartyId
    billitApiKey
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedMutation<
	APITypes.UpdateCompanyMutationVariables,
	APITypes.UpdateCompanyMutation
>
export const deleteCompany = /* GraphQL */ `mutation DeleteCompany(
  $input: DeleteCompanyInput!
  $condition: ModelCompanyConditionInput
) {
  deleteCompany(input: $input, condition: $condition) {
    id
    tenantId
    name
    email
    phone
    website
    registrationNumber
    vatNumber
    addressLine1
    addressLine2
    pdfPrimaryColor
    pdfSecondaryColor
    logoImage {
      bucket
      region
      key
      identityId
    }
    logoImage2 {
      bucket
      region
      key
      identityId
    }
    logoImage3 {
      bucket
      region
      key
      identityId
    }
    logoImage4 {
      bucket
      region
      key
      identityId
    }
    logoImageText
    logoImage2Text
    logoImage3Text
    logoImage4Text
    invoiceCount
    purchaseOrderInvoiceCount
    invoicingYear
    bank
    iban
    bic
    accountName
    bankProfileName
    bankProfileName2
    bank2
    iban2
    bic2
    accountName2
    bankProfileName3
    bank3
    iban3
    bic3
    accountName3
    bankProfileName4
    bank4
    iban4
    bic4
    accountName4
    bankProfileName5
    bank5
    iban5
    bic5
    accountName5
    accountCurrency
    country
    duplicateQuoteCounter
    exportInfo {
      exportDate
      user
    }
    companyEmailId
    createPurchaseRecap
    termsAndCondition1
    termsAndCondition2
    poTANDC1 {
      bucket
      region
      key
      identityId
    }
    soundProdTAndC1 {
      bucket
      region
      key
      identityId
    }
    soundProdTAndC2 {
      bucket
      region
      key
      identityId
    }
    editorialTAndC {
      bucket
      region
      key
      identityId
    }
    commercialTAndC {
      bucket
      region
      key
      identityId
    }
    setDesignTAndC {
      bucket
      region
      key
      identityId
    }
    wardrobeTAndC {
      bucket
      region
      key
      identityId
    }
    editorialEnglishTAndC {
      bucket
      region
      key
      identityId
    }
    commercialEnglishTAndC {
      bucket
      region
      key
      identityId
    }
    setDesignEnglishTAndC {
      bucket
      region
      key
      identityId
    }
    wardrobeEnglishTAndC {
      bucket
      region
      key
      identityId
    }
    digitalTAndC {
      bucket
      region
      key
      identityId
    }
    animationTAndC {
      bucket
      region
      key
      identityId
    }
    animationEnglishTAndC {
      bucket
      region
      key
      identityId
    }
    frenchApfpTAndC1 {
      bucket
      region
      key
      identityId
    }
    frenchApfpTAndC2 {
      bucket
      region
      key
      identityId
    }
    blankQuoteTAndC {
      bucket
      region
      key
      identityId
    }
    blankQuoteEnglishTAndC {
      bucket
      region
      key
      identityId
    }
    aicpTAndC {
      bucket
      region
      key
      identityId
    }
    purchaseTags {
      title
      color
    }
    favouriteProjects {
      id
      name
      selectedDate
    }
    teamCount
    subTeamCount
    projectCount {
      type
      count
      year
      name
    }
    projectGroupCount {
      type
      count
      year
      name
    }
    quoteCount {
      type
      count
      year
      name
    }
    quoteTemplateDetails {
      type
      quoteId
      parentTeamId
      parentSubTeamId
      quoteName
    }
    quoteAccountingCategoryAllow
    quoteAccountingCategory {
      name
    }
    quoteTertiaryCategoryAllow
    quoteTertiaryCategory {
      name
    }
    taxRateType
    salesAccNumberType
    salesAccByCostlineDetails {
      id
      EUName
      EUNumber
      InternationalName
      InternationalNumber
      LocalName
      LocalNumber
    }
    salesAccQuoteTypeDetails {
      type
      EUName
      EUNumber
      InternationalName
      InternationalNumber
      LocalName
      LocalNumber
    }
    aicpEUName
    aicpEUNumber
    aicpInternationalName
    aicpInternationalNumber
    aicpLocalName
    aicpLocalNumber
    apfpEUName
    apfpEUNumber
    apfpInternationalName
    apfpInternationalNumber
    apfpLocalName
    apfpLocalNumber
    photoEUName
    photoEUNumber
    photoInternationalName
    photoInternationalNumber
    photoLocalName
    photoLocalNumber
    postProdEUName
    postProdEUNumber
    postProdInternationalName
    postProdInternationalNumber
    postProdLocalName
    postProdLocalNumber
    vat20
    vat10
    specialEnglishInvoiceNote
    specialFrenchInvoiceNote
    costCategoriesFields {
      id
      name
    }
    costVatFields {
      number
      name
      text
    }
    miscAccNosFields {
      name
      number
      text
    }
    clientsSubAcc
    suppliersSubAcc
    userBridgeApiLoginDetails {
      uuid
      email
    }
    userBankingAutehticationDetails {
      access_token
      expires_at
      user {
        uuid
        email
      }
    }
    isLoggedIntoBanking
    lastUpdatedTransactionDate
    vatIntracom {
      type
      debitNumber
      debitName
      creditNumber
      creditName
    }
    sendCostlinesToReviewPage
    sendOverheadsToReviewPage
    activateDeliveryDate
    defaultProjectType
    paymentTerms
    localOtNumberOfHours
    exeOtNumberOfHours
    projectNumberCustomisation {
      seperator
      first
      second
      third
    }
    useOneProjectNumber
    commonProjectNumber
    individualSuppliersSubAcc
    clientsSalesAccountNumber
    suppliersCostAccountNumber
    quoteNumberCustomisation {
      seperator
      first
      second
      third
    }
    useOneQuoteNumber
    commonQuoteNumber
    commonProjectGroupFlag
    commonProjectGroup
    restrictProjectGroup
    salesLedgerName
    purchasesLedgerName
    ledgerNames {
      bankProfileName
      bridgeBankAccountId
      number
      name
      label
    }
    quoteJsonDetails {
      name
      quoteType
      categories {
        Bucket
        Key
        identityId
      }
      subcategories {
        Bucket
        Key
        identityId
      }
      costline {
        Bucket
        Key
        identityId
      }
    }
    purchaseCount
    invoiceNumberPrefix
    poNumberPrefix
    emailTemplateArray {
      id
      language
      name
      subject
      body
    }
    billitPartyId
    billitApiKey
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedMutation<
	APITypes.DeleteCompanyMutationVariables,
	APITypes.DeleteCompanyMutation
>
export const createCompanyQuoteTemplate =
	/* GraphQL */ `mutation CreateCompanyQuoteTemplate(
  $input: CreateCompanyQuoteTemplateInput!
  $condition: ModelCompanyQuoteTemplateConditionInput
) {
  createCompanyQuoteTemplate(input: $input, condition: $condition) {
    id
    tenantId
    quoteId
    teamIds
    subTeamIds
    name
    quoteType
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedMutation<
		APITypes.CreateCompanyQuoteTemplateMutationVariables,
		APITypes.CreateCompanyQuoteTemplateMutation
	>
export const updateCompanyQuoteTemplate =
	/* GraphQL */ `mutation UpdateCompanyQuoteTemplate(
  $input: UpdateCompanyQuoteTemplateInput!
  $condition: ModelCompanyQuoteTemplateConditionInput
) {
  updateCompanyQuoteTemplate(input: $input, condition: $condition) {
    id
    tenantId
    quoteId
    teamIds
    subTeamIds
    name
    quoteType
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedMutation<
		APITypes.UpdateCompanyQuoteTemplateMutationVariables,
		APITypes.UpdateCompanyQuoteTemplateMutation
	>
export const deleteCompanyQuoteTemplate =
	/* GraphQL */ `mutation DeleteCompanyQuoteTemplate(
  $input: DeleteCompanyQuoteTemplateInput!
  $condition: ModelCompanyQuoteTemplateConditionInput
) {
  deleteCompanyQuoteTemplate(input: $input, condition: $condition) {
    id
    tenantId
    quoteId
    teamIds
    subTeamIds
    name
    quoteType
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedMutation<
		APITypes.DeleteCompanyQuoteTemplateMutationVariables,
		APITypes.DeleteCompanyQuoteTemplateMutation
	>
export const createContact = /* GraphQL */ `mutation CreateContact(
  $input: CreateContactInput!
  $condition: ModelContactConditionInput
) {
  createContact(input: $input, condition: $condition) {
    id
    tenantId
    activeFlag
    name
    idnumber
    vatNumber
    website
    phone
    firstName
    lastName
    email
    contactPhone
    contactDetails {
      id
      fullName
      email
      phone
    }
    line01
    line02
    city
    state
    postalCode
    country
    currency
    paymentTerms
    taxType
    taxRate
    thirdPartyAccounts
    note
    bank
    iban
    bic
    accountName
    clientSubAccount
    invoices {
      items {
        id
        tenantId
        proposalId
        quoteType
        activeFlag
        originalInvoiceId
        creditInvoiceGenerated
        archivedDate
        paidDate
        paymentStatus
        quoteName
        quoteNumber
        projectName
        projectNumber
        clientId
        contactId
        clientName
        contactName
        clientTaxType
        clientEmail
        clientAddress
        clientCountry
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        title
        invoiceNumber
        poNumber
        invoiceAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        clientNote
        isDetailed
        isClientTaxRate
        bankProfileNumber
        invoicesBankProfileName
        invoicesBank
        invoicesIban
        invoicesBic
        invoicesAccountName
        invoiceDate
        invoiceDueDate
        description
        creditComments
        invoiceType
        proposalsDraft {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
          salesAccNumberType
        }
        taxDetails {
          taxRate
          taxPercentage
          taxAmount
          taxableAmount
        }
        salesAccNumberType
        sectionDetails {
          type
          amount
        }
        sectionDetailsByQuote {
          type
          amount
        }
        sectionDetailsByAccSection {
          type
          amount
        }
        proposals {
          id
          tenantId
          activeFlag
          quoteId
          quoteType
          clientId
          contactId
          status
          noofInvoices
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientTaxType
          clientName
          contactName
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          paymentTerms
          total
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          proposalsBankProfileName
          proposalsBank
          proposalsIban
          proposalsBic
          proposalsAccountName
          createdOn
          updatedOn
          poDate
          poName
          poAmount
          poCurrency
          poNotes
          poVersion
          prevStatus
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          _deleted
          _version
          _lastChangedAt
        }
        createdOn
        updatedOn
        uniqueTransactionId
        assignedTenantId
        assignedTenantName
        showBidLetter
        companyLogo
        lastExportedDate
        emailSent
        draftEmailData {
          toEmail
          toCC
          toBCC
          subject
          body
          template
        }
        emailHistory {
          date
          subject
        }
        billitInboxItemId
        billitPeppolStatus
        billitPeppolError
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    _deleted
    _version
    _lastChangedAt
    createdOn
    updatedOn
  }
}
` as GeneratedMutation<
	APITypes.CreateContactMutationVariables,
	APITypes.CreateContactMutation
>
export const updateContact = /* GraphQL */ `mutation UpdateContact(
  $input: UpdateContactInput!
  $condition: ModelContactConditionInput
) {
  updateContact(input: $input, condition: $condition) {
    id
    tenantId
    activeFlag
    name
    idnumber
    vatNumber
    website
    phone
    firstName
    lastName
    email
    contactPhone
    contactDetails {
      id
      fullName
      email
      phone
    }
    line01
    line02
    city
    state
    postalCode
    country
    currency
    paymentTerms
    taxType
    taxRate
    thirdPartyAccounts
    note
    bank
    iban
    bic
    accountName
    clientSubAccount
    invoices {
      items {
        id
        tenantId
        proposalId
        quoteType
        activeFlag
        originalInvoiceId
        creditInvoiceGenerated
        archivedDate
        paidDate
        paymentStatus
        quoteName
        quoteNumber
        projectName
        projectNumber
        clientId
        contactId
        clientName
        contactName
        clientTaxType
        clientEmail
        clientAddress
        clientCountry
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        title
        invoiceNumber
        poNumber
        invoiceAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        clientNote
        isDetailed
        isClientTaxRate
        bankProfileNumber
        invoicesBankProfileName
        invoicesBank
        invoicesIban
        invoicesBic
        invoicesAccountName
        invoiceDate
        invoiceDueDate
        description
        creditComments
        invoiceType
        proposalsDraft {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
          salesAccNumberType
        }
        taxDetails {
          taxRate
          taxPercentage
          taxAmount
          taxableAmount
        }
        salesAccNumberType
        sectionDetails {
          type
          amount
        }
        sectionDetailsByQuote {
          type
          amount
        }
        sectionDetailsByAccSection {
          type
          amount
        }
        proposals {
          id
          tenantId
          activeFlag
          quoteId
          quoteType
          clientId
          contactId
          status
          noofInvoices
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientTaxType
          clientName
          contactName
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          paymentTerms
          total
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          proposalsBankProfileName
          proposalsBank
          proposalsIban
          proposalsBic
          proposalsAccountName
          createdOn
          updatedOn
          poDate
          poName
          poAmount
          poCurrency
          poNotes
          poVersion
          prevStatus
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          _deleted
          _version
          _lastChangedAt
        }
        createdOn
        updatedOn
        uniqueTransactionId
        assignedTenantId
        assignedTenantName
        showBidLetter
        companyLogo
        lastExportedDate
        emailSent
        draftEmailData {
          toEmail
          toCC
          toBCC
          subject
          body
          template
        }
        emailHistory {
          date
          subject
        }
        billitInboxItemId
        billitPeppolStatus
        billitPeppolError
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    _deleted
    _version
    _lastChangedAt
    createdOn
    updatedOn
  }
}
` as GeneratedMutation<
	APITypes.UpdateContactMutationVariables,
	APITypes.UpdateContactMutation
>
export const deleteContact = /* GraphQL */ `mutation DeleteContact(
  $input: DeleteContactInput!
  $condition: ModelContactConditionInput
) {
  deleteContact(input: $input, condition: $condition) {
    id
    tenantId
    activeFlag
    name
    idnumber
    vatNumber
    website
    phone
    firstName
    lastName
    email
    contactPhone
    contactDetails {
      id
      fullName
      email
      phone
    }
    line01
    line02
    city
    state
    postalCode
    country
    currency
    paymentTerms
    taxType
    taxRate
    thirdPartyAccounts
    note
    bank
    iban
    bic
    accountName
    clientSubAccount
    invoices {
      items {
        id
        tenantId
        proposalId
        quoteType
        activeFlag
        originalInvoiceId
        creditInvoiceGenerated
        archivedDate
        paidDate
        paymentStatus
        quoteName
        quoteNumber
        projectName
        projectNumber
        clientId
        contactId
        clientName
        contactName
        clientTaxType
        clientEmail
        clientAddress
        clientCountry
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        title
        invoiceNumber
        poNumber
        invoiceAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        clientNote
        isDetailed
        isClientTaxRate
        bankProfileNumber
        invoicesBankProfileName
        invoicesBank
        invoicesIban
        invoicesBic
        invoicesAccountName
        invoiceDate
        invoiceDueDate
        description
        creditComments
        invoiceType
        proposalsDraft {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
          salesAccNumberType
        }
        taxDetails {
          taxRate
          taxPercentage
          taxAmount
          taxableAmount
        }
        salesAccNumberType
        sectionDetails {
          type
          amount
        }
        sectionDetailsByQuote {
          type
          amount
        }
        sectionDetailsByAccSection {
          type
          amount
        }
        proposals {
          id
          tenantId
          activeFlag
          quoteId
          quoteType
          clientId
          contactId
          status
          noofInvoices
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientTaxType
          clientName
          contactName
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          paymentTerms
          total
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          proposalsBankProfileName
          proposalsBank
          proposalsIban
          proposalsBic
          proposalsAccountName
          createdOn
          updatedOn
          poDate
          poName
          poAmount
          poCurrency
          poNotes
          poVersion
          prevStatus
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          _deleted
          _version
          _lastChangedAt
        }
        createdOn
        updatedOn
        uniqueTransactionId
        assignedTenantId
        assignedTenantName
        showBidLetter
        companyLogo
        lastExportedDate
        emailSent
        draftEmailData {
          toEmail
          toCC
          toBCC
          subject
          body
          template
        }
        emailHistory {
          date
          subject
        }
        billitInboxItemId
        billitPeppolStatus
        billitPeppolError
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    _deleted
    _version
    _lastChangedAt
    createdOn
    updatedOn
  }
}
` as GeneratedMutation<
	APITypes.DeleteContactMutationVariables,
	APITypes.DeleteContactMutation
>
export const createCurrencyRate = /* GraphQL */ `mutation CreateCurrencyRate(
  $input: CreateCurrencyRateInput!
  $condition: ModelCurrencyRateConditionInput
) {
  createCurrencyRate(input: $input, condition: $condition) {
    id
    tenantId
    activeFlag
    base
    date
    rates {
      currencyName
      currencyRate
    }
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedMutation<
	APITypes.CreateCurrencyRateMutationVariables,
	APITypes.CreateCurrencyRateMutation
>
export const updateCurrencyRate = /* GraphQL */ `mutation UpdateCurrencyRate(
  $input: UpdateCurrencyRateInput!
  $condition: ModelCurrencyRateConditionInput
) {
  updateCurrencyRate(input: $input, condition: $condition) {
    id
    tenantId
    activeFlag
    base
    date
    rates {
      currencyName
      currencyRate
    }
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedMutation<
	APITypes.UpdateCurrencyRateMutationVariables,
	APITypes.UpdateCurrencyRateMutation
>
export const deleteCurrencyRate = /* GraphQL */ `mutation DeleteCurrencyRate(
  $input: DeleteCurrencyRateInput!
  $condition: ModelCurrencyRateConditionInput
) {
  deleteCurrencyRate(input: $input, condition: $condition) {
    id
    tenantId
    activeFlag
    base
    date
    rates {
      currencyName
      currencyRate
    }
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedMutation<
	APITypes.DeleteCurrencyRateMutationVariables,
	APITypes.DeleteCurrencyRateMutation
>
export const createExportInfo = /* GraphQL */ `mutation CreateExportInfo(
  $input: CreateExportInfoInput!
  $condition: ModelExportInfoConditionInput
) {
  createExportInfo(input: $input, condition: $condition) {
    id
    tenantId
    activeFlag
    name
    exportDate
    exportType
    loggedLineId
    _deleted
    _version
    _lastChangedAt
    createdOn
    updatedOn
  }
}
` as GeneratedMutation<
	APITypes.CreateExportInfoMutationVariables,
	APITypes.CreateExportInfoMutation
>
export const updateExportInfo = /* GraphQL */ `mutation UpdateExportInfo(
  $input: UpdateExportInfoInput!
  $condition: ModelExportInfoConditionInput
) {
  updateExportInfo(input: $input, condition: $condition) {
    id
    tenantId
    activeFlag
    name
    exportDate
    exportType
    loggedLineId
    _deleted
    _version
    _lastChangedAt
    createdOn
    updatedOn
  }
}
` as GeneratedMutation<
	APITypes.UpdateExportInfoMutationVariables,
	APITypes.UpdateExportInfoMutation
>
export const deleteExportInfo = /* GraphQL */ `mutation DeleteExportInfo(
  $input: DeleteExportInfoInput!
  $condition: ModelExportInfoConditionInput
) {
  deleteExportInfo(input: $input, condition: $condition) {
    id
    tenantId
    activeFlag
    name
    exportDate
    exportType
    loggedLineId
    _deleted
    _version
    _lastChangedAt
    createdOn
    updatedOn
  }
}
` as GeneratedMutation<
	APITypes.DeleteExportInfoMutationVariables,
	APITypes.DeleteExportInfoMutation
>
export const createFilledCostlines =
	/* GraphQL */ `mutation CreateFilledCostlines(
  $input: CreateFilledCostlinesInput!
  $condition: ModelFilledCostlinesConditionInput
) {
  createFilledCostlines(input: $input, condition: $condition) {
    id
    tenantId
    quoteId
    item
    item_fr
    quantity
    number
    shootNumber
    rate
    rateInEuros
    total
    overheadPercentage
    marginPercentage
    costlineUuid
    costLineType
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedMutation<
		APITypes.CreateFilledCostlinesMutationVariables,
		APITypes.CreateFilledCostlinesMutation
	>
export const updateFilledCostlines =
	/* GraphQL */ `mutation UpdateFilledCostlines(
  $input: UpdateFilledCostlinesInput!
  $condition: ModelFilledCostlinesConditionInput
) {
  updateFilledCostlines(input: $input, condition: $condition) {
    id
    tenantId
    quoteId
    item
    item_fr
    quantity
    number
    shootNumber
    rate
    rateInEuros
    total
    overheadPercentage
    marginPercentage
    costlineUuid
    costLineType
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedMutation<
		APITypes.UpdateFilledCostlinesMutationVariables,
		APITypes.UpdateFilledCostlinesMutation
	>
export const deleteFilledCostlines =
	/* GraphQL */ `mutation DeleteFilledCostlines(
  $input: DeleteFilledCostlinesInput!
  $condition: ModelFilledCostlinesConditionInput
) {
  deleteFilledCostlines(input: $input, condition: $condition) {
    id
    tenantId
    quoteId
    item
    item_fr
    quantity
    number
    shootNumber
    rate
    rateInEuros
    total
    overheadPercentage
    marginPercentage
    costlineUuid
    costLineType
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedMutation<
		APITypes.DeleteFilledCostlinesMutationVariables,
		APITypes.DeleteFilledCostlinesMutation
	>
export const createFreelancerBilling =
	/* GraphQL */ `mutation CreateFreelancerBilling(
  $input: CreateFreelancerBillingInput!
  $condition: ModelFreelancerBillingConditionInput
) {
  createFreelancerBilling(input: $input, condition: $condition) {
    id
    tenantId
    projectId
    freelancerId
    projectFreelancerKey
    stripeInvoiceId
    stripeLineItemId
    stripeRefundId
    stripePriceId
    stripePriceAmount
    status
    chargedAt
    chargeScheduledAt
    chargeSchedulerName
    refundEligibleUntil
    refundedAt
    stripeCreditNoteId
    activeFlag
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedMutation<
		APITypes.CreateFreelancerBillingMutationVariables,
		APITypes.CreateFreelancerBillingMutation
	>
export const updateFreelancerBilling =
	/* GraphQL */ `mutation UpdateFreelancerBilling(
  $input: UpdateFreelancerBillingInput!
  $condition: ModelFreelancerBillingConditionInput
) {
  updateFreelancerBilling(input: $input, condition: $condition) {
    id
    tenantId
    projectId
    freelancerId
    projectFreelancerKey
    stripeInvoiceId
    stripeLineItemId
    stripeRefundId
    stripePriceId
    stripePriceAmount
    status
    chargedAt
    chargeScheduledAt
    chargeSchedulerName
    refundEligibleUntil
    refundedAt
    stripeCreditNoteId
    activeFlag
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedMutation<
		APITypes.UpdateFreelancerBillingMutationVariables,
		APITypes.UpdateFreelancerBillingMutation
	>
export const deleteFreelancerBilling =
	/* GraphQL */ `mutation DeleteFreelancerBilling(
  $input: DeleteFreelancerBillingInput!
  $condition: ModelFreelancerBillingConditionInput
) {
  deleteFreelancerBilling(input: $input, condition: $condition) {
    id
    tenantId
    projectId
    freelancerId
    projectFreelancerKey
    stripeInvoiceId
    stripeLineItemId
    stripeRefundId
    stripePriceId
    stripePriceAmount
    status
    chargedAt
    chargeScheduledAt
    chargeSchedulerName
    refundEligibleUntil
    refundedAt
    stripeCreditNoteId
    activeFlag
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedMutation<
		APITypes.DeleteFreelancerBillingMutationVariables,
		APITypes.DeleteFreelancerBillingMutation
	>
export const createFreelancers = /* GraphQL */ `mutation CreateFreelancers(
  $input: CreateFreelancersInput!
  $condition: ModelFreelancersConditionInput
) {
  createFreelancers(input: $input, condition: $condition) {
    id
    email
    name
    freelancerTenantId
    companyTenantId
    currentCompanyTenantId
    currentCompanyName
    profileImage {
      bucket
      region
      key
      identityId
    }
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedMutation<
	APITypes.CreateFreelancersMutationVariables,
	APITypes.CreateFreelancersMutation
>
export const updateFreelancers = /* GraphQL */ `mutation UpdateFreelancers(
  $input: UpdateFreelancersInput!
  $condition: ModelFreelancersConditionInput
) {
  updateFreelancers(input: $input, condition: $condition) {
    id
    email
    name
    freelancerTenantId
    companyTenantId
    currentCompanyTenantId
    currentCompanyName
    profileImage {
      bucket
      region
      key
      identityId
    }
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedMutation<
	APITypes.UpdateFreelancersMutationVariables,
	APITypes.UpdateFreelancersMutation
>
export const deleteFreelancers = /* GraphQL */ `mutation DeleteFreelancers(
  $input: DeleteFreelancersInput!
  $condition: ModelFreelancersConditionInput
) {
  deleteFreelancers(input: $input, condition: $condition) {
    id
    email
    name
    freelancerTenantId
    companyTenantId
    currentCompanyTenantId
    currentCompanyName
    profileImage {
      bucket
      region
      key
      identityId
    }
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedMutation<
	APITypes.DeleteFreelancersMutationVariables,
	APITypes.DeleteFreelancersMutation
>
export const createInvoices = /* GraphQL */ `mutation CreateInvoices(
  $input: CreateInvoicesInput!
  $condition: ModelInvoicesConditionInput
) {
  createInvoices(input: $input, condition: $condition) {
    id
    tenantId
    proposalId
    quoteType
    activeFlag
    originalInvoiceId
    creditInvoiceGenerated
    archivedDate
    paidDate
    paymentStatus
    quoteName
    quoteNumber
    projectName
    projectNumber
    clientId
    contactId
    clientName
    contactName
    clientTaxType
    clientEmail
    clientAddress
    clientCountry
    clientIdNumber
    clientVatNumber
    clientCurrency
    clientTaxRate
    title
    invoiceNumber
    poNumber
    invoiceAmountPercentage
    amount
    amountAfterTax
    taxAmount
    balancePercentage
    balanceAmount
    clientNote
    isDetailed
    isClientTaxRate
    bankProfileNumber
    invoicesBankProfileName
    invoicesBank
    invoicesIban
    invoicesBic
    invoicesAccountName
    invoiceDate
    invoiceDueDate
    description
    creditComments
    invoiceType
    proposalsDraft {
      generated
      poNumber
      proposalAmountPercentage
      amount
      amountAfterTax
      taxAmount
      balancePercentage
      balanceAmount
      invoiceId
      invoiceDate
      invoiceDueDate
      description
      readyStatus
      taxDetails {
        taxRate
        taxPercentage
        taxAmount
        taxableAmount
      }
      salesAccNumberType
      sectionDetails {
        type
        amount
      }
      sectionDetailsByQuote {
        type
        amount
      }
      sectionDetailsByAccSection {
        type
        amount
      }
    }
    taxDetails {
      taxRate
      taxPercentage
      taxAmount
      taxableAmount
    }
    salesAccNumberType
    sectionDetails {
      type
      amount
    }
    sectionDetailsByQuote {
      type
      amount
    }
    sectionDetailsByAccSection {
      type
      amount
    }
    proposals {
      id
      tenantId
      activeFlag
      quoteId
      quoteType
      clientId
      contactId
      status
      noofInvoices
      quoteName
      quoteNumber
      projectName
      projectNumber
      clientTaxType
      clientName
      contactName
      clientEmail
      clientAddress
      clientCountry
      clientIdNumber
      clientVatNumber
      clientCurrency
      clientTaxRate
      paymentTerms
      total
      clientNote
      isDetailed
      isClientTaxRate
      bankProfileNumber
      proposalsBankProfileName
      proposalsBank
      proposalsIban
      proposalsBic
      proposalsAccountName
      drafts {
        generated
        poNumber
        proposalAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        invoiceId
        invoiceDate
        invoiceDueDate
        description
        readyStatus
        taxDetails {
          taxRate
          taxPercentage
          taxAmount
          taxableAmount
        }
        salesAccNumberType
        sectionDetails {
          type
          amount
        }
        sectionDetailsByQuote {
          type
          amount
        }
        sectionDetailsByAccSection {
          type
          amount
        }
      }
      quote {
        id
        name
        tenantId
        quoteType
        quoteVersion
        aiGenerationRunId
        aiGenerationStatus
        aiGenerationError
        aiGenerationStartedAt
        aiGenerationCompletedAt
        aiGeneratedByUserId
        blankQuoteType
        parentTeamId
        parentSubTeamId
        visibility
        quoteLanguage
        childFreelancers
        offlineIds
        activeFlag
        type
        mergedQuotes
        parentProjectId
        billLocation
        marginLabel
        overheadLabel
        marginAndOverheadLabel
        marginPercentage
        overheadPercentage
        exchangeRate
        localExchangeRate
        localOtNumberOfHours
        exeOtNumberOfHours
        marginVAT_rate
        marginAcc_section
        allowInternational
        freelancers
        parentCompanyId
        companyLogo
        maximizeMinimize
        provisionalColumn
        selectContactById
        clientId
        contactId
        clientName
        projectName
        agency
        agencyRepresentative
        director
        executiveProducer
        lineProducer
        numberOfShootingDays
        notes
        introduction
        shooting
        prep
        shootingCountry
        prelight
        casting
        crew
        buyouts
        locations
        studio
        artDepartment
        wardrobe
        equipment
        travel
        accommodation
        editing
        imagePostproduction
        soundPostproduction
        deliverables
        insurance
        quoteGuidelines
        excluded
        paymentTerms
        miscellaneous
        conclusion
        installment1Percentage
        installment1Date
        installment2Percentage
        installment2Date
        balancePercentage
        balanceDate
        isStarred
        isChecked
        isFinalized
        recapInfoComments
        contact
        quoteTotal {
          budgetSubTotal
          budgetGrandTotal
          budgetMargin
          budgetMarginPercentage
          budgetSeperateMargin
          budgetSeperateMarginPercentage
          budgetSeperateOverhead
          budgetSeperateOverheadPercentage
          provisionalSubTotal
          provisionalGrandTotal
          provisionalMargin
          provisionalMarginPercentage
          actualSubTotal
          actualGrandTotal
          actualMargin
          actualMarginPercentage
          purchaseSubTotal
          purchaseGrandTotal
          purchaseMargin
          purchaseMarginPercentage
          grandBudgetWithMarginTotal
          noMarginTotalPercentage
          subTotalBudgetWithMargin
          subTotalBudgetWithoutMargin
          subTotalBudgetWithMarginPercentage
        }
        quoteTotalDiscount {
          totalAfterDiscount
          totalDiscount
          budgetTotalDiscountOnMargin
          budgetTotalDiscountOnMarginPercentage
          budgetTotalDiscountPercentage
          provisionalTotalDiscountOnMargin
          provisionalTotalDiscountOnMarginPercentage
          provisionalTotalDiscountPercentage
          actualTotalDiscountOnMargin
          actualTotalDiscountOnMarginPercentage
          actualTotalDiscountPercentage
          purchaseTotalDiscountOnMargin
          purchaseTotalDiscountOnMarginPercentage
          purchaseTotalDiscountPercentage
        }
        discount {
          totalDiscount
          totalAfterDiscount
          totalDiscountOnMargin
          totalDiscountOnMarginPercentage
          totalDiscountPercentage
        }
        quoteNumber
        quoteAccountingCategory
        deliveryDate
        quoteTertiaryCategory
        exeLocation
        advertiserJobID
        brand
        jobName
        agencyJobID
        product
        advertiser
        productionJobID
        advertiserAddress
        productionCompany
        productionContact
        vfxCo
        vfxProducer
        editorialCo
        editorialProducer
        musicCo
        musicProducer
        agencyProducer
        agencyCreativeTeam
        prepDays
        buildAndStrikeDays
        preLight
        stageDays
        locationDays
        description
        service
        scope
        vhr
        billingAddress
        dateOfShoot
        photographer
        jobNumber
        photoLocation
        quoteProdValue1
        quoteProdValue2
        quoteProdValue3
        quoteProdValue4
        quoteProdValue5
        quoteProdValue6
        quoteProdValue7
        quoteProdValue8
        quoteProdValue9
        quoteProdValue10
        quoteProdValue11
        quoteProdValue12
        quoteProdValue13
        quoteProdValue14
        quoteProdValue15
        quoteProdValue16
        quoteProdValue17
        quoteProdValue18
        quoteProdValue19
        quoteProdValue20
        quoteProdValue21
        quoteProdValue22
        quoteProdValue23
        quoteProdValue24
        quoteProdValue25
        termsType
        termsSelection
        quoteCurrency
        exeQuoteCurrency
        marginCustomization
        pdfColumnCustomization
        pdfMiscCustomization
        summaryTableCustomization
        quoteHeaderLabel1
        quoteHeaderValue1
        quoteHeaderLabel2
        quoteHeaderValue2
        quoteHeaderLabel3
        quoteHeaderValue3
        quoteHeaderLabel4
        quoteHeaderValue4
        quoteHeaderLabel5
        quoteHeaderValue5
        quoteHeaderLabel6
        quoteHeaderValue6
        quoteHeaderLabel7
        quoteHeaderValue7
        quoteHeaderLabel8
        quoteHeaderValue8
        quoteHeaderLabel9
        quoteHeaderValue9
        quoteHeaderLabel10
        quoteHeaderValue10
        quoteHeaderLabel11
        quoteHeaderValue11
        productionNoteLabels
        budgetSections
        showCo2InSummary
        showCo2InPdf
        numberOfPrepDaysCo2
        numberOfShootDaysCo2
        numberOfPeopleOnSetCo2
        enableTravelCo2
        travelTypeCo2
        percentageOfCrewTravelCo2
        travelTypeLocation2Co2
        percentageOfCrewTravelLocation2Co2
        overtimeHours1Rate
        overtimeHours2Rate
        overtimeHours3Rate
        overtimeHours4Rate
        assignedTenantId
        assignedTenantName
        isExpired
        filledCostlineDetails {
          totalBudget
          totalCrewBudget
          totalPostProdBudget
          crewPrepNumberOfDays
          crewShootNumberOfDays
        }
        proposals {
          nextToken
        }
        createdOn
        updatedOn
        _deleted
        _version
        _lastChangedAt
      }
      invoices {
        items {
          id
          tenantId
          proposalId
          quoteType
          activeFlag
          originalInvoiceId
          creditInvoiceGenerated
          archivedDate
          paidDate
          paymentStatus
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientId
          contactId
          clientName
          contactName
          clientTaxType
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          title
          invoiceNumber
          poNumber
          invoiceAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          invoicesBankProfileName
          invoicesBank
          invoicesIban
          invoicesBic
          invoicesAccountName
          invoiceDate
          invoiceDueDate
          description
          creditComments
          invoiceType
          salesAccNumberType
          createdOn
          updatedOn
          uniqueTransactionId
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          lastExportedDate
          emailSent
          billitInboxItemId
          billitPeppolStatus
          billitPeppolError
          _deleted
          _version
          _lastChangedAt
        }
        nextToken
      }
      createdOn
      updatedOn
      poDate
      poName
      poAmount
      poCurrency
      poNotes
      poDocuments {
        bucket
        region
        key
        identityId
      }
      poVersion
      prevStatus
      assignedTenantId
      assignedTenantName
      showBidLetter
      companyLogo
      _deleted
      _version
      _lastChangedAt
    }
    createdOn
    updatedOn
    uniqueTransactionId
    assignedTenantId
    assignedTenantName
    showBidLetter
    companyLogo
    lastExportedDate
    emailSent
    draftEmailData {
      toEmail
      toCC
      toBCC
      subject
      body
      template
    }
    emailHistory {
      date
      subject
    }
    billitInboxItemId
    billitPeppolStatus
    billitPeppolError
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedMutation<
	APITypes.CreateInvoicesMutationVariables,
	APITypes.CreateInvoicesMutation
>
export const updateInvoices = /* GraphQL */ `mutation UpdateInvoices(
  $input: UpdateInvoicesInput!
  $condition: ModelInvoicesConditionInput
) {
  updateInvoices(input: $input, condition: $condition) {
    id
    tenantId
    proposalId
    quoteType
    activeFlag
    originalInvoiceId
    creditInvoiceGenerated
    archivedDate
    paidDate
    paymentStatus
    quoteName
    quoteNumber
    projectName
    projectNumber
    clientId
    contactId
    clientName
    contactName
    clientTaxType
    clientEmail
    clientAddress
    clientCountry
    clientIdNumber
    clientVatNumber
    clientCurrency
    clientTaxRate
    title
    invoiceNumber
    poNumber
    invoiceAmountPercentage
    amount
    amountAfterTax
    taxAmount
    balancePercentage
    balanceAmount
    clientNote
    isDetailed
    isClientTaxRate
    bankProfileNumber
    invoicesBankProfileName
    invoicesBank
    invoicesIban
    invoicesBic
    invoicesAccountName
    invoiceDate
    invoiceDueDate
    description
    creditComments
    invoiceType
    proposalsDraft {
      generated
      poNumber
      proposalAmountPercentage
      amount
      amountAfterTax
      taxAmount
      balancePercentage
      balanceAmount
      invoiceId
      invoiceDate
      invoiceDueDate
      description
      readyStatus
      taxDetails {
        taxRate
        taxPercentage
        taxAmount
        taxableAmount
      }
      salesAccNumberType
      sectionDetails {
        type
        amount
      }
      sectionDetailsByQuote {
        type
        amount
      }
      sectionDetailsByAccSection {
        type
        amount
      }
    }
    taxDetails {
      taxRate
      taxPercentage
      taxAmount
      taxableAmount
    }
    salesAccNumberType
    sectionDetails {
      type
      amount
    }
    sectionDetailsByQuote {
      type
      amount
    }
    sectionDetailsByAccSection {
      type
      amount
    }
    proposals {
      id
      tenantId
      activeFlag
      quoteId
      quoteType
      clientId
      contactId
      status
      noofInvoices
      quoteName
      quoteNumber
      projectName
      projectNumber
      clientTaxType
      clientName
      contactName
      clientEmail
      clientAddress
      clientCountry
      clientIdNumber
      clientVatNumber
      clientCurrency
      clientTaxRate
      paymentTerms
      total
      clientNote
      isDetailed
      isClientTaxRate
      bankProfileNumber
      proposalsBankProfileName
      proposalsBank
      proposalsIban
      proposalsBic
      proposalsAccountName
      drafts {
        generated
        poNumber
        proposalAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        invoiceId
        invoiceDate
        invoiceDueDate
        description
        readyStatus
        taxDetails {
          taxRate
          taxPercentage
          taxAmount
          taxableAmount
        }
        salesAccNumberType
        sectionDetails {
          type
          amount
        }
        sectionDetailsByQuote {
          type
          amount
        }
        sectionDetailsByAccSection {
          type
          amount
        }
      }
      quote {
        id
        name
        tenantId
        quoteType
        quoteVersion
        aiGenerationRunId
        aiGenerationStatus
        aiGenerationError
        aiGenerationStartedAt
        aiGenerationCompletedAt
        aiGeneratedByUserId
        blankQuoteType
        parentTeamId
        parentSubTeamId
        visibility
        quoteLanguage
        childFreelancers
        offlineIds
        activeFlag
        type
        mergedQuotes
        parentProjectId
        billLocation
        marginLabel
        overheadLabel
        marginAndOverheadLabel
        marginPercentage
        overheadPercentage
        exchangeRate
        localExchangeRate
        localOtNumberOfHours
        exeOtNumberOfHours
        marginVAT_rate
        marginAcc_section
        allowInternational
        freelancers
        parentCompanyId
        companyLogo
        maximizeMinimize
        provisionalColumn
        selectContactById
        clientId
        contactId
        clientName
        projectName
        agency
        agencyRepresentative
        director
        executiveProducer
        lineProducer
        numberOfShootingDays
        notes
        introduction
        shooting
        prep
        shootingCountry
        prelight
        casting
        crew
        buyouts
        locations
        studio
        artDepartment
        wardrobe
        equipment
        travel
        accommodation
        editing
        imagePostproduction
        soundPostproduction
        deliverables
        insurance
        quoteGuidelines
        excluded
        paymentTerms
        miscellaneous
        conclusion
        installment1Percentage
        installment1Date
        installment2Percentage
        installment2Date
        balancePercentage
        balanceDate
        isStarred
        isChecked
        isFinalized
        recapInfoComments
        contact
        quoteTotal {
          budgetSubTotal
          budgetGrandTotal
          budgetMargin
          budgetMarginPercentage
          budgetSeperateMargin
          budgetSeperateMarginPercentage
          budgetSeperateOverhead
          budgetSeperateOverheadPercentage
          provisionalSubTotal
          provisionalGrandTotal
          provisionalMargin
          provisionalMarginPercentage
          actualSubTotal
          actualGrandTotal
          actualMargin
          actualMarginPercentage
          purchaseSubTotal
          purchaseGrandTotal
          purchaseMargin
          purchaseMarginPercentage
          grandBudgetWithMarginTotal
          noMarginTotalPercentage
          subTotalBudgetWithMargin
          subTotalBudgetWithoutMargin
          subTotalBudgetWithMarginPercentage
        }
        quoteTotalDiscount {
          totalAfterDiscount
          totalDiscount
          budgetTotalDiscountOnMargin
          budgetTotalDiscountOnMarginPercentage
          budgetTotalDiscountPercentage
          provisionalTotalDiscountOnMargin
          provisionalTotalDiscountOnMarginPercentage
          provisionalTotalDiscountPercentage
          actualTotalDiscountOnMargin
          actualTotalDiscountOnMarginPercentage
          actualTotalDiscountPercentage
          purchaseTotalDiscountOnMargin
          purchaseTotalDiscountOnMarginPercentage
          purchaseTotalDiscountPercentage
        }
        discount {
          totalDiscount
          totalAfterDiscount
          totalDiscountOnMargin
          totalDiscountOnMarginPercentage
          totalDiscountPercentage
        }
        quoteNumber
        quoteAccountingCategory
        deliveryDate
        quoteTertiaryCategory
        exeLocation
        advertiserJobID
        brand
        jobName
        agencyJobID
        product
        advertiser
        productionJobID
        advertiserAddress
        productionCompany
        productionContact
        vfxCo
        vfxProducer
        editorialCo
        editorialProducer
        musicCo
        musicProducer
        agencyProducer
        agencyCreativeTeam
        prepDays
        buildAndStrikeDays
        preLight
        stageDays
        locationDays
        description
        service
        scope
        vhr
        billingAddress
        dateOfShoot
        photographer
        jobNumber
        photoLocation
        quoteProdValue1
        quoteProdValue2
        quoteProdValue3
        quoteProdValue4
        quoteProdValue5
        quoteProdValue6
        quoteProdValue7
        quoteProdValue8
        quoteProdValue9
        quoteProdValue10
        quoteProdValue11
        quoteProdValue12
        quoteProdValue13
        quoteProdValue14
        quoteProdValue15
        quoteProdValue16
        quoteProdValue17
        quoteProdValue18
        quoteProdValue19
        quoteProdValue20
        quoteProdValue21
        quoteProdValue22
        quoteProdValue23
        quoteProdValue24
        quoteProdValue25
        termsType
        termsSelection
        quoteCurrency
        exeQuoteCurrency
        marginCustomization
        pdfColumnCustomization
        pdfMiscCustomization
        summaryTableCustomization
        quoteHeaderLabel1
        quoteHeaderValue1
        quoteHeaderLabel2
        quoteHeaderValue2
        quoteHeaderLabel3
        quoteHeaderValue3
        quoteHeaderLabel4
        quoteHeaderValue4
        quoteHeaderLabel5
        quoteHeaderValue5
        quoteHeaderLabel6
        quoteHeaderValue6
        quoteHeaderLabel7
        quoteHeaderValue7
        quoteHeaderLabel8
        quoteHeaderValue8
        quoteHeaderLabel9
        quoteHeaderValue9
        quoteHeaderLabel10
        quoteHeaderValue10
        quoteHeaderLabel11
        quoteHeaderValue11
        productionNoteLabels
        budgetSections
        showCo2InSummary
        showCo2InPdf
        numberOfPrepDaysCo2
        numberOfShootDaysCo2
        numberOfPeopleOnSetCo2
        enableTravelCo2
        travelTypeCo2
        percentageOfCrewTravelCo2
        travelTypeLocation2Co2
        percentageOfCrewTravelLocation2Co2
        overtimeHours1Rate
        overtimeHours2Rate
        overtimeHours3Rate
        overtimeHours4Rate
        assignedTenantId
        assignedTenantName
        isExpired
        filledCostlineDetails {
          totalBudget
          totalCrewBudget
          totalPostProdBudget
          crewPrepNumberOfDays
          crewShootNumberOfDays
        }
        proposals {
          nextToken
        }
        createdOn
        updatedOn
        _deleted
        _version
        _lastChangedAt
      }
      invoices {
        items {
          id
          tenantId
          proposalId
          quoteType
          activeFlag
          originalInvoiceId
          creditInvoiceGenerated
          archivedDate
          paidDate
          paymentStatus
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientId
          contactId
          clientName
          contactName
          clientTaxType
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          title
          invoiceNumber
          poNumber
          invoiceAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          invoicesBankProfileName
          invoicesBank
          invoicesIban
          invoicesBic
          invoicesAccountName
          invoiceDate
          invoiceDueDate
          description
          creditComments
          invoiceType
          salesAccNumberType
          createdOn
          updatedOn
          uniqueTransactionId
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          lastExportedDate
          emailSent
          billitInboxItemId
          billitPeppolStatus
          billitPeppolError
          _deleted
          _version
          _lastChangedAt
        }
        nextToken
      }
      createdOn
      updatedOn
      poDate
      poName
      poAmount
      poCurrency
      poNotes
      poDocuments {
        bucket
        region
        key
        identityId
      }
      poVersion
      prevStatus
      assignedTenantId
      assignedTenantName
      showBidLetter
      companyLogo
      _deleted
      _version
      _lastChangedAt
    }
    createdOn
    updatedOn
    uniqueTransactionId
    assignedTenantId
    assignedTenantName
    showBidLetter
    companyLogo
    lastExportedDate
    emailSent
    draftEmailData {
      toEmail
      toCC
      toBCC
      subject
      body
      template
    }
    emailHistory {
      date
      subject
    }
    billitInboxItemId
    billitPeppolStatus
    billitPeppolError
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedMutation<
	APITypes.UpdateInvoicesMutationVariables,
	APITypes.UpdateInvoicesMutation
>
export const deleteInvoices = /* GraphQL */ `mutation DeleteInvoices(
  $input: DeleteInvoicesInput!
  $condition: ModelInvoicesConditionInput
) {
  deleteInvoices(input: $input, condition: $condition) {
    id
    tenantId
    proposalId
    quoteType
    activeFlag
    originalInvoiceId
    creditInvoiceGenerated
    archivedDate
    paidDate
    paymentStatus
    quoteName
    quoteNumber
    projectName
    projectNumber
    clientId
    contactId
    clientName
    contactName
    clientTaxType
    clientEmail
    clientAddress
    clientCountry
    clientIdNumber
    clientVatNumber
    clientCurrency
    clientTaxRate
    title
    invoiceNumber
    poNumber
    invoiceAmountPercentage
    amount
    amountAfterTax
    taxAmount
    balancePercentage
    balanceAmount
    clientNote
    isDetailed
    isClientTaxRate
    bankProfileNumber
    invoicesBankProfileName
    invoicesBank
    invoicesIban
    invoicesBic
    invoicesAccountName
    invoiceDate
    invoiceDueDate
    description
    creditComments
    invoiceType
    proposalsDraft {
      generated
      poNumber
      proposalAmountPercentage
      amount
      amountAfterTax
      taxAmount
      balancePercentage
      balanceAmount
      invoiceId
      invoiceDate
      invoiceDueDate
      description
      readyStatus
      taxDetails {
        taxRate
        taxPercentage
        taxAmount
        taxableAmount
      }
      salesAccNumberType
      sectionDetails {
        type
        amount
      }
      sectionDetailsByQuote {
        type
        amount
      }
      sectionDetailsByAccSection {
        type
        amount
      }
    }
    taxDetails {
      taxRate
      taxPercentage
      taxAmount
      taxableAmount
    }
    salesAccNumberType
    sectionDetails {
      type
      amount
    }
    sectionDetailsByQuote {
      type
      amount
    }
    sectionDetailsByAccSection {
      type
      amount
    }
    proposals {
      id
      tenantId
      activeFlag
      quoteId
      quoteType
      clientId
      contactId
      status
      noofInvoices
      quoteName
      quoteNumber
      projectName
      projectNumber
      clientTaxType
      clientName
      contactName
      clientEmail
      clientAddress
      clientCountry
      clientIdNumber
      clientVatNumber
      clientCurrency
      clientTaxRate
      paymentTerms
      total
      clientNote
      isDetailed
      isClientTaxRate
      bankProfileNumber
      proposalsBankProfileName
      proposalsBank
      proposalsIban
      proposalsBic
      proposalsAccountName
      drafts {
        generated
        poNumber
        proposalAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        invoiceId
        invoiceDate
        invoiceDueDate
        description
        readyStatus
        taxDetails {
          taxRate
          taxPercentage
          taxAmount
          taxableAmount
        }
        salesAccNumberType
        sectionDetails {
          type
          amount
        }
        sectionDetailsByQuote {
          type
          amount
        }
        sectionDetailsByAccSection {
          type
          amount
        }
      }
      quote {
        id
        name
        tenantId
        quoteType
        quoteVersion
        aiGenerationRunId
        aiGenerationStatus
        aiGenerationError
        aiGenerationStartedAt
        aiGenerationCompletedAt
        aiGeneratedByUserId
        blankQuoteType
        parentTeamId
        parentSubTeamId
        visibility
        quoteLanguage
        childFreelancers
        offlineIds
        activeFlag
        type
        mergedQuotes
        parentProjectId
        billLocation
        marginLabel
        overheadLabel
        marginAndOverheadLabel
        marginPercentage
        overheadPercentage
        exchangeRate
        localExchangeRate
        localOtNumberOfHours
        exeOtNumberOfHours
        marginVAT_rate
        marginAcc_section
        allowInternational
        freelancers
        parentCompanyId
        companyLogo
        maximizeMinimize
        provisionalColumn
        selectContactById
        clientId
        contactId
        clientName
        projectName
        agency
        agencyRepresentative
        director
        executiveProducer
        lineProducer
        numberOfShootingDays
        notes
        introduction
        shooting
        prep
        shootingCountry
        prelight
        casting
        crew
        buyouts
        locations
        studio
        artDepartment
        wardrobe
        equipment
        travel
        accommodation
        editing
        imagePostproduction
        soundPostproduction
        deliverables
        insurance
        quoteGuidelines
        excluded
        paymentTerms
        miscellaneous
        conclusion
        installment1Percentage
        installment1Date
        installment2Percentage
        installment2Date
        balancePercentage
        balanceDate
        isStarred
        isChecked
        isFinalized
        recapInfoComments
        contact
        quoteTotal {
          budgetSubTotal
          budgetGrandTotal
          budgetMargin
          budgetMarginPercentage
          budgetSeperateMargin
          budgetSeperateMarginPercentage
          budgetSeperateOverhead
          budgetSeperateOverheadPercentage
          provisionalSubTotal
          provisionalGrandTotal
          provisionalMargin
          provisionalMarginPercentage
          actualSubTotal
          actualGrandTotal
          actualMargin
          actualMarginPercentage
          purchaseSubTotal
          purchaseGrandTotal
          purchaseMargin
          purchaseMarginPercentage
          grandBudgetWithMarginTotal
          noMarginTotalPercentage
          subTotalBudgetWithMargin
          subTotalBudgetWithoutMargin
          subTotalBudgetWithMarginPercentage
        }
        quoteTotalDiscount {
          totalAfterDiscount
          totalDiscount
          budgetTotalDiscountOnMargin
          budgetTotalDiscountOnMarginPercentage
          budgetTotalDiscountPercentage
          provisionalTotalDiscountOnMargin
          provisionalTotalDiscountOnMarginPercentage
          provisionalTotalDiscountPercentage
          actualTotalDiscountOnMargin
          actualTotalDiscountOnMarginPercentage
          actualTotalDiscountPercentage
          purchaseTotalDiscountOnMargin
          purchaseTotalDiscountOnMarginPercentage
          purchaseTotalDiscountPercentage
        }
        discount {
          totalDiscount
          totalAfterDiscount
          totalDiscountOnMargin
          totalDiscountOnMarginPercentage
          totalDiscountPercentage
        }
        quoteNumber
        quoteAccountingCategory
        deliveryDate
        quoteTertiaryCategory
        exeLocation
        advertiserJobID
        brand
        jobName
        agencyJobID
        product
        advertiser
        productionJobID
        advertiserAddress
        productionCompany
        productionContact
        vfxCo
        vfxProducer
        editorialCo
        editorialProducer
        musicCo
        musicProducer
        agencyProducer
        agencyCreativeTeam
        prepDays
        buildAndStrikeDays
        preLight
        stageDays
        locationDays
        description
        service
        scope
        vhr
        billingAddress
        dateOfShoot
        photographer
        jobNumber
        photoLocation
        quoteProdValue1
        quoteProdValue2
        quoteProdValue3
        quoteProdValue4
        quoteProdValue5
        quoteProdValue6
        quoteProdValue7
        quoteProdValue8
        quoteProdValue9
        quoteProdValue10
        quoteProdValue11
        quoteProdValue12
        quoteProdValue13
        quoteProdValue14
        quoteProdValue15
        quoteProdValue16
        quoteProdValue17
        quoteProdValue18
        quoteProdValue19
        quoteProdValue20
        quoteProdValue21
        quoteProdValue22
        quoteProdValue23
        quoteProdValue24
        quoteProdValue25
        termsType
        termsSelection
        quoteCurrency
        exeQuoteCurrency
        marginCustomization
        pdfColumnCustomization
        pdfMiscCustomization
        summaryTableCustomization
        quoteHeaderLabel1
        quoteHeaderValue1
        quoteHeaderLabel2
        quoteHeaderValue2
        quoteHeaderLabel3
        quoteHeaderValue3
        quoteHeaderLabel4
        quoteHeaderValue4
        quoteHeaderLabel5
        quoteHeaderValue5
        quoteHeaderLabel6
        quoteHeaderValue6
        quoteHeaderLabel7
        quoteHeaderValue7
        quoteHeaderLabel8
        quoteHeaderValue8
        quoteHeaderLabel9
        quoteHeaderValue9
        quoteHeaderLabel10
        quoteHeaderValue10
        quoteHeaderLabel11
        quoteHeaderValue11
        productionNoteLabels
        budgetSections
        showCo2InSummary
        showCo2InPdf
        numberOfPrepDaysCo2
        numberOfShootDaysCo2
        numberOfPeopleOnSetCo2
        enableTravelCo2
        travelTypeCo2
        percentageOfCrewTravelCo2
        travelTypeLocation2Co2
        percentageOfCrewTravelLocation2Co2
        overtimeHours1Rate
        overtimeHours2Rate
        overtimeHours3Rate
        overtimeHours4Rate
        assignedTenantId
        assignedTenantName
        isExpired
        filledCostlineDetails {
          totalBudget
          totalCrewBudget
          totalPostProdBudget
          crewPrepNumberOfDays
          crewShootNumberOfDays
        }
        proposals {
          nextToken
        }
        createdOn
        updatedOn
        _deleted
        _version
        _lastChangedAt
      }
      invoices {
        items {
          id
          tenantId
          proposalId
          quoteType
          activeFlag
          originalInvoiceId
          creditInvoiceGenerated
          archivedDate
          paidDate
          paymentStatus
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientId
          contactId
          clientName
          contactName
          clientTaxType
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          title
          invoiceNumber
          poNumber
          invoiceAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          invoicesBankProfileName
          invoicesBank
          invoicesIban
          invoicesBic
          invoicesAccountName
          invoiceDate
          invoiceDueDate
          description
          creditComments
          invoiceType
          salesAccNumberType
          createdOn
          updatedOn
          uniqueTransactionId
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          lastExportedDate
          emailSent
          billitInboxItemId
          billitPeppolStatus
          billitPeppolError
          _deleted
          _version
          _lastChangedAt
        }
        nextToken
      }
      createdOn
      updatedOn
      poDate
      poName
      poAmount
      poCurrency
      poNotes
      poDocuments {
        bucket
        region
        key
        identityId
      }
      poVersion
      prevStatus
      assignedTenantId
      assignedTenantName
      showBidLetter
      companyLogo
      _deleted
      _version
      _lastChangedAt
    }
    createdOn
    updatedOn
    uniqueTransactionId
    assignedTenantId
    assignedTenantName
    showBidLetter
    companyLogo
    lastExportedDate
    emailSent
    draftEmailData {
      toEmail
      toCC
      toBCC
      subject
      body
      template
    }
    emailHistory {
      date
      subject
    }
    billitInboxItemId
    billitPeppolStatus
    billitPeppolError
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedMutation<
	APITypes.DeleteInvoicesMutationVariables,
	APITypes.DeleteInvoicesMutation
>
export const createLlmDetails = /* GraphQL */ `mutation CreateLlmDetails(
  $input: CreateLlmDetailsInput!
  $condition: ModelLlmDetailsConditionInput
) {
  createLlmDetails(input: $input, condition: $condition) {
    id
    tenantId
    quoteId
    systemPrompt
    userPrompt
    temperature
    maxTokens
    generatedOutput
    generatedPromptQuoteKey
    runType
    runStatus
    runTypeStatus
    auditS3Key
    modelId
    inputTokens
    outputTokens
    totalTokens
    estimatedCostUsd
    startedAt
    completedAt
    errorCode
    errorMessage
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedMutation<
	APITypes.CreateLlmDetailsMutationVariables,
	APITypes.CreateLlmDetailsMutation
>
export const updateLlmDetails = /* GraphQL */ `mutation UpdateLlmDetails(
  $input: UpdateLlmDetailsInput!
  $condition: ModelLlmDetailsConditionInput
) {
  updateLlmDetails(input: $input, condition: $condition) {
    id
    tenantId
    quoteId
    systemPrompt
    userPrompt
    temperature
    maxTokens
    generatedOutput
    generatedPromptQuoteKey
    runType
    runStatus
    runTypeStatus
    auditS3Key
    modelId
    inputTokens
    outputTokens
    totalTokens
    estimatedCostUsd
    startedAt
    completedAt
    errorCode
    errorMessage
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedMutation<
	APITypes.UpdateLlmDetailsMutationVariables,
	APITypes.UpdateLlmDetailsMutation
>
export const deleteLlmDetails = /* GraphQL */ `mutation DeleteLlmDetails(
  $input: DeleteLlmDetailsInput!
  $condition: ModelLlmDetailsConditionInput
) {
  deleteLlmDetails(input: $input, condition: $condition) {
    id
    tenantId
    quoteId
    systemPrompt
    userPrompt
    temperature
    maxTokens
    generatedOutput
    generatedPromptQuoteKey
    runType
    runStatus
    runTypeStatus
    auditS3Key
    modelId
    inputTokens
    outputTokens
    totalTokens
    estimatedCostUsd
    startedAt
    completedAt
    errorCode
    errorMessage
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedMutation<
	APITypes.DeleteLlmDetailsMutationVariables,
	APITypes.DeleteLlmDetailsMutation
>
export const createPreparePurchase =
	/* GraphQL */ `mutation CreatePreparePurchase(
  $input: CreatePreparePurchaseInput!
  $condition: ModelPreparePurchaseConditionInput
) {
  createPreparePurchase(input: $input, condition: $condition) {
    id
    tenantId
    activeFlag
    uniqueTransactionId
    flag
    invoiceName
    ocrInvoiceName
    fileName
    ocrFileName
    invoiceDate
    ocrInvoiceDate
    paymentDate
    ocrPaymentDate
    paymentStatus
    preparePurchasePaidDate
    supplier
    ocrSupplier
    po
    ocrPO
    costlineName
    costlineName_fr
    projectName
    totalAmount
    taxAmount
    netAmountDetails {
      netAmount
      category
      projectId
      projectName
      projectNumber
      costlineId
      costlineName
      costlineName_fr
    }
    taxAmountDetails {
      taxAmount
      vatAccount
      vatIntracom
    }
    netAmount
    ocrTotalAmount
    ocrTaxAmount
    ocrNetAmount
    currency
    ocrCurrency
    type
    status
    currentPage
    prevPage
    archivedDate
    category
    ocrCategory
    note
    ocrNote
    invoiceDocuments {
      bucket
      region
      key
      identityId
    }
    poId
    quoteId
    supplierId
    costlineId
    projectId
    ocrStatus
    vatAccount
    ocrData {
      bucket
      region
      key
      identityId
    }
    invoiceKey
    paymentMethods
    vatIntracom
    bankAccountNumber
    paymentReference
    paymentReferenceType
    bankAccountName
    supplierAccountingNumber
    supplierAccountingName
    projectNumber
    quoteNumber
    lastExportedDate
    preparePurchaseToPayDate
    fullPurchaseNumber
    bridgePaymentLinkId
    billitInboxItemId
    billitPeppolFileId
    billitSenderPeppolId
    billitImportDate
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedMutation<
		APITypes.CreatePreparePurchaseMutationVariables,
		APITypes.CreatePreparePurchaseMutation
	>
export const updatePreparePurchase =
	/* GraphQL */ `mutation UpdatePreparePurchase(
  $input: UpdatePreparePurchaseInput!
  $condition: ModelPreparePurchaseConditionInput
) {
  updatePreparePurchase(input: $input, condition: $condition) {
    id
    tenantId
    activeFlag
    uniqueTransactionId
    flag
    invoiceName
    ocrInvoiceName
    fileName
    ocrFileName
    invoiceDate
    ocrInvoiceDate
    paymentDate
    ocrPaymentDate
    paymentStatus
    preparePurchasePaidDate
    supplier
    ocrSupplier
    po
    ocrPO
    costlineName
    costlineName_fr
    projectName
    totalAmount
    taxAmount
    netAmountDetails {
      netAmount
      category
      projectId
      projectName
      projectNumber
      costlineId
      costlineName
      costlineName_fr
    }
    taxAmountDetails {
      taxAmount
      vatAccount
      vatIntracom
    }
    netAmount
    ocrTotalAmount
    ocrTaxAmount
    ocrNetAmount
    currency
    ocrCurrency
    type
    status
    currentPage
    prevPage
    archivedDate
    category
    ocrCategory
    note
    ocrNote
    invoiceDocuments {
      bucket
      region
      key
      identityId
    }
    poId
    quoteId
    supplierId
    costlineId
    projectId
    ocrStatus
    vatAccount
    ocrData {
      bucket
      region
      key
      identityId
    }
    invoiceKey
    paymentMethods
    vatIntracom
    bankAccountNumber
    paymentReference
    paymentReferenceType
    bankAccountName
    supplierAccountingNumber
    supplierAccountingName
    projectNumber
    quoteNumber
    lastExportedDate
    preparePurchaseToPayDate
    fullPurchaseNumber
    bridgePaymentLinkId
    billitInboxItemId
    billitPeppolFileId
    billitSenderPeppolId
    billitImportDate
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedMutation<
		APITypes.UpdatePreparePurchaseMutationVariables,
		APITypes.UpdatePreparePurchaseMutation
	>
export const deletePreparePurchase =
	/* GraphQL */ `mutation DeletePreparePurchase(
  $input: DeletePreparePurchaseInput!
  $condition: ModelPreparePurchaseConditionInput
) {
  deletePreparePurchase(input: $input, condition: $condition) {
    id
    tenantId
    activeFlag
    uniqueTransactionId
    flag
    invoiceName
    ocrInvoiceName
    fileName
    ocrFileName
    invoiceDate
    ocrInvoiceDate
    paymentDate
    ocrPaymentDate
    paymentStatus
    preparePurchasePaidDate
    supplier
    ocrSupplier
    po
    ocrPO
    costlineName
    costlineName_fr
    projectName
    totalAmount
    taxAmount
    netAmountDetails {
      netAmount
      category
      projectId
      projectName
      projectNumber
      costlineId
      costlineName
      costlineName_fr
    }
    taxAmountDetails {
      taxAmount
      vatAccount
      vatIntracom
    }
    netAmount
    ocrTotalAmount
    ocrTaxAmount
    ocrNetAmount
    currency
    ocrCurrency
    type
    status
    currentPage
    prevPage
    archivedDate
    category
    ocrCategory
    note
    ocrNote
    invoiceDocuments {
      bucket
      region
      key
      identityId
    }
    poId
    quoteId
    supplierId
    costlineId
    projectId
    ocrStatus
    vatAccount
    ocrData {
      bucket
      region
      key
      identityId
    }
    invoiceKey
    paymentMethods
    vatIntracom
    bankAccountNumber
    paymentReference
    paymentReferenceType
    bankAccountName
    supplierAccountingNumber
    supplierAccountingName
    projectNumber
    quoteNumber
    lastExportedDate
    preparePurchaseToPayDate
    fullPurchaseNumber
    bridgePaymentLinkId
    billitInboxItemId
    billitPeppolFileId
    billitSenderPeppolId
    billitImportDate
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedMutation<
		APITypes.DeletePreparePurchaseMutationVariables,
		APITypes.DeletePreparePurchaseMutation
	>
export const createProjects = /* GraphQL */ `mutation CreateProjects(
  $input: CreateProjectsInput!
  $condition: ModelProjectsConditionInput
) {
  createProjects(input: $input, condition: $condition) {
    id
    name
    tenantId
    freelancers
    childFreelancers
    offlineIds
    parentProjectId
    parentClientId
    activeFlag
    type
    parentTeamId
    parentSubTeamId
    isSubTeam
    projectType
    projectGroup
    parentCompanyId
    projectNumber
    subTeamCount
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedMutation<
	APITypes.CreateProjectsMutationVariables,
	APITypes.CreateProjectsMutation
>
export const updateProjects = /* GraphQL */ `mutation UpdateProjects(
  $input: UpdateProjectsInput!
  $condition: ModelProjectsConditionInput
) {
  updateProjects(input: $input, condition: $condition) {
    id
    name
    tenantId
    freelancers
    childFreelancers
    offlineIds
    parentProjectId
    parentClientId
    activeFlag
    type
    parentTeamId
    parentSubTeamId
    isSubTeam
    projectType
    projectGroup
    parentCompanyId
    projectNumber
    subTeamCount
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedMutation<
	APITypes.UpdateProjectsMutationVariables,
	APITypes.UpdateProjectsMutation
>
export const deleteProjects = /* GraphQL */ `mutation DeleteProjects(
  $input: DeleteProjectsInput!
  $condition: ModelProjectsConditionInput
) {
  deleteProjects(input: $input, condition: $condition) {
    id
    name
    tenantId
    freelancers
    childFreelancers
    offlineIds
    parentProjectId
    parentClientId
    activeFlag
    type
    parentTeamId
    parentSubTeamId
    isSubTeam
    projectType
    projectGroup
    parentCompanyId
    projectNumber
    subTeamCount
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedMutation<
	APITypes.DeleteProjectsMutationVariables,
	APITypes.DeleteProjectsMutation
>
export const createProposals = /* GraphQL */ `mutation CreateProposals(
  $input: CreateProposalsInput!
  $condition: ModelProposalsConditionInput
) {
  createProposals(input: $input, condition: $condition) {
    id
    tenantId
    activeFlag
    quoteId
    quoteType
    clientId
    contactId
    status
    noofInvoices
    quoteName
    quoteNumber
    projectName
    projectNumber
    clientTaxType
    clientName
    contactName
    clientEmail
    clientAddress
    clientCountry
    clientIdNumber
    clientVatNumber
    clientCurrency
    clientTaxRate
    paymentTerms
    total
    clientNote
    isDetailed
    isClientTaxRate
    bankProfileNumber
    proposalsBankProfileName
    proposalsBank
    proposalsIban
    proposalsBic
    proposalsAccountName
    drafts {
      generated
      poNumber
      proposalAmountPercentage
      amount
      amountAfterTax
      taxAmount
      balancePercentage
      balanceAmount
      invoiceId
      invoiceDate
      invoiceDueDate
      description
      readyStatus
      taxDetails {
        taxRate
        taxPercentage
        taxAmount
        taxableAmount
      }
      salesAccNumberType
      sectionDetails {
        type
        amount
      }
      sectionDetailsByQuote {
        type
        amount
      }
      sectionDetailsByAccSection {
        type
        amount
      }
    }
    quote {
      id
      name
      tenantId
      quoteType
      quoteVersion
      aiGenerationRunId
      aiGenerationStatus
      aiGenerationError
      aiGenerationStartedAt
      aiGenerationCompletedAt
      aiGeneratedByUserId
      blankQuoteType
      parentTeamId
      parentSubTeamId
      visibility
      quoteLanguage
      childFreelancers
      offlineIds
      activeFlag
      type
      mergedQuotes
      parentProjectId
      billLocation
      marginLabel
      overheadLabel
      marginAndOverheadLabel
      marginPercentage
      overheadPercentage
      exchangeRate
      localExchangeRate
      localOtNumberOfHours
      exeOtNumberOfHours
      marginVAT_rate
      marginAcc_section
      allowInternational
      freelancers
      parentCompanyId
      companyLogo
      maximizeMinimize
      provisionalColumn
      selectContactById
      clientId
      contactId
      clientName
      projectName
      agency
      agencyRepresentative
      director
      executiveProducer
      lineProducer
      numberOfShootingDays
      notes
      introduction
      shooting
      prep
      shootingCountry
      prelight
      casting
      crew
      buyouts
      locations
      studio
      artDepartment
      wardrobe
      equipment
      travel
      accommodation
      editing
      imagePostproduction
      soundPostproduction
      deliverables
      insurance
      quoteGuidelines
      excluded
      paymentTerms
      miscellaneous
      conclusion
      installment1Percentage
      installment1Date
      installment2Percentage
      installment2Date
      balancePercentage
      balanceDate
      isStarred
      isChecked
      isFinalized
      recapInfoComments
      contact
      quoteTotal {
        budgetSubTotal
        budgetGrandTotal
        budgetMargin
        budgetMarginPercentage
        budgetSeperateMargin
        budgetSeperateMarginPercentage
        budgetSeperateOverhead
        budgetSeperateOverheadPercentage
        provisionalSubTotal
        provisionalGrandTotal
        provisionalMargin
        provisionalMarginPercentage
        actualSubTotal
        actualGrandTotal
        actualMargin
        actualMarginPercentage
        purchaseSubTotal
        purchaseGrandTotal
        purchaseMargin
        purchaseMarginPercentage
        grandBudgetWithMarginTotal
        noMarginTotalPercentage
        subTotalBudgetWithMargin
        subTotalBudgetWithoutMargin
        subTotalBudgetWithMarginPercentage
      }
      quoteTotalDiscount {
        totalAfterDiscount
        totalDiscount
        budgetTotalDiscountOnMargin
        budgetTotalDiscountOnMarginPercentage
        budgetTotalDiscountPercentage
        provisionalTotalDiscountOnMargin
        provisionalTotalDiscountOnMarginPercentage
        provisionalTotalDiscountPercentage
        actualTotalDiscountOnMargin
        actualTotalDiscountOnMarginPercentage
        actualTotalDiscountPercentage
        purchaseTotalDiscountOnMargin
        purchaseTotalDiscountOnMarginPercentage
        purchaseTotalDiscountPercentage
      }
      discount {
        totalDiscount
        totalAfterDiscount
        totalDiscountOnMargin
        totalDiscountOnMarginPercentage
        totalDiscountPercentage
      }
      quoteNumber
      quoteAccountingCategory
      deliveryDate
      quoteTertiaryCategory
      exeLocation
      advertiserJobID
      brand
      jobName
      agencyJobID
      product
      advertiser
      productionJobID
      advertiserAddress
      productionCompany
      productionContact
      vfxCo
      vfxProducer
      editorialCo
      editorialProducer
      musicCo
      musicProducer
      agencyProducer
      agencyCreativeTeam
      prepDays
      buildAndStrikeDays
      preLight
      stageDays
      locationDays
      description
      service
      scope
      vhr
      billingAddress
      dateOfShoot
      photographer
      jobNumber
      photoLocation
      quoteProdValue1
      quoteProdValue2
      quoteProdValue3
      quoteProdValue4
      quoteProdValue5
      quoteProdValue6
      quoteProdValue7
      quoteProdValue8
      quoteProdValue9
      quoteProdValue10
      quoteProdValue11
      quoteProdValue12
      quoteProdValue13
      quoteProdValue14
      quoteProdValue15
      quoteProdValue16
      quoteProdValue17
      quoteProdValue18
      quoteProdValue19
      quoteProdValue20
      quoteProdValue21
      quoteProdValue22
      quoteProdValue23
      quoteProdValue24
      quoteProdValue25
      termsType
      termsSelection
      quoteCurrency
      exeQuoteCurrency
      marginCustomization
      pdfColumnCustomization
      pdfMiscCustomization
      summaryTableCustomization
      quoteHeaderLabel1
      quoteHeaderValue1
      quoteHeaderLabel2
      quoteHeaderValue2
      quoteHeaderLabel3
      quoteHeaderValue3
      quoteHeaderLabel4
      quoteHeaderValue4
      quoteHeaderLabel5
      quoteHeaderValue5
      quoteHeaderLabel6
      quoteHeaderValue6
      quoteHeaderLabel7
      quoteHeaderValue7
      quoteHeaderLabel8
      quoteHeaderValue8
      quoteHeaderLabel9
      quoteHeaderValue9
      quoteHeaderLabel10
      quoteHeaderValue10
      quoteHeaderLabel11
      quoteHeaderValue11
      productionNoteLabels
      budgetSections
      showCo2InSummary
      showCo2InPdf
      numberOfPrepDaysCo2
      numberOfShootDaysCo2
      numberOfPeopleOnSetCo2
      enableTravelCo2
      travelTypeCo2
      percentageOfCrewTravelCo2
      travelTypeLocation2Co2
      percentageOfCrewTravelLocation2Co2
      overtimeHours1Rate
      overtimeHours2Rate
      overtimeHours3Rate
      overtimeHours4Rate
      assignedTenantId
      assignedTenantName
      isExpired
      filledCostlineDetails {
        totalBudget
        totalCrewBudget
        totalPostProdBudget
        crewPrepNumberOfDays
        crewShootNumberOfDays
      }
      proposals {
        items {
          id
          tenantId
          activeFlag
          quoteId
          quoteType
          clientId
          contactId
          status
          noofInvoices
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientTaxType
          clientName
          contactName
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          paymentTerms
          total
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          proposalsBankProfileName
          proposalsBank
          proposalsIban
          proposalsBic
          proposalsAccountName
          createdOn
          updatedOn
          poDate
          poName
          poAmount
          poCurrency
          poNotes
          poVersion
          prevStatus
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          _deleted
          _version
          _lastChangedAt
        }
        nextToken
      }
      createdOn
      updatedOn
      _deleted
      _version
      _lastChangedAt
    }
    invoices {
      items {
        id
        tenantId
        proposalId
        quoteType
        activeFlag
        originalInvoiceId
        creditInvoiceGenerated
        archivedDate
        paidDate
        paymentStatus
        quoteName
        quoteNumber
        projectName
        projectNumber
        clientId
        contactId
        clientName
        contactName
        clientTaxType
        clientEmail
        clientAddress
        clientCountry
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        title
        invoiceNumber
        poNumber
        invoiceAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        clientNote
        isDetailed
        isClientTaxRate
        bankProfileNumber
        invoicesBankProfileName
        invoicesBank
        invoicesIban
        invoicesBic
        invoicesAccountName
        invoiceDate
        invoiceDueDate
        description
        creditComments
        invoiceType
        proposalsDraft {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
          salesAccNumberType
        }
        taxDetails {
          taxRate
          taxPercentage
          taxAmount
          taxableAmount
        }
        salesAccNumberType
        sectionDetails {
          type
          amount
        }
        sectionDetailsByQuote {
          type
          amount
        }
        sectionDetailsByAccSection {
          type
          amount
        }
        proposals {
          id
          tenantId
          activeFlag
          quoteId
          quoteType
          clientId
          contactId
          status
          noofInvoices
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientTaxType
          clientName
          contactName
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          paymentTerms
          total
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          proposalsBankProfileName
          proposalsBank
          proposalsIban
          proposalsBic
          proposalsAccountName
          createdOn
          updatedOn
          poDate
          poName
          poAmount
          poCurrency
          poNotes
          poVersion
          prevStatus
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          _deleted
          _version
          _lastChangedAt
        }
        createdOn
        updatedOn
        uniqueTransactionId
        assignedTenantId
        assignedTenantName
        showBidLetter
        companyLogo
        lastExportedDate
        emailSent
        draftEmailData {
          toEmail
          toCC
          toBCC
          subject
          body
          template
        }
        emailHistory {
          date
          subject
        }
        billitInboxItemId
        billitPeppolStatus
        billitPeppolError
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    createdOn
    updatedOn
    poDate
    poName
    poAmount
    poCurrency
    poNotes
    poDocuments {
      bucket
      region
      key
      identityId
    }
    poVersion
    prevStatus
    assignedTenantId
    assignedTenantName
    showBidLetter
    companyLogo
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedMutation<
	APITypes.CreateProposalsMutationVariables,
	APITypes.CreateProposalsMutation
>
export const updateProposals = /* GraphQL */ `mutation UpdateProposals(
  $input: UpdateProposalsInput!
  $condition: ModelProposalsConditionInput
) {
  updateProposals(input: $input, condition: $condition) {
    id
    tenantId
    activeFlag
    quoteId
    quoteType
    clientId
    contactId
    status
    noofInvoices
    quoteName
    quoteNumber
    projectName
    projectNumber
    clientTaxType
    clientName
    contactName
    clientEmail
    clientAddress
    clientCountry
    clientIdNumber
    clientVatNumber
    clientCurrency
    clientTaxRate
    paymentTerms
    total
    clientNote
    isDetailed
    isClientTaxRate
    bankProfileNumber
    proposalsBankProfileName
    proposalsBank
    proposalsIban
    proposalsBic
    proposalsAccountName
    drafts {
      generated
      poNumber
      proposalAmountPercentage
      amount
      amountAfterTax
      taxAmount
      balancePercentage
      balanceAmount
      invoiceId
      invoiceDate
      invoiceDueDate
      description
      readyStatus
      taxDetails {
        taxRate
        taxPercentage
        taxAmount
        taxableAmount
      }
      salesAccNumberType
      sectionDetails {
        type
        amount
      }
      sectionDetailsByQuote {
        type
        amount
      }
      sectionDetailsByAccSection {
        type
        amount
      }
    }
    quote {
      id
      name
      tenantId
      quoteType
      quoteVersion
      aiGenerationRunId
      aiGenerationStatus
      aiGenerationError
      aiGenerationStartedAt
      aiGenerationCompletedAt
      aiGeneratedByUserId
      blankQuoteType
      parentTeamId
      parentSubTeamId
      visibility
      quoteLanguage
      childFreelancers
      offlineIds
      activeFlag
      type
      mergedQuotes
      parentProjectId
      billLocation
      marginLabel
      overheadLabel
      marginAndOverheadLabel
      marginPercentage
      overheadPercentage
      exchangeRate
      localExchangeRate
      localOtNumberOfHours
      exeOtNumberOfHours
      marginVAT_rate
      marginAcc_section
      allowInternational
      freelancers
      parentCompanyId
      companyLogo
      maximizeMinimize
      provisionalColumn
      selectContactById
      clientId
      contactId
      clientName
      projectName
      agency
      agencyRepresentative
      director
      executiveProducer
      lineProducer
      numberOfShootingDays
      notes
      introduction
      shooting
      prep
      shootingCountry
      prelight
      casting
      crew
      buyouts
      locations
      studio
      artDepartment
      wardrobe
      equipment
      travel
      accommodation
      editing
      imagePostproduction
      soundPostproduction
      deliverables
      insurance
      quoteGuidelines
      excluded
      paymentTerms
      miscellaneous
      conclusion
      installment1Percentage
      installment1Date
      installment2Percentage
      installment2Date
      balancePercentage
      balanceDate
      isStarred
      isChecked
      isFinalized
      recapInfoComments
      contact
      quoteTotal {
        budgetSubTotal
        budgetGrandTotal
        budgetMargin
        budgetMarginPercentage
        budgetSeperateMargin
        budgetSeperateMarginPercentage
        budgetSeperateOverhead
        budgetSeperateOverheadPercentage
        provisionalSubTotal
        provisionalGrandTotal
        provisionalMargin
        provisionalMarginPercentage
        actualSubTotal
        actualGrandTotal
        actualMargin
        actualMarginPercentage
        purchaseSubTotal
        purchaseGrandTotal
        purchaseMargin
        purchaseMarginPercentage
        grandBudgetWithMarginTotal
        noMarginTotalPercentage
        subTotalBudgetWithMargin
        subTotalBudgetWithoutMargin
        subTotalBudgetWithMarginPercentage
      }
      quoteTotalDiscount {
        totalAfterDiscount
        totalDiscount
        budgetTotalDiscountOnMargin
        budgetTotalDiscountOnMarginPercentage
        budgetTotalDiscountPercentage
        provisionalTotalDiscountOnMargin
        provisionalTotalDiscountOnMarginPercentage
        provisionalTotalDiscountPercentage
        actualTotalDiscountOnMargin
        actualTotalDiscountOnMarginPercentage
        actualTotalDiscountPercentage
        purchaseTotalDiscountOnMargin
        purchaseTotalDiscountOnMarginPercentage
        purchaseTotalDiscountPercentage
      }
      discount {
        totalDiscount
        totalAfterDiscount
        totalDiscountOnMargin
        totalDiscountOnMarginPercentage
        totalDiscountPercentage
      }
      quoteNumber
      quoteAccountingCategory
      deliveryDate
      quoteTertiaryCategory
      exeLocation
      advertiserJobID
      brand
      jobName
      agencyJobID
      product
      advertiser
      productionJobID
      advertiserAddress
      productionCompany
      productionContact
      vfxCo
      vfxProducer
      editorialCo
      editorialProducer
      musicCo
      musicProducer
      agencyProducer
      agencyCreativeTeam
      prepDays
      buildAndStrikeDays
      preLight
      stageDays
      locationDays
      description
      service
      scope
      vhr
      billingAddress
      dateOfShoot
      photographer
      jobNumber
      photoLocation
      quoteProdValue1
      quoteProdValue2
      quoteProdValue3
      quoteProdValue4
      quoteProdValue5
      quoteProdValue6
      quoteProdValue7
      quoteProdValue8
      quoteProdValue9
      quoteProdValue10
      quoteProdValue11
      quoteProdValue12
      quoteProdValue13
      quoteProdValue14
      quoteProdValue15
      quoteProdValue16
      quoteProdValue17
      quoteProdValue18
      quoteProdValue19
      quoteProdValue20
      quoteProdValue21
      quoteProdValue22
      quoteProdValue23
      quoteProdValue24
      quoteProdValue25
      termsType
      termsSelection
      quoteCurrency
      exeQuoteCurrency
      marginCustomization
      pdfColumnCustomization
      pdfMiscCustomization
      summaryTableCustomization
      quoteHeaderLabel1
      quoteHeaderValue1
      quoteHeaderLabel2
      quoteHeaderValue2
      quoteHeaderLabel3
      quoteHeaderValue3
      quoteHeaderLabel4
      quoteHeaderValue4
      quoteHeaderLabel5
      quoteHeaderValue5
      quoteHeaderLabel6
      quoteHeaderValue6
      quoteHeaderLabel7
      quoteHeaderValue7
      quoteHeaderLabel8
      quoteHeaderValue8
      quoteHeaderLabel9
      quoteHeaderValue9
      quoteHeaderLabel10
      quoteHeaderValue10
      quoteHeaderLabel11
      quoteHeaderValue11
      productionNoteLabels
      budgetSections
      showCo2InSummary
      showCo2InPdf
      numberOfPrepDaysCo2
      numberOfShootDaysCo2
      numberOfPeopleOnSetCo2
      enableTravelCo2
      travelTypeCo2
      percentageOfCrewTravelCo2
      travelTypeLocation2Co2
      percentageOfCrewTravelLocation2Co2
      overtimeHours1Rate
      overtimeHours2Rate
      overtimeHours3Rate
      overtimeHours4Rate
      assignedTenantId
      assignedTenantName
      isExpired
      filledCostlineDetails {
        totalBudget
        totalCrewBudget
        totalPostProdBudget
        crewPrepNumberOfDays
        crewShootNumberOfDays
      }
      proposals {
        items {
          id
          tenantId
          activeFlag
          quoteId
          quoteType
          clientId
          contactId
          status
          noofInvoices
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientTaxType
          clientName
          contactName
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          paymentTerms
          total
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          proposalsBankProfileName
          proposalsBank
          proposalsIban
          proposalsBic
          proposalsAccountName
          createdOn
          updatedOn
          poDate
          poName
          poAmount
          poCurrency
          poNotes
          poVersion
          prevStatus
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          _deleted
          _version
          _lastChangedAt
        }
        nextToken
      }
      createdOn
      updatedOn
      _deleted
      _version
      _lastChangedAt
    }
    invoices {
      items {
        id
        tenantId
        proposalId
        quoteType
        activeFlag
        originalInvoiceId
        creditInvoiceGenerated
        archivedDate
        paidDate
        paymentStatus
        quoteName
        quoteNumber
        projectName
        projectNumber
        clientId
        contactId
        clientName
        contactName
        clientTaxType
        clientEmail
        clientAddress
        clientCountry
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        title
        invoiceNumber
        poNumber
        invoiceAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        clientNote
        isDetailed
        isClientTaxRate
        bankProfileNumber
        invoicesBankProfileName
        invoicesBank
        invoicesIban
        invoicesBic
        invoicesAccountName
        invoiceDate
        invoiceDueDate
        description
        creditComments
        invoiceType
        proposalsDraft {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
          salesAccNumberType
        }
        taxDetails {
          taxRate
          taxPercentage
          taxAmount
          taxableAmount
        }
        salesAccNumberType
        sectionDetails {
          type
          amount
        }
        sectionDetailsByQuote {
          type
          amount
        }
        sectionDetailsByAccSection {
          type
          amount
        }
        proposals {
          id
          tenantId
          activeFlag
          quoteId
          quoteType
          clientId
          contactId
          status
          noofInvoices
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientTaxType
          clientName
          contactName
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          paymentTerms
          total
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          proposalsBankProfileName
          proposalsBank
          proposalsIban
          proposalsBic
          proposalsAccountName
          createdOn
          updatedOn
          poDate
          poName
          poAmount
          poCurrency
          poNotes
          poVersion
          prevStatus
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          _deleted
          _version
          _lastChangedAt
        }
        createdOn
        updatedOn
        uniqueTransactionId
        assignedTenantId
        assignedTenantName
        showBidLetter
        companyLogo
        lastExportedDate
        emailSent
        draftEmailData {
          toEmail
          toCC
          toBCC
          subject
          body
          template
        }
        emailHistory {
          date
          subject
        }
        billitInboxItemId
        billitPeppolStatus
        billitPeppolError
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    createdOn
    updatedOn
    poDate
    poName
    poAmount
    poCurrency
    poNotes
    poDocuments {
      bucket
      region
      key
      identityId
    }
    poVersion
    prevStatus
    assignedTenantId
    assignedTenantName
    showBidLetter
    companyLogo
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedMutation<
	APITypes.UpdateProposalsMutationVariables,
	APITypes.UpdateProposalsMutation
>
export const deleteProposals = /* GraphQL */ `mutation DeleteProposals(
  $input: DeleteProposalsInput!
  $condition: ModelProposalsConditionInput
) {
  deleteProposals(input: $input, condition: $condition) {
    id
    tenantId
    activeFlag
    quoteId
    quoteType
    clientId
    contactId
    status
    noofInvoices
    quoteName
    quoteNumber
    projectName
    projectNumber
    clientTaxType
    clientName
    contactName
    clientEmail
    clientAddress
    clientCountry
    clientIdNumber
    clientVatNumber
    clientCurrency
    clientTaxRate
    paymentTerms
    total
    clientNote
    isDetailed
    isClientTaxRate
    bankProfileNumber
    proposalsBankProfileName
    proposalsBank
    proposalsIban
    proposalsBic
    proposalsAccountName
    drafts {
      generated
      poNumber
      proposalAmountPercentage
      amount
      amountAfterTax
      taxAmount
      balancePercentage
      balanceAmount
      invoiceId
      invoiceDate
      invoiceDueDate
      description
      readyStatus
      taxDetails {
        taxRate
        taxPercentage
        taxAmount
        taxableAmount
      }
      salesAccNumberType
      sectionDetails {
        type
        amount
      }
      sectionDetailsByQuote {
        type
        amount
      }
      sectionDetailsByAccSection {
        type
        amount
      }
    }
    quote {
      id
      name
      tenantId
      quoteType
      quoteVersion
      aiGenerationRunId
      aiGenerationStatus
      aiGenerationError
      aiGenerationStartedAt
      aiGenerationCompletedAt
      aiGeneratedByUserId
      blankQuoteType
      parentTeamId
      parentSubTeamId
      visibility
      quoteLanguage
      childFreelancers
      offlineIds
      activeFlag
      type
      mergedQuotes
      parentProjectId
      billLocation
      marginLabel
      overheadLabel
      marginAndOverheadLabel
      marginPercentage
      overheadPercentage
      exchangeRate
      localExchangeRate
      localOtNumberOfHours
      exeOtNumberOfHours
      marginVAT_rate
      marginAcc_section
      allowInternational
      freelancers
      parentCompanyId
      companyLogo
      maximizeMinimize
      provisionalColumn
      selectContactById
      clientId
      contactId
      clientName
      projectName
      agency
      agencyRepresentative
      director
      executiveProducer
      lineProducer
      numberOfShootingDays
      notes
      introduction
      shooting
      prep
      shootingCountry
      prelight
      casting
      crew
      buyouts
      locations
      studio
      artDepartment
      wardrobe
      equipment
      travel
      accommodation
      editing
      imagePostproduction
      soundPostproduction
      deliverables
      insurance
      quoteGuidelines
      excluded
      paymentTerms
      miscellaneous
      conclusion
      installment1Percentage
      installment1Date
      installment2Percentage
      installment2Date
      balancePercentage
      balanceDate
      isStarred
      isChecked
      isFinalized
      recapInfoComments
      contact
      quoteTotal {
        budgetSubTotal
        budgetGrandTotal
        budgetMargin
        budgetMarginPercentage
        budgetSeperateMargin
        budgetSeperateMarginPercentage
        budgetSeperateOverhead
        budgetSeperateOverheadPercentage
        provisionalSubTotal
        provisionalGrandTotal
        provisionalMargin
        provisionalMarginPercentage
        actualSubTotal
        actualGrandTotal
        actualMargin
        actualMarginPercentage
        purchaseSubTotal
        purchaseGrandTotal
        purchaseMargin
        purchaseMarginPercentage
        grandBudgetWithMarginTotal
        noMarginTotalPercentage
        subTotalBudgetWithMargin
        subTotalBudgetWithoutMargin
        subTotalBudgetWithMarginPercentage
      }
      quoteTotalDiscount {
        totalAfterDiscount
        totalDiscount
        budgetTotalDiscountOnMargin
        budgetTotalDiscountOnMarginPercentage
        budgetTotalDiscountPercentage
        provisionalTotalDiscountOnMargin
        provisionalTotalDiscountOnMarginPercentage
        provisionalTotalDiscountPercentage
        actualTotalDiscountOnMargin
        actualTotalDiscountOnMarginPercentage
        actualTotalDiscountPercentage
        purchaseTotalDiscountOnMargin
        purchaseTotalDiscountOnMarginPercentage
        purchaseTotalDiscountPercentage
      }
      discount {
        totalDiscount
        totalAfterDiscount
        totalDiscountOnMargin
        totalDiscountOnMarginPercentage
        totalDiscountPercentage
      }
      quoteNumber
      quoteAccountingCategory
      deliveryDate
      quoteTertiaryCategory
      exeLocation
      advertiserJobID
      brand
      jobName
      agencyJobID
      product
      advertiser
      productionJobID
      advertiserAddress
      productionCompany
      productionContact
      vfxCo
      vfxProducer
      editorialCo
      editorialProducer
      musicCo
      musicProducer
      agencyProducer
      agencyCreativeTeam
      prepDays
      buildAndStrikeDays
      preLight
      stageDays
      locationDays
      description
      service
      scope
      vhr
      billingAddress
      dateOfShoot
      photographer
      jobNumber
      photoLocation
      quoteProdValue1
      quoteProdValue2
      quoteProdValue3
      quoteProdValue4
      quoteProdValue5
      quoteProdValue6
      quoteProdValue7
      quoteProdValue8
      quoteProdValue9
      quoteProdValue10
      quoteProdValue11
      quoteProdValue12
      quoteProdValue13
      quoteProdValue14
      quoteProdValue15
      quoteProdValue16
      quoteProdValue17
      quoteProdValue18
      quoteProdValue19
      quoteProdValue20
      quoteProdValue21
      quoteProdValue22
      quoteProdValue23
      quoteProdValue24
      quoteProdValue25
      termsType
      termsSelection
      quoteCurrency
      exeQuoteCurrency
      marginCustomization
      pdfColumnCustomization
      pdfMiscCustomization
      summaryTableCustomization
      quoteHeaderLabel1
      quoteHeaderValue1
      quoteHeaderLabel2
      quoteHeaderValue2
      quoteHeaderLabel3
      quoteHeaderValue3
      quoteHeaderLabel4
      quoteHeaderValue4
      quoteHeaderLabel5
      quoteHeaderValue5
      quoteHeaderLabel6
      quoteHeaderValue6
      quoteHeaderLabel7
      quoteHeaderValue7
      quoteHeaderLabel8
      quoteHeaderValue8
      quoteHeaderLabel9
      quoteHeaderValue9
      quoteHeaderLabel10
      quoteHeaderValue10
      quoteHeaderLabel11
      quoteHeaderValue11
      productionNoteLabels
      budgetSections
      showCo2InSummary
      showCo2InPdf
      numberOfPrepDaysCo2
      numberOfShootDaysCo2
      numberOfPeopleOnSetCo2
      enableTravelCo2
      travelTypeCo2
      percentageOfCrewTravelCo2
      travelTypeLocation2Co2
      percentageOfCrewTravelLocation2Co2
      overtimeHours1Rate
      overtimeHours2Rate
      overtimeHours3Rate
      overtimeHours4Rate
      assignedTenantId
      assignedTenantName
      isExpired
      filledCostlineDetails {
        totalBudget
        totalCrewBudget
        totalPostProdBudget
        crewPrepNumberOfDays
        crewShootNumberOfDays
      }
      proposals {
        items {
          id
          tenantId
          activeFlag
          quoteId
          quoteType
          clientId
          contactId
          status
          noofInvoices
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientTaxType
          clientName
          contactName
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          paymentTerms
          total
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          proposalsBankProfileName
          proposalsBank
          proposalsIban
          proposalsBic
          proposalsAccountName
          createdOn
          updatedOn
          poDate
          poName
          poAmount
          poCurrency
          poNotes
          poVersion
          prevStatus
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          _deleted
          _version
          _lastChangedAt
        }
        nextToken
      }
      createdOn
      updatedOn
      _deleted
      _version
      _lastChangedAt
    }
    invoices {
      items {
        id
        tenantId
        proposalId
        quoteType
        activeFlag
        originalInvoiceId
        creditInvoiceGenerated
        archivedDate
        paidDate
        paymentStatus
        quoteName
        quoteNumber
        projectName
        projectNumber
        clientId
        contactId
        clientName
        contactName
        clientTaxType
        clientEmail
        clientAddress
        clientCountry
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        title
        invoiceNumber
        poNumber
        invoiceAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        clientNote
        isDetailed
        isClientTaxRate
        bankProfileNumber
        invoicesBankProfileName
        invoicesBank
        invoicesIban
        invoicesBic
        invoicesAccountName
        invoiceDate
        invoiceDueDate
        description
        creditComments
        invoiceType
        proposalsDraft {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
          salesAccNumberType
        }
        taxDetails {
          taxRate
          taxPercentage
          taxAmount
          taxableAmount
        }
        salesAccNumberType
        sectionDetails {
          type
          amount
        }
        sectionDetailsByQuote {
          type
          amount
        }
        sectionDetailsByAccSection {
          type
          amount
        }
        proposals {
          id
          tenantId
          activeFlag
          quoteId
          quoteType
          clientId
          contactId
          status
          noofInvoices
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientTaxType
          clientName
          contactName
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          paymentTerms
          total
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          proposalsBankProfileName
          proposalsBank
          proposalsIban
          proposalsBic
          proposalsAccountName
          createdOn
          updatedOn
          poDate
          poName
          poAmount
          poCurrency
          poNotes
          poVersion
          prevStatus
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          _deleted
          _version
          _lastChangedAt
        }
        createdOn
        updatedOn
        uniqueTransactionId
        assignedTenantId
        assignedTenantName
        showBidLetter
        companyLogo
        lastExportedDate
        emailSent
        draftEmailData {
          toEmail
          toCC
          toBCC
          subject
          body
          template
        }
        emailHistory {
          date
          subject
        }
        billitInboxItemId
        billitPeppolStatus
        billitPeppolError
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    createdOn
    updatedOn
    poDate
    poName
    poAmount
    poCurrency
    poNotes
    poDocuments {
      bucket
      region
      key
      identityId
    }
    poVersion
    prevStatus
    assignedTenantId
    assignedTenantName
    showBidLetter
    companyLogo
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedMutation<
	APITypes.DeleteProposalsMutationVariables,
	APITypes.DeleteProposalsMutation
>
export const createPurchase = /* GraphQL */ `mutation CreatePurchase(
  $input: CreatePurchaseInput!
  $condition: ModelPurchaseConditionInput
) {
  createPurchase(input: $input, condition: $condition) {
    id
    tenantId
    activeFlag
    quoteId
    supplierId
    recapCostlineId
    quoteName
    projectName
    supplierName
    recapCostlineItem
    recapCostlineItem_fr
    currency
    provisionalTotal
    invoiceTotal
    taxAmount
    purchaseInvoiceDueDate
    purchaseArchivedDate
    purchasePaidDate
    supplierCreditorAccount
    purchaseOrderId
    poAvailable
    invoiceAvailable
    paymentStatus
    purchaseType
    supplierType
    invoiceKey
    tags
    invoiceDocuments {
      bucket
      region
      key
      identityId
    }
    quoteNumber
    projectNumber
    invoiceNumber
    purchaseToPayDate
    purchaseNumber
    purchaseOrderNumber
    projectId
    supplierTerms
    quantity
    number
    rate
    taxRate
    deliveryDate
    deliveryAddress
    poComments
    poGenerated
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedMutation<
	APITypes.CreatePurchaseMutationVariables,
	APITypes.CreatePurchaseMutation
>
export const updatePurchase = /* GraphQL */ `mutation UpdatePurchase(
  $input: UpdatePurchaseInput!
  $condition: ModelPurchaseConditionInput
) {
  updatePurchase(input: $input, condition: $condition) {
    id
    tenantId
    activeFlag
    quoteId
    supplierId
    recapCostlineId
    quoteName
    projectName
    supplierName
    recapCostlineItem
    recapCostlineItem_fr
    currency
    provisionalTotal
    invoiceTotal
    taxAmount
    purchaseInvoiceDueDate
    purchaseArchivedDate
    purchasePaidDate
    supplierCreditorAccount
    purchaseOrderId
    poAvailable
    invoiceAvailable
    paymentStatus
    purchaseType
    supplierType
    invoiceKey
    tags
    invoiceDocuments {
      bucket
      region
      key
      identityId
    }
    quoteNumber
    projectNumber
    invoiceNumber
    purchaseToPayDate
    purchaseNumber
    purchaseOrderNumber
    projectId
    supplierTerms
    quantity
    number
    rate
    taxRate
    deliveryDate
    deliveryAddress
    poComments
    poGenerated
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedMutation<
	APITypes.UpdatePurchaseMutationVariables,
	APITypes.UpdatePurchaseMutation
>
export const deletePurchase = /* GraphQL */ `mutation DeletePurchase(
  $input: DeletePurchaseInput!
  $condition: ModelPurchaseConditionInput
) {
  deletePurchase(input: $input, condition: $condition) {
    id
    tenantId
    activeFlag
    quoteId
    supplierId
    recapCostlineId
    quoteName
    projectName
    supplierName
    recapCostlineItem
    recapCostlineItem_fr
    currency
    provisionalTotal
    invoiceTotal
    taxAmount
    purchaseInvoiceDueDate
    purchaseArchivedDate
    purchasePaidDate
    supplierCreditorAccount
    purchaseOrderId
    poAvailable
    invoiceAvailable
    paymentStatus
    purchaseType
    supplierType
    invoiceKey
    tags
    invoiceDocuments {
      bucket
      region
      key
      identityId
    }
    quoteNumber
    projectNumber
    invoiceNumber
    purchaseToPayDate
    purchaseNumber
    purchaseOrderNumber
    projectId
    supplierTerms
    quantity
    number
    rate
    taxRate
    deliveryDate
    deliveryAddress
    poComments
    poGenerated
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedMutation<
	APITypes.DeletePurchaseMutationVariables,
	APITypes.DeletePurchaseMutation
>
export const createPurchaseOrder = /* GraphQL */ `mutation CreatePurchaseOrder(
  $input: CreatePurchaseOrderInput!
  $condition: ModelPurchaseOrderConditionInput
) {
  createPurchaseOrder(input: $input, condition: $condition) {
    id
    tenantId
    activeFlag
    purchaseOrderNumber
    quoteId
    supplierId
    recapCostlineId
    costlineName
    costlineName_fr
    projectId
    quoteNumber
    poAvailable
    supplierName
    supplierTerms
    quantity
    number
    rate
    provisionalTotal
    taxRate
    deliveryDate
    deliveryAddress
    comments
    status
    generated
    _deleted
    _version
    _lastChangedAt
    createdOn
    updatedOn
  }
}
` as GeneratedMutation<
	APITypes.CreatePurchaseOrderMutationVariables,
	APITypes.CreatePurchaseOrderMutation
>
export const updatePurchaseOrder = /* GraphQL */ `mutation UpdatePurchaseOrder(
  $input: UpdatePurchaseOrderInput!
  $condition: ModelPurchaseOrderConditionInput
) {
  updatePurchaseOrder(input: $input, condition: $condition) {
    id
    tenantId
    activeFlag
    purchaseOrderNumber
    quoteId
    supplierId
    recapCostlineId
    costlineName
    costlineName_fr
    projectId
    quoteNumber
    poAvailable
    supplierName
    supplierTerms
    quantity
    number
    rate
    provisionalTotal
    taxRate
    deliveryDate
    deliveryAddress
    comments
    status
    generated
    _deleted
    _version
    _lastChangedAt
    createdOn
    updatedOn
  }
}
` as GeneratedMutation<
	APITypes.UpdatePurchaseOrderMutationVariables,
	APITypes.UpdatePurchaseOrderMutation
>
export const deletePurchaseOrder = /* GraphQL */ `mutation DeletePurchaseOrder(
  $input: DeletePurchaseOrderInput!
  $condition: ModelPurchaseOrderConditionInput
) {
  deletePurchaseOrder(input: $input, condition: $condition) {
    id
    tenantId
    activeFlag
    purchaseOrderNumber
    quoteId
    supplierId
    recapCostlineId
    costlineName
    costlineName_fr
    projectId
    quoteNumber
    poAvailable
    supplierName
    supplierTerms
    quantity
    number
    rate
    provisionalTotal
    taxRate
    deliveryDate
    deliveryAddress
    comments
    status
    generated
    _deleted
    _version
    _lastChangedAt
    createdOn
    updatedOn
  }
}
` as GeneratedMutation<
	APITypes.DeletePurchaseOrderMutationVariables,
	APITypes.DeletePurchaseOrderMutation
>
export const createQuote = /* GraphQL */ `mutation CreateQuote(
  $input: CreateQuoteInput!
  $condition: ModelQuoteConditionInput
) {
  createQuote(input: $input, condition: $condition) {
    id
    name
    tenantId
    quoteType
    quoteVersion
    aiGenerationRunId
    aiGenerationStatus
    aiGenerationError
    aiGenerationStartedAt
    aiGenerationCompletedAt
    aiGeneratedByUserId
    blankQuoteType
    parentTeamId
    parentSubTeamId
    visibility
    quoteLanguage
    childFreelancers
    offlineIds
    activeFlag
    type
    mergedQuotes
    parentProjectId
    billLocation
    marginLabel
    overheadLabel
    marginAndOverheadLabel
    marginPercentage
    overheadPercentage
    exchangeRate
    localExchangeRate
    localOtNumberOfHours
    exeOtNumberOfHours
    marginVAT_rate
    marginAcc_section
    allowInternational
    freelancers
    parentCompanyId
    companyLogo
    maximizeMinimize
    provisionalColumn
    selectContactById
    clientId
    contactId
    clientName
    projectName
    agency
    agencyRepresentative
    director
    executiveProducer
    lineProducer
    numberOfShootingDays
    notes
    introduction
    shooting
    prep
    shootingCountry
    prelight
    casting
    crew
    buyouts
    locations
    studio
    artDepartment
    wardrobe
    equipment
    travel
    accommodation
    editing
    imagePostproduction
    soundPostproduction
    deliverables
    insurance
    quoteGuidelines
    excluded
    paymentTerms
    miscellaneous
    conclusion
    installment1Percentage
    installment1Date
    installment2Percentage
    installment2Date
    balancePercentage
    balanceDate
    isStarred
    isChecked
    isFinalized
    recapInfoComments
    contact
    quoteTotal {
      budgetSubTotal
      budgetGrandTotal
      budgetMargin
      budgetMarginPercentage
      budgetSeperateMargin
      budgetSeperateMarginPercentage
      budgetSeperateOverhead
      budgetSeperateOverheadPercentage
      provisionalSubTotal
      provisionalGrandTotal
      provisionalMargin
      provisionalMarginPercentage
      actualSubTotal
      actualGrandTotal
      actualMargin
      actualMarginPercentage
      purchaseSubTotal
      purchaseGrandTotal
      purchaseMargin
      purchaseMarginPercentage
      grandBudgetWithMarginTotal
      noMarginTotalPercentage
      subTotalBudgetWithMargin
      subTotalBudgetWithoutMargin
      subTotalBudgetWithMarginPercentage
    }
    quoteTotalDiscount {
      totalAfterDiscount
      totalDiscount
      budgetTotalDiscountOnMargin
      budgetTotalDiscountOnMarginPercentage
      budgetTotalDiscountPercentage
      provisionalTotalDiscountOnMargin
      provisionalTotalDiscountOnMarginPercentage
      provisionalTotalDiscountPercentage
      actualTotalDiscountOnMargin
      actualTotalDiscountOnMarginPercentage
      actualTotalDiscountPercentage
      purchaseTotalDiscountOnMargin
      purchaseTotalDiscountOnMarginPercentage
      purchaseTotalDiscountPercentage
    }
    discount {
      totalDiscount
      totalAfterDiscount
      totalDiscountOnMargin
      totalDiscountOnMarginPercentage
      totalDiscountPercentage
    }
    quoteNumber
    quoteAccountingCategory
    deliveryDate
    quoteTertiaryCategory
    exeLocation
    advertiserJobID
    brand
    jobName
    agencyJobID
    product
    advertiser
    productionJobID
    advertiserAddress
    productionCompany
    productionContact
    vfxCo
    vfxProducer
    editorialCo
    editorialProducer
    musicCo
    musicProducer
    agencyProducer
    agencyCreativeTeam
    prepDays
    buildAndStrikeDays
    preLight
    stageDays
    locationDays
    description
    service
    scope
    vhr
    billingAddress
    dateOfShoot
    photographer
    jobNumber
    photoLocation
    quoteProdValue1
    quoteProdValue2
    quoteProdValue3
    quoteProdValue4
    quoteProdValue5
    quoteProdValue6
    quoteProdValue7
    quoteProdValue8
    quoteProdValue9
    quoteProdValue10
    quoteProdValue11
    quoteProdValue12
    quoteProdValue13
    quoteProdValue14
    quoteProdValue15
    quoteProdValue16
    quoteProdValue17
    quoteProdValue18
    quoteProdValue19
    quoteProdValue20
    quoteProdValue21
    quoteProdValue22
    quoteProdValue23
    quoteProdValue24
    quoteProdValue25
    termsType
    termsSelection
    quoteCurrency
    exeQuoteCurrency
    marginCustomization
    pdfColumnCustomization
    pdfMiscCustomization
    summaryTableCustomization
    quoteHeaderLabel1
    quoteHeaderValue1
    quoteHeaderLabel2
    quoteHeaderValue2
    quoteHeaderLabel3
    quoteHeaderValue3
    quoteHeaderLabel4
    quoteHeaderValue4
    quoteHeaderLabel5
    quoteHeaderValue5
    quoteHeaderLabel6
    quoteHeaderValue6
    quoteHeaderLabel7
    quoteHeaderValue7
    quoteHeaderLabel8
    quoteHeaderValue8
    quoteHeaderLabel9
    quoteHeaderValue9
    quoteHeaderLabel10
    quoteHeaderValue10
    quoteHeaderLabel11
    quoteHeaderValue11
    productionNoteLabels
    budgetSections
    showCo2InSummary
    showCo2InPdf
    numberOfPrepDaysCo2
    numberOfShootDaysCo2
    numberOfPeopleOnSetCo2
    enableTravelCo2
    travelTypeCo2
    percentageOfCrewTravelCo2
    travelTypeLocation2Co2
    percentageOfCrewTravelLocation2Co2
    overtimeHours1Rate
    overtimeHours2Rate
    overtimeHours3Rate
    overtimeHours4Rate
    assignedTenantId
    assignedTenantName
    isExpired
    filledCostlineDetails {
      totalBudget
      totalCrewBudget
      totalPostProdBudget
      crewPrepNumberOfDays
      crewShootNumberOfDays
    }
    proposals {
      items {
        id
        tenantId
        activeFlag
        quoteId
        quoteType
        clientId
        contactId
        status
        noofInvoices
        quoteName
        quoteNumber
        projectName
        projectNumber
        clientTaxType
        clientName
        contactName
        clientEmail
        clientAddress
        clientCountry
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        paymentTerms
        total
        clientNote
        isDetailed
        isClientTaxRate
        bankProfileNumber
        proposalsBankProfileName
        proposalsBank
        proposalsIban
        proposalsBic
        proposalsAccountName
        drafts {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
          salesAccNumberType
        }
        quote {
          id
          name
          tenantId
          quoteType
          quoteVersion
          aiGenerationRunId
          aiGenerationStatus
          aiGenerationError
          aiGenerationStartedAt
          aiGenerationCompletedAt
          aiGeneratedByUserId
          blankQuoteType
          parentTeamId
          parentSubTeamId
          visibility
          quoteLanguage
          childFreelancers
          offlineIds
          activeFlag
          type
          mergedQuotes
          parentProjectId
          billLocation
          marginLabel
          overheadLabel
          marginAndOverheadLabel
          marginPercentage
          overheadPercentage
          exchangeRate
          localExchangeRate
          localOtNumberOfHours
          exeOtNumberOfHours
          marginVAT_rate
          marginAcc_section
          allowInternational
          freelancers
          parentCompanyId
          companyLogo
          maximizeMinimize
          provisionalColumn
          selectContactById
          clientId
          contactId
          clientName
          projectName
          agency
          agencyRepresentative
          director
          executiveProducer
          lineProducer
          numberOfShootingDays
          notes
          introduction
          shooting
          prep
          shootingCountry
          prelight
          casting
          crew
          buyouts
          locations
          studio
          artDepartment
          wardrobe
          equipment
          travel
          accommodation
          editing
          imagePostproduction
          soundPostproduction
          deliverables
          insurance
          quoteGuidelines
          excluded
          paymentTerms
          miscellaneous
          conclusion
          installment1Percentage
          installment1Date
          installment2Percentage
          installment2Date
          balancePercentage
          balanceDate
          isStarred
          isChecked
          isFinalized
          recapInfoComments
          contact
          quoteNumber
          quoteAccountingCategory
          deliveryDate
          quoteTertiaryCategory
          exeLocation
          advertiserJobID
          brand
          jobName
          agencyJobID
          product
          advertiser
          productionJobID
          advertiserAddress
          productionCompany
          productionContact
          vfxCo
          vfxProducer
          editorialCo
          editorialProducer
          musicCo
          musicProducer
          agencyProducer
          agencyCreativeTeam
          prepDays
          buildAndStrikeDays
          preLight
          stageDays
          locationDays
          description
          service
          scope
          vhr
          billingAddress
          dateOfShoot
          photographer
          jobNumber
          photoLocation
          quoteProdValue1
          quoteProdValue2
          quoteProdValue3
          quoteProdValue4
          quoteProdValue5
          quoteProdValue6
          quoteProdValue7
          quoteProdValue8
          quoteProdValue9
          quoteProdValue10
          quoteProdValue11
          quoteProdValue12
          quoteProdValue13
          quoteProdValue14
          quoteProdValue15
          quoteProdValue16
          quoteProdValue17
          quoteProdValue18
          quoteProdValue19
          quoteProdValue20
          quoteProdValue21
          quoteProdValue22
          quoteProdValue23
          quoteProdValue24
          quoteProdValue25
          termsType
          termsSelection
          quoteCurrency
          exeQuoteCurrency
          marginCustomization
          pdfColumnCustomization
          pdfMiscCustomization
          summaryTableCustomization
          quoteHeaderLabel1
          quoteHeaderValue1
          quoteHeaderLabel2
          quoteHeaderValue2
          quoteHeaderLabel3
          quoteHeaderValue3
          quoteHeaderLabel4
          quoteHeaderValue4
          quoteHeaderLabel5
          quoteHeaderValue5
          quoteHeaderLabel6
          quoteHeaderValue6
          quoteHeaderLabel7
          quoteHeaderValue7
          quoteHeaderLabel8
          quoteHeaderValue8
          quoteHeaderLabel9
          quoteHeaderValue9
          quoteHeaderLabel10
          quoteHeaderValue10
          quoteHeaderLabel11
          quoteHeaderValue11
          productionNoteLabels
          budgetSections
          showCo2InSummary
          showCo2InPdf
          numberOfPrepDaysCo2
          numberOfShootDaysCo2
          numberOfPeopleOnSetCo2
          enableTravelCo2
          travelTypeCo2
          percentageOfCrewTravelCo2
          travelTypeLocation2Co2
          percentageOfCrewTravelLocation2Co2
          overtimeHours1Rate
          overtimeHours2Rate
          overtimeHours3Rate
          overtimeHours4Rate
          assignedTenantId
          assignedTenantName
          isExpired
          createdOn
          updatedOn
          _deleted
          _version
          _lastChangedAt
        }
        invoices {
          nextToken
        }
        createdOn
        updatedOn
        poDate
        poName
        poAmount
        poCurrency
        poNotes
        poDocuments {
          bucket
          region
          key
          identityId
        }
        poVersion
        prevStatus
        assignedTenantId
        assignedTenantName
        showBidLetter
        companyLogo
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedMutation<
	APITypes.CreateQuoteMutationVariables,
	APITypes.CreateQuoteMutation
>
export const updateQuote = /* GraphQL */ `mutation UpdateQuote(
  $input: UpdateQuoteInput!
  $condition: ModelQuoteConditionInput
) {
  updateQuote(input: $input, condition: $condition) {
    id
    name
    tenantId
    quoteType
    quoteVersion
    aiGenerationRunId
    aiGenerationStatus
    aiGenerationError
    aiGenerationStartedAt
    aiGenerationCompletedAt
    aiGeneratedByUserId
    blankQuoteType
    parentTeamId
    parentSubTeamId
    visibility
    quoteLanguage
    childFreelancers
    offlineIds
    activeFlag
    type
    mergedQuotes
    parentProjectId
    billLocation
    marginLabel
    overheadLabel
    marginAndOverheadLabel
    marginPercentage
    overheadPercentage
    exchangeRate
    localExchangeRate
    localOtNumberOfHours
    exeOtNumberOfHours
    marginVAT_rate
    marginAcc_section
    allowInternational
    freelancers
    parentCompanyId
    companyLogo
    maximizeMinimize
    provisionalColumn
    selectContactById
    clientId
    contactId
    clientName
    projectName
    agency
    agencyRepresentative
    director
    executiveProducer
    lineProducer
    numberOfShootingDays
    notes
    introduction
    shooting
    prep
    shootingCountry
    prelight
    casting
    crew
    buyouts
    locations
    studio
    artDepartment
    wardrobe
    equipment
    travel
    accommodation
    editing
    imagePostproduction
    soundPostproduction
    deliverables
    insurance
    quoteGuidelines
    excluded
    paymentTerms
    miscellaneous
    conclusion
    installment1Percentage
    installment1Date
    installment2Percentage
    installment2Date
    balancePercentage
    balanceDate
    isStarred
    isChecked
    isFinalized
    recapInfoComments
    contact
    quoteTotal {
      budgetSubTotal
      budgetGrandTotal
      budgetMargin
      budgetMarginPercentage
      budgetSeperateMargin
      budgetSeperateMarginPercentage
      budgetSeperateOverhead
      budgetSeperateOverheadPercentage
      provisionalSubTotal
      provisionalGrandTotal
      provisionalMargin
      provisionalMarginPercentage
      actualSubTotal
      actualGrandTotal
      actualMargin
      actualMarginPercentage
      purchaseSubTotal
      purchaseGrandTotal
      purchaseMargin
      purchaseMarginPercentage
      grandBudgetWithMarginTotal
      noMarginTotalPercentage
      subTotalBudgetWithMargin
      subTotalBudgetWithoutMargin
      subTotalBudgetWithMarginPercentage
    }
    quoteTotalDiscount {
      totalAfterDiscount
      totalDiscount
      budgetTotalDiscountOnMargin
      budgetTotalDiscountOnMarginPercentage
      budgetTotalDiscountPercentage
      provisionalTotalDiscountOnMargin
      provisionalTotalDiscountOnMarginPercentage
      provisionalTotalDiscountPercentage
      actualTotalDiscountOnMargin
      actualTotalDiscountOnMarginPercentage
      actualTotalDiscountPercentage
      purchaseTotalDiscountOnMargin
      purchaseTotalDiscountOnMarginPercentage
      purchaseTotalDiscountPercentage
    }
    discount {
      totalDiscount
      totalAfterDiscount
      totalDiscountOnMargin
      totalDiscountOnMarginPercentage
      totalDiscountPercentage
    }
    quoteNumber
    quoteAccountingCategory
    deliveryDate
    quoteTertiaryCategory
    exeLocation
    advertiserJobID
    brand
    jobName
    agencyJobID
    product
    advertiser
    productionJobID
    advertiserAddress
    productionCompany
    productionContact
    vfxCo
    vfxProducer
    editorialCo
    editorialProducer
    musicCo
    musicProducer
    agencyProducer
    agencyCreativeTeam
    prepDays
    buildAndStrikeDays
    preLight
    stageDays
    locationDays
    description
    service
    scope
    vhr
    billingAddress
    dateOfShoot
    photographer
    jobNumber
    photoLocation
    quoteProdValue1
    quoteProdValue2
    quoteProdValue3
    quoteProdValue4
    quoteProdValue5
    quoteProdValue6
    quoteProdValue7
    quoteProdValue8
    quoteProdValue9
    quoteProdValue10
    quoteProdValue11
    quoteProdValue12
    quoteProdValue13
    quoteProdValue14
    quoteProdValue15
    quoteProdValue16
    quoteProdValue17
    quoteProdValue18
    quoteProdValue19
    quoteProdValue20
    quoteProdValue21
    quoteProdValue22
    quoteProdValue23
    quoteProdValue24
    quoteProdValue25
    termsType
    termsSelection
    quoteCurrency
    exeQuoteCurrency
    marginCustomization
    pdfColumnCustomization
    pdfMiscCustomization
    summaryTableCustomization
    quoteHeaderLabel1
    quoteHeaderValue1
    quoteHeaderLabel2
    quoteHeaderValue2
    quoteHeaderLabel3
    quoteHeaderValue3
    quoteHeaderLabel4
    quoteHeaderValue4
    quoteHeaderLabel5
    quoteHeaderValue5
    quoteHeaderLabel6
    quoteHeaderValue6
    quoteHeaderLabel7
    quoteHeaderValue7
    quoteHeaderLabel8
    quoteHeaderValue8
    quoteHeaderLabel9
    quoteHeaderValue9
    quoteHeaderLabel10
    quoteHeaderValue10
    quoteHeaderLabel11
    quoteHeaderValue11
    productionNoteLabels
    budgetSections
    showCo2InSummary
    showCo2InPdf
    numberOfPrepDaysCo2
    numberOfShootDaysCo2
    numberOfPeopleOnSetCo2
    enableTravelCo2
    travelTypeCo2
    percentageOfCrewTravelCo2
    travelTypeLocation2Co2
    percentageOfCrewTravelLocation2Co2
    overtimeHours1Rate
    overtimeHours2Rate
    overtimeHours3Rate
    overtimeHours4Rate
    assignedTenantId
    assignedTenantName
    isExpired
    filledCostlineDetails {
      totalBudget
      totalCrewBudget
      totalPostProdBudget
      crewPrepNumberOfDays
      crewShootNumberOfDays
    }
    proposals {
      items {
        id
        tenantId
        activeFlag
        quoteId
        quoteType
        clientId
        contactId
        status
        noofInvoices
        quoteName
        quoteNumber
        projectName
        projectNumber
        clientTaxType
        clientName
        contactName
        clientEmail
        clientAddress
        clientCountry
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        paymentTerms
        total
        clientNote
        isDetailed
        isClientTaxRate
        bankProfileNumber
        proposalsBankProfileName
        proposalsBank
        proposalsIban
        proposalsBic
        proposalsAccountName
        drafts {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
          salesAccNumberType
        }
        quote {
          id
          name
          tenantId
          quoteType
          quoteVersion
          aiGenerationRunId
          aiGenerationStatus
          aiGenerationError
          aiGenerationStartedAt
          aiGenerationCompletedAt
          aiGeneratedByUserId
          blankQuoteType
          parentTeamId
          parentSubTeamId
          visibility
          quoteLanguage
          childFreelancers
          offlineIds
          activeFlag
          type
          mergedQuotes
          parentProjectId
          billLocation
          marginLabel
          overheadLabel
          marginAndOverheadLabel
          marginPercentage
          overheadPercentage
          exchangeRate
          localExchangeRate
          localOtNumberOfHours
          exeOtNumberOfHours
          marginVAT_rate
          marginAcc_section
          allowInternational
          freelancers
          parentCompanyId
          companyLogo
          maximizeMinimize
          provisionalColumn
          selectContactById
          clientId
          contactId
          clientName
          projectName
          agency
          agencyRepresentative
          director
          executiveProducer
          lineProducer
          numberOfShootingDays
          notes
          introduction
          shooting
          prep
          shootingCountry
          prelight
          casting
          crew
          buyouts
          locations
          studio
          artDepartment
          wardrobe
          equipment
          travel
          accommodation
          editing
          imagePostproduction
          soundPostproduction
          deliverables
          insurance
          quoteGuidelines
          excluded
          paymentTerms
          miscellaneous
          conclusion
          installment1Percentage
          installment1Date
          installment2Percentage
          installment2Date
          balancePercentage
          balanceDate
          isStarred
          isChecked
          isFinalized
          recapInfoComments
          contact
          quoteNumber
          quoteAccountingCategory
          deliveryDate
          quoteTertiaryCategory
          exeLocation
          advertiserJobID
          brand
          jobName
          agencyJobID
          product
          advertiser
          productionJobID
          advertiserAddress
          productionCompany
          productionContact
          vfxCo
          vfxProducer
          editorialCo
          editorialProducer
          musicCo
          musicProducer
          agencyProducer
          agencyCreativeTeam
          prepDays
          buildAndStrikeDays
          preLight
          stageDays
          locationDays
          description
          service
          scope
          vhr
          billingAddress
          dateOfShoot
          photographer
          jobNumber
          photoLocation
          quoteProdValue1
          quoteProdValue2
          quoteProdValue3
          quoteProdValue4
          quoteProdValue5
          quoteProdValue6
          quoteProdValue7
          quoteProdValue8
          quoteProdValue9
          quoteProdValue10
          quoteProdValue11
          quoteProdValue12
          quoteProdValue13
          quoteProdValue14
          quoteProdValue15
          quoteProdValue16
          quoteProdValue17
          quoteProdValue18
          quoteProdValue19
          quoteProdValue20
          quoteProdValue21
          quoteProdValue22
          quoteProdValue23
          quoteProdValue24
          quoteProdValue25
          termsType
          termsSelection
          quoteCurrency
          exeQuoteCurrency
          marginCustomization
          pdfColumnCustomization
          pdfMiscCustomization
          summaryTableCustomization
          quoteHeaderLabel1
          quoteHeaderValue1
          quoteHeaderLabel2
          quoteHeaderValue2
          quoteHeaderLabel3
          quoteHeaderValue3
          quoteHeaderLabel4
          quoteHeaderValue4
          quoteHeaderLabel5
          quoteHeaderValue5
          quoteHeaderLabel6
          quoteHeaderValue6
          quoteHeaderLabel7
          quoteHeaderValue7
          quoteHeaderLabel8
          quoteHeaderValue8
          quoteHeaderLabel9
          quoteHeaderValue9
          quoteHeaderLabel10
          quoteHeaderValue10
          quoteHeaderLabel11
          quoteHeaderValue11
          productionNoteLabels
          budgetSections
          showCo2InSummary
          showCo2InPdf
          numberOfPrepDaysCo2
          numberOfShootDaysCo2
          numberOfPeopleOnSetCo2
          enableTravelCo2
          travelTypeCo2
          percentageOfCrewTravelCo2
          travelTypeLocation2Co2
          percentageOfCrewTravelLocation2Co2
          overtimeHours1Rate
          overtimeHours2Rate
          overtimeHours3Rate
          overtimeHours4Rate
          assignedTenantId
          assignedTenantName
          isExpired
          createdOn
          updatedOn
          _deleted
          _version
          _lastChangedAt
        }
        invoices {
          nextToken
        }
        createdOn
        updatedOn
        poDate
        poName
        poAmount
        poCurrency
        poNotes
        poDocuments {
          bucket
          region
          key
          identityId
        }
        poVersion
        prevStatus
        assignedTenantId
        assignedTenantName
        showBidLetter
        companyLogo
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedMutation<
	APITypes.UpdateQuoteMutationVariables,
	APITypes.UpdateQuoteMutation
>
export const deleteQuote = /* GraphQL */ `mutation DeleteQuote(
  $input: DeleteQuoteInput!
  $condition: ModelQuoteConditionInput
) {
  deleteQuote(input: $input, condition: $condition) {
    id
    name
    tenantId
    quoteType
    quoteVersion
    aiGenerationRunId
    aiGenerationStatus
    aiGenerationError
    aiGenerationStartedAt
    aiGenerationCompletedAt
    aiGeneratedByUserId
    blankQuoteType
    parentTeamId
    parentSubTeamId
    visibility
    quoteLanguage
    childFreelancers
    offlineIds
    activeFlag
    type
    mergedQuotes
    parentProjectId
    billLocation
    marginLabel
    overheadLabel
    marginAndOverheadLabel
    marginPercentage
    overheadPercentage
    exchangeRate
    localExchangeRate
    localOtNumberOfHours
    exeOtNumberOfHours
    marginVAT_rate
    marginAcc_section
    allowInternational
    freelancers
    parentCompanyId
    companyLogo
    maximizeMinimize
    provisionalColumn
    selectContactById
    clientId
    contactId
    clientName
    projectName
    agency
    agencyRepresentative
    director
    executiveProducer
    lineProducer
    numberOfShootingDays
    notes
    introduction
    shooting
    prep
    shootingCountry
    prelight
    casting
    crew
    buyouts
    locations
    studio
    artDepartment
    wardrobe
    equipment
    travel
    accommodation
    editing
    imagePostproduction
    soundPostproduction
    deliverables
    insurance
    quoteGuidelines
    excluded
    paymentTerms
    miscellaneous
    conclusion
    installment1Percentage
    installment1Date
    installment2Percentage
    installment2Date
    balancePercentage
    balanceDate
    isStarred
    isChecked
    isFinalized
    recapInfoComments
    contact
    quoteTotal {
      budgetSubTotal
      budgetGrandTotal
      budgetMargin
      budgetMarginPercentage
      budgetSeperateMargin
      budgetSeperateMarginPercentage
      budgetSeperateOverhead
      budgetSeperateOverheadPercentage
      provisionalSubTotal
      provisionalGrandTotal
      provisionalMargin
      provisionalMarginPercentage
      actualSubTotal
      actualGrandTotal
      actualMargin
      actualMarginPercentage
      purchaseSubTotal
      purchaseGrandTotal
      purchaseMargin
      purchaseMarginPercentage
      grandBudgetWithMarginTotal
      noMarginTotalPercentage
      subTotalBudgetWithMargin
      subTotalBudgetWithoutMargin
      subTotalBudgetWithMarginPercentage
    }
    quoteTotalDiscount {
      totalAfterDiscount
      totalDiscount
      budgetTotalDiscountOnMargin
      budgetTotalDiscountOnMarginPercentage
      budgetTotalDiscountPercentage
      provisionalTotalDiscountOnMargin
      provisionalTotalDiscountOnMarginPercentage
      provisionalTotalDiscountPercentage
      actualTotalDiscountOnMargin
      actualTotalDiscountOnMarginPercentage
      actualTotalDiscountPercentage
      purchaseTotalDiscountOnMargin
      purchaseTotalDiscountOnMarginPercentage
      purchaseTotalDiscountPercentage
    }
    discount {
      totalDiscount
      totalAfterDiscount
      totalDiscountOnMargin
      totalDiscountOnMarginPercentage
      totalDiscountPercentage
    }
    quoteNumber
    quoteAccountingCategory
    deliveryDate
    quoteTertiaryCategory
    exeLocation
    advertiserJobID
    brand
    jobName
    agencyJobID
    product
    advertiser
    productionJobID
    advertiserAddress
    productionCompany
    productionContact
    vfxCo
    vfxProducer
    editorialCo
    editorialProducer
    musicCo
    musicProducer
    agencyProducer
    agencyCreativeTeam
    prepDays
    buildAndStrikeDays
    preLight
    stageDays
    locationDays
    description
    service
    scope
    vhr
    billingAddress
    dateOfShoot
    photographer
    jobNumber
    photoLocation
    quoteProdValue1
    quoteProdValue2
    quoteProdValue3
    quoteProdValue4
    quoteProdValue5
    quoteProdValue6
    quoteProdValue7
    quoteProdValue8
    quoteProdValue9
    quoteProdValue10
    quoteProdValue11
    quoteProdValue12
    quoteProdValue13
    quoteProdValue14
    quoteProdValue15
    quoteProdValue16
    quoteProdValue17
    quoteProdValue18
    quoteProdValue19
    quoteProdValue20
    quoteProdValue21
    quoteProdValue22
    quoteProdValue23
    quoteProdValue24
    quoteProdValue25
    termsType
    termsSelection
    quoteCurrency
    exeQuoteCurrency
    marginCustomization
    pdfColumnCustomization
    pdfMiscCustomization
    summaryTableCustomization
    quoteHeaderLabel1
    quoteHeaderValue1
    quoteHeaderLabel2
    quoteHeaderValue2
    quoteHeaderLabel3
    quoteHeaderValue3
    quoteHeaderLabel4
    quoteHeaderValue4
    quoteHeaderLabel5
    quoteHeaderValue5
    quoteHeaderLabel6
    quoteHeaderValue6
    quoteHeaderLabel7
    quoteHeaderValue7
    quoteHeaderLabel8
    quoteHeaderValue8
    quoteHeaderLabel9
    quoteHeaderValue9
    quoteHeaderLabel10
    quoteHeaderValue10
    quoteHeaderLabel11
    quoteHeaderValue11
    productionNoteLabels
    budgetSections
    showCo2InSummary
    showCo2InPdf
    numberOfPrepDaysCo2
    numberOfShootDaysCo2
    numberOfPeopleOnSetCo2
    enableTravelCo2
    travelTypeCo2
    percentageOfCrewTravelCo2
    travelTypeLocation2Co2
    percentageOfCrewTravelLocation2Co2
    overtimeHours1Rate
    overtimeHours2Rate
    overtimeHours3Rate
    overtimeHours4Rate
    assignedTenantId
    assignedTenantName
    isExpired
    filledCostlineDetails {
      totalBudget
      totalCrewBudget
      totalPostProdBudget
      crewPrepNumberOfDays
      crewShootNumberOfDays
    }
    proposals {
      items {
        id
        tenantId
        activeFlag
        quoteId
        quoteType
        clientId
        contactId
        status
        noofInvoices
        quoteName
        quoteNumber
        projectName
        projectNumber
        clientTaxType
        clientName
        contactName
        clientEmail
        clientAddress
        clientCountry
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        paymentTerms
        total
        clientNote
        isDetailed
        isClientTaxRate
        bankProfileNumber
        proposalsBankProfileName
        proposalsBank
        proposalsIban
        proposalsBic
        proposalsAccountName
        drafts {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
          salesAccNumberType
        }
        quote {
          id
          name
          tenantId
          quoteType
          quoteVersion
          aiGenerationRunId
          aiGenerationStatus
          aiGenerationError
          aiGenerationStartedAt
          aiGenerationCompletedAt
          aiGeneratedByUserId
          blankQuoteType
          parentTeamId
          parentSubTeamId
          visibility
          quoteLanguage
          childFreelancers
          offlineIds
          activeFlag
          type
          mergedQuotes
          parentProjectId
          billLocation
          marginLabel
          overheadLabel
          marginAndOverheadLabel
          marginPercentage
          overheadPercentage
          exchangeRate
          localExchangeRate
          localOtNumberOfHours
          exeOtNumberOfHours
          marginVAT_rate
          marginAcc_section
          allowInternational
          freelancers
          parentCompanyId
          companyLogo
          maximizeMinimize
          provisionalColumn
          selectContactById
          clientId
          contactId
          clientName
          projectName
          agency
          agencyRepresentative
          director
          executiveProducer
          lineProducer
          numberOfShootingDays
          notes
          introduction
          shooting
          prep
          shootingCountry
          prelight
          casting
          crew
          buyouts
          locations
          studio
          artDepartment
          wardrobe
          equipment
          travel
          accommodation
          editing
          imagePostproduction
          soundPostproduction
          deliverables
          insurance
          quoteGuidelines
          excluded
          paymentTerms
          miscellaneous
          conclusion
          installment1Percentage
          installment1Date
          installment2Percentage
          installment2Date
          balancePercentage
          balanceDate
          isStarred
          isChecked
          isFinalized
          recapInfoComments
          contact
          quoteNumber
          quoteAccountingCategory
          deliveryDate
          quoteTertiaryCategory
          exeLocation
          advertiserJobID
          brand
          jobName
          agencyJobID
          product
          advertiser
          productionJobID
          advertiserAddress
          productionCompany
          productionContact
          vfxCo
          vfxProducer
          editorialCo
          editorialProducer
          musicCo
          musicProducer
          agencyProducer
          agencyCreativeTeam
          prepDays
          buildAndStrikeDays
          preLight
          stageDays
          locationDays
          description
          service
          scope
          vhr
          billingAddress
          dateOfShoot
          photographer
          jobNumber
          photoLocation
          quoteProdValue1
          quoteProdValue2
          quoteProdValue3
          quoteProdValue4
          quoteProdValue5
          quoteProdValue6
          quoteProdValue7
          quoteProdValue8
          quoteProdValue9
          quoteProdValue10
          quoteProdValue11
          quoteProdValue12
          quoteProdValue13
          quoteProdValue14
          quoteProdValue15
          quoteProdValue16
          quoteProdValue17
          quoteProdValue18
          quoteProdValue19
          quoteProdValue20
          quoteProdValue21
          quoteProdValue22
          quoteProdValue23
          quoteProdValue24
          quoteProdValue25
          termsType
          termsSelection
          quoteCurrency
          exeQuoteCurrency
          marginCustomization
          pdfColumnCustomization
          pdfMiscCustomization
          summaryTableCustomization
          quoteHeaderLabel1
          quoteHeaderValue1
          quoteHeaderLabel2
          quoteHeaderValue2
          quoteHeaderLabel3
          quoteHeaderValue3
          quoteHeaderLabel4
          quoteHeaderValue4
          quoteHeaderLabel5
          quoteHeaderValue5
          quoteHeaderLabel6
          quoteHeaderValue6
          quoteHeaderLabel7
          quoteHeaderValue7
          quoteHeaderLabel8
          quoteHeaderValue8
          quoteHeaderLabel9
          quoteHeaderValue9
          quoteHeaderLabel10
          quoteHeaderValue10
          quoteHeaderLabel11
          quoteHeaderValue11
          productionNoteLabels
          budgetSections
          showCo2InSummary
          showCo2InPdf
          numberOfPrepDaysCo2
          numberOfShootDaysCo2
          numberOfPeopleOnSetCo2
          enableTravelCo2
          travelTypeCo2
          percentageOfCrewTravelCo2
          travelTypeLocation2Co2
          percentageOfCrewTravelLocation2Co2
          overtimeHours1Rate
          overtimeHours2Rate
          overtimeHours3Rate
          overtimeHours4Rate
          assignedTenantId
          assignedTenantName
          isExpired
          createdOn
          updatedOn
          _deleted
          _version
          _lastChangedAt
        }
        invoices {
          nextToken
        }
        createdOn
        updatedOn
        poDate
        poName
        poAmount
        poCurrency
        poNotes
        poDocuments {
          bucket
          region
          key
          identityId
        }
        poVersion
        prevStatus
        assignedTenantId
        assignedTenantName
        showBidLetter
        companyLogo
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedMutation<
	APITypes.DeleteQuoteMutationVariables,
	APITypes.DeleteQuoteMutation
>
export const createQuoteInfo = /* GraphQL */ `mutation CreateQuoteInfo(
  $input: CreateQuoteInfoInput!
  $condition: ModelQuoteInfoConditionInput
) {
  createQuoteInfo(input: $input, condition: $condition) {
    id
    quoteId
    tenantId
    originalQuoteId
    freelancers
    childFreelancers
    offlineIds
    activeFlag
    agentCommission
    agentCommissionPercentage
    allowMarginAndOverheadPercentageGlobalUpdate
    language
    costlineUuid
    category
    categoryId
    categoryPrefix
    category_fr
    categoryUuid
    categoryLabelValue
    costLineLabel
    costLineEditLabel
    costLineType
    costLineCurrency
    editable
    exchangeEnabled
    exchangeRate
    tableRowIndex
    fractionalSortKey
    isInternational
    isVisible
    item
    item_fr
    margin
    marginPercentage
    number
    shootNumber
    overhead
    overheadPercentage
    discountPercentage
    overtimeDetails {
      multiplier
      overtimeHours
    }
    overtimeHours1
    overtimeHours2
    overtimeHours3
    overtimeHours4
    overtimeHours
    otNumberOfHours
    overtimeHoursCost
    payrollTaxEnabled
    payrollTaxType
    quantity
    rate
    rateInEuros
    rowColor
    costlineHeader
    subCategory
    subCategoryId
    subCategoryPrefix
    subCategorySuffix
    subCategory_fr
    subCategoryUuid
    subCategoryLabelValue
    thirdLevelSection
    thirdLevelSectionId
    thirdLevelSectionPrefix
    thirdLevelSection_fr
    thirdLevelSectionUuid
    thirdLevelSectionLabelValue
    total
    totalHeading
    totalMargin
    unit
    smg
    VAT_rate
    Acc_section
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedMutation<
	APITypes.CreateQuoteInfoMutationVariables,
	APITypes.CreateQuoteInfoMutation
>
export const updateQuoteInfo = /* GraphQL */ `mutation UpdateQuoteInfo(
  $input: UpdateQuoteInfoInput!
  $condition: ModelQuoteInfoConditionInput
) {
  updateQuoteInfo(input: $input, condition: $condition) {
    id
    quoteId
    tenantId
    originalQuoteId
    freelancers
    childFreelancers
    offlineIds
    activeFlag
    agentCommission
    agentCommissionPercentage
    allowMarginAndOverheadPercentageGlobalUpdate
    language
    costlineUuid
    category
    categoryId
    categoryPrefix
    category_fr
    categoryUuid
    categoryLabelValue
    costLineLabel
    costLineEditLabel
    costLineType
    costLineCurrency
    editable
    exchangeEnabled
    exchangeRate
    tableRowIndex
    fractionalSortKey
    isInternational
    isVisible
    item
    item_fr
    margin
    marginPercentage
    number
    shootNumber
    overhead
    overheadPercentage
    discountPercentage
    overtimeDetails {
      multiplier
      overtimeHours
    }
    overtimeHours1
    overtimeHours2
    overtimeHours3
    overtimeHours4
    overtimeHours
    otNumberOfHours
    overtimeHoursCost
    payrollTaxEnabled
    payrollTaxType
    quantity
    rate
    rateInEuros
    rowColor
    costlineHeader
    subCategory
    subCategoryId
    subCategoryPrefix
    subCategorySuffix
    subCategory_fr
    subCategoryUuid
    subCategoryLabelValue
    thirdLevelSection
    thirdLevelSectionId
    thirdLevelSectionPrefix
    thirdLevelSection_fr
    thirdLevelSectionUuid
    thirdLevelSectionLabelValue
    total
    totalHeading
    totalMargin
    unit
    smg
    VAT_rate
    Acc_section
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedMutation<
	APITypes.UpdateQuoteInfoMutationVariables,
	APITypes.UpdateQuoteInfoMutation
>
export const deleteQuoteInfo = /* GraphQL */ `mutation DeleteQuoteInfo(
  $input: DeleteQuoteInfoInput!
  $condition: ModelQuoteInfoConditionInput
) {
  deleteQuoteInfo(input: $input, condition: $condition) {
    id
    quoteId
    tenantId
    originalQuoteId
    freelancers
    childFreelancers
    offlineIds
    activeFlag
    agentCommission
    agentCommissionPercentage
    allowMarginAndOverheadPercentageGlobalUpdate
    language
    costlineUuid
    category
    categoryId
    categoryPrefix
    category_fr
    categoryUuid
    categoryLabelValue
    costLineLabel
    costLineEditLabel
    costLineType
    costLineCurrency
    editable
    exchangeEnabled
    exchangeRate
    tableRowIndex
    fractionalSortKey
    isInternational
    isVisible
    item
    item_fr
    margin
    marginPercentage
    number
    shootNumber
    overhead
    overheadPercentage
    discountPercentage
    overtimeDetails {
      multiplier
      overtimeHours
    }
    overtimeHours1
    overtimeHours2
    overtimeHours3
    overtimeHours4
    overtimeHours
    otNumberOfHours
    overtimeHoursCost
    payrollTaxEnabled
    payrollTaxType
    quantity
    rate
    rateInEuros
    rowColor
    costlineHeader
    subCategory
    subCategoryId
    subCategoryPrefix
    subCategorySuffix
    subCategory_fr
    subCategoryUuid
    subCategoryLabelValue
    thirdLevelSection
    thirdLevelSectionId
    thirdLevelSectionPrefix
    thirdLevelSection_fr
    thirdLevelSectionUuid
    thirdLevelSectionLabelValue
    total
    totalHeading
    totalMargin
    unit
    smg
    VAT_rate
    Acc_section
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedMutation<
	APITypes.DeleteQuoteInfoMutationVariables,
	APITypes.DeleteQuoteInfoMutation
>
export const createRecapInfo = /* GraphQL */ `mutation CreateRecapInfo(
  $input: CreateRecapInfoInput!
  $condition: ModelRecapInfoConditionInput
) {
  createRecapInfo(input: $input, condition: $condition) {
    id
    quoteId
    tenantId
    originalQuoteId
    freelancers
    childFreelancers
    offlineIds
    activeFlag
    uuid
    costlineUuid
    categoryId
    categoryUuid
    category
    category_fr
    categoryPrefix
    categoryLabelValue
    subCategoryId
    subCategoryUuid
    subCategory
    subCategory_fr
    subCategoryPrefix
    subCategorySuffix
    subCategoryLabelValue
    thirdLevelSection
    thirdLevelSectionId
    thirdLevelSectionPrefix
    thirdLevelSection_fr
    thirdLevelSectionUuid
    thirdLevelSectionLabelValue
    tableRowIndex
    fractionalSortKey
    item
    item_fr
    isInternational
    editable
    costLineType
    costLineLabel
    costLineEditLabel
    language
    number
    shootNumber
    rate
    exchangeEnabled
    exchangeRate
    rateInEuros
    quantity
    total
    totalMargin
    payrollTaxEnabled
    payrollTaxType
    overtimeHours1
    overtimeHours2
    overtimeHours3
    overtimeHours4
    otNumberOfHours
    overtimeHoursCost
    isCustomCostLine
    referenceCostLineUuid
    provisionalQuantity
    provisionalNumber
    provisionalShootNumber
    provisionalRate
    provisionalOtTotal
    provisionalTotal
    provisionalPayrollTaxEnabled
    provisionalPayrollTaxType
    actualTotal
    actualPayrollTaxEnabled
    actualPayrollTaxType
    purchaseTotal
    supplierStatus
    supplierId
    paymentStatus
    purchaseId
    comments
    invoiceId
    invoiceAvailable
    invoiceDocuments {
      bucket
      region
      key
      identityId
    }
    poAvailable
    purchaseOrderId
    rowColor
    costlineHeader
    startDate
    endDate
    days
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedMutation<
	APITypes.CreateRecapInfoMutationVariables,
	APITypes.CreateRecapInfoMutation
>
export const updateRecapInfo = /* GraphQL */ `mutation UpdateRecapInfo(
  $input: UpdateRecapInfoInput!
  $condition: ModelRecapInfoConditionInput
) {
  updateRecapInfo(input: $input, condition: $condition) {
    id
    quoteId
    tenantId
    originalQuoteId
    freelancers
    childFreelancers
    offlineIds
    activeFlag
    uuid
    costlineUuid
    categoryId
    categoryUuid
    category
    category_fr
    categoryPrefix
    categoryLabelValue
    subCategoryId
    subCategoryUuid
    subCategory
    subCategory_fr
    subCategoryPrefix
    subCategorySuffix
    subCategoryLabelValue
    thirdLevelSection
    thirdLevelSectionId
    thirdLevelSectionPrefix
    thirdLevelSection_fr
    thirdLevelSectionUuid
    thirdLevelSectionLabelValue
    tableRowIndex
    fractionalSortKey
    item
    item_fr
    isInternational
    editable
    costLineType
    costLineLabel
    costLineEditLabel
    language
    number
    shootNumber
    rate
    exchangeEnabled
    exchangeRate
    rateInEuros
    quantity
    total
    totalMargin
    payrollTaxEnabled
    payrollTaxType
    overtimeHours1
    overtimeHours2
    overtimeHours3
    overtimeHours4
    otNumberOfHours
    overtimeHoursCost
    isCustomCostLine
    referenceCostLineUuid
    provisionalQuantity
    provisionalNumber
    provisionalShootNumber
    provisionalRate
    provisionalOtTotal
    provisionalTotal
    provisionalPayrollTaxEnabled
    provisionalPayrollTaxType
    actualTotal
    actualPayrollTaxEnabled
    actualPayrollTaxType
    purchaseTotal
    supplierStatus
    supplierId
    paymentStatus
    purchaseId
    comments
    invoiceId
    invoiceAvailable
    invoiceDocuments {
      bucket
      region
      key
      identityId
    }
    poAvailable
    purchaseOrderId
    rowColor
    costlineHeader
    startDate
    endDate
    days
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedMutation<
	APITypes.UpdateRecapInfoMutationVariables,
	APITypes.UpdateRecapInfoMutation
>
export const deleteRecapInfo = /* GraphQL */ `mutation DeleteRecapInfo(
  $input: DeleteRecapInfoInput!
  $condition: ModelRecapInfoConditionInput
) {
  deleteRecapInfo(input: $input, condition: $condition) {
    id
    quoteId
    tenantId
    originalQuoteId
    freelancers
    childFreelancers
    offlineIds
    activeFlag
    uuid
    costlineUuid
    categoryId
    categoryUuid
    category
    category_fr
    categoryPrefix
    categoryLabelValue
    subCategoryId
    subCategoryUuid
    subCategory
    subCategory_fr
    subCategoryPrefix
    subCategorySuffix
    subCategoryLabelValue
    thirdLevelSection
    thirdLevelSectionId
    thirdLevelSectionPrefix
    thirdLevelSection_fr
    thirdLevelSectionUuid
    thirdLevelSectionLabelValue
    tableRowIndex
    fractionalSortKey
    item
    item_fr
    isInternational
    editable
    costLineType
    costLineLabel
    costLineEditLabel
    language
    number
    shootNumber
    rate
    exchangeEnabled
    exchangeRate
    rateInEuros
    quantity
    total
    totalMargin
    payrollTaxEnabled
    payrollTaxType
    overtimeHours1
    overtimeHours2
    overtimeHours3
    overtimeHours4
    otNumberOfHours
    overtimeHoursCost
    isCustomCostLine
    referenceCostLineUuid
    provisionalQuantity
    provisionalNumber
    provisionalShootNumber
    provisionalRate
    provisionalOtTotal
    provisionalTotal
    provisionalPayrollTaxEnabled
    provisionalPayrollTaxType
    actualTotal
    actualPayrollTaxEnabled
    actualPayrollTaxType
    purchaseTotal
    supplierStatus
    supplierId
    paymentStatus
    purchaseId
    comments
    invoiceId
    invoiceAvailable
    invoiceDocuments {
      bucket
      region
      key
      identityId
    }
    poAvailable
    purchaseOrderId
    rowColor
    costlineHeader
    startDate
    endDate
    days
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedMutation<
	APITypes.DeleteRecapInfoMutationVariables,
	APITypes.DeleteRecapInfoMutation
>
export const createSectionRename = /* GraphQL */ `mutation CreateSectionRename(
  $input: CreateSectionRenameInput!
  $condition: ModelSectionRenameConditionInput
) {
  createSectionRename(input: $input, condition: $condition) {
    id
    quoteId
    tenantId
    sectionId
    sectionType
    sectionName
    sectionName_fr
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedMutation<
	APITypes.CreateSectionRenameMutationVariables,
	APITypes.CreateSectionRenameMutation
>
export const updateSectionRename = /* GraphQL */ `mutation UpdateSectionRename(
  $input: UpdateSectionRenameInput!
  $condition: ModelSectionRenameConditionInput
) {
  updateSectionRename(input: $input, condition: $condition) {
    id
    quoteId
    tenantId
    sectionId
    sectionType
    sectionName
    sectionName_fr
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedMutation<
	APITypes.UpdateSectionRenameMutationVariables,
	APITypes.UpdateSectionRenameMutation
>
export const deleteSectionRename = /* GraphQL */ `mutation DeleteSectionRename(
  $input: DeleteSectionRenameInput!
  $condition: ModelSectionRenameConditionInput
) {
  deleteSectionRename(input: $input, condition: $condition) {
    id
    quoteId
    tenantId
    sectionId
    sectionType
    sectionName
    sectionName_fr
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedMutation<
	APITypes.DeleteSectionRenameMutationVariables,
	APITypes.DeleteSectionRenameMutation
>
export const createSubscriptionDetails =
	/* GraphQL */ `mutation CreateSubscriptionDetails(
  $input: CreateSubscriptionDetailsInput!
  $condition: ModelSubscriptionDetailsConditionInput
) {
  createSubscriptionDetails(input: $input, condition: $condition) {
    id
    tenantId
    stripeId
    subscriptionEndDate
    subscriptionStatus
    isEnterpriseUser
    subscriptionSubId
    subscriptionPriceId
    subscriptionProductId
    stripePaymentMethodId
    actualPaidTeamCount
    totalTeamCount
    activeFlag
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedMutation<
		APITypes.CreateSubscriptionDetailsMutationVariables,
		APITypes.CreateSubscriptionDetailsMutation
	>
export const updateSubscriptionDetails =
	/* GraphQL */ `mutation UpdateSubscriptionDetails(
  $input: UpdateSubscriptionDetailsInput!
  $condition: ModelSubscriptionDetailsConditionInput
) {
  updateSubscriptionDetails(input: $input, condition: $condition) {
    id
    tenantId
    stripeId
    subscriptionEndDate
    subscriptionStatus
    isEnterpriseUser
    subscriptionSubId
    subscriptionPriceId
    subscriptionProductId
    stripePaymentMethodId
    actualPaidTeamCount
    totalTeamCount
    activeFlag
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedMutation<
		APITypes.UpdateSubscriptionDetailsMutationVariables,
		APITypes.UpdateSubscriptionDetailsMutation
	>
export const deleteSubscriptionDetails =
	/* GraphQL */ `mutation DeleteSubscriptionDetails(
  $input: DeleteSubscriptionDetailsInput!
  $condition: ModelSubscriptionDetailsConditionInput
) {
  deleteSubscriptionDetails(input: $input, condition: $condition) {
    id
    tenantId
    stripeId
    subscriptionEndDate
    subscriptionStatus
    isEnterpriseUser
    subscriptionSubId
    subscriptionPriceId
    subscriptionProductId
    stripePaymentMethodId
    actualPaidTeamCount
    totalTeamCount
    activeFlag
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedMutation<
		APITypes.DeleteSubscriptionDetailsMutationVariables,
		APITypes.DeleteSubscriptionDetailsMutation
	>
export const createSuppliers = /* GraphQL */ `mutation CreateSuppliers(
  $input: CreateSuppliersInput!
  $condition: ModelSuppliersConditionInput
) {
  createSuppliers(input: $input, condition: $condition) {
    id
    tenantId
    activeFlag
    name
    idnumber
    vatNumber
    website
    phone
    firstName
    lastName
    contactEmail
    companyEmail
    contactPhone
    line01
    line02
    city
    state
    postalCode
    country
    currency
    paymentTerms
    taxType
    taxRate
    thirdPartyAccounts
    note
    bank
    iban
    bic
    accountName
    commercialName
    supplierCreditorAccount
    supplierSubAccount
    supplierType
    individualType
    isArchived
    internalADR
    quoteSectionDetails {
      quoteType
      categoryUuid
      subCategoryUuid
      categoryName
      subCategoryName
      categoryName_fr
      subCategoryName_fr
    }
    purchase {
      items {
        id
        tenantId
        activeFlag
        quoteId
        supplierId
        recapCostlineId
        quoteName
        projectName
        supplierName
        recapCostlineItem
        recapCostlineItem_fr
        currency
        provisionalTotal
        invoiceTotal
        taxAmount
        purchaseInvoiceDueDate
        purchaseArchivedDate
        purchasePaidDate
        supplierCreditorAccount
        purchaseOrderId
        poAvailable
        invoiceAvailable
        paymentStatus
        purchaseType
        supplierType
        invoiceKey
        tags
        invoiceDocuments {
          bucket
          region
          key
          identityId
        }
        quoteNumber
        projectNumber
        invoiceNumber
        purchaseToPayDate
        purchaseNumber
        purchaseOrderNumber
        projectId
        supplierTerms
        quantity
        number
        rate
        taxRate
        deliveryDate
        deliveryAddress
        poComments
        poGenerated
        createdOn
        updatedOn
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    _deleted
    _version
    _lastChangedAt
    createdOn
    updatedOn
  }
}
` as GeneratedMutation<
	APITypes.CreateSuppliersMutationVariables,
	APITypes.CreateSuppliersMutation
>
export const updateSuppliers = /* GraphQL */ `mutation UpdateSuppliers(
  $input: UpdateSuppliersInput!
  $condition: ModelSuppliersConditionInput
) {
  updateSuppliers(input: $input, condition: $condition) {
    id
    tenantId
    activeFlag
    name
    idnumber
    vatNumber
    website
    phone
    firstName
    lastName
    contactEmail
    companyEmail
    contactPhone
    line01
    line02
    city
    state
    postalCode
    country
    currency
    paymentTerms
    taxType
    taxRate
    thirdPartyAccounts
    note
    bank
    iban
    bic
    accountName
    commercialName
    supplierCreditorAccount
    supplierSubAccount
    supplierType
    individualType
    isArchived
    internalADR
    quoteSectionDetails {
      quoteType
      categoryUuid
      subCategoryUuid
      categoryName
      subCategoryName
      categoryName_fr
      subCategoryName_fr
    }
    purchase {
      items {
        id
        tenantId
        activeFlag
        quoteId
        supplierId
        recapCostlineId
        quoteName
        projectName
        supplierName
        recapCostlineItem
        recapCostlineItem_fr
        currency
        provisionalTotal
        invoiceTotal
        taxAmount
        purchaseInvoiceDueDate
        purchaseArchivedDate
        purchasePaidDate
        supplierCreditorAccount
        purchaseOrderId
        poAvailable
        invoiceAvailable
        paymentStatus
        purchaseType
        supplierType
        invoiceKey
        tags
        invoiceDocuments {
          bucket
          region
          key
          identityId
        }
        quoteNumber
        projectNumber
        invoiceNumber
        purchaseToPayDate
        purchaseNumber
        purchaseOrderNumber
        projectId
        supplierTerms
        quantity
        number
        rate
        taxRate
        deliveryDate
        deliveryAddress
        poComments
        poGenerated
        createdOn
        updatedOn
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    _deleted
    _version
    _lastChangedAt
    createdOn
    updatedOn
  }
}
` as GeneratedMutation<
	APITypes.UpdateSuppliersMutationVariables,
	APITypes.UpdateSuppliersMutation
>
export const deleteSuppliers = /* GraphQL */ `mutation DeleteSuppliers(
  $input: DeleteSuppliersInput!
  $condition: ModelSuppliersConditionInput
) {
  deleteSuppliers(input: $input, condition: $condition) {
    id
    tenantId
    activeFlag
    name
    idnumber
    vatNumber
    website
    phone
    firstName
    lastName
    contactEmail
    companyEmail
    contactPhone
    line01
    line02
    city
    state
    postalCode
    country
    currency
    paymentTerms
    taxType
    taxRate
    thirdPartyAccounts
    note
    bank
    iban
    bic
    accountName
    commercialName
    supplierCreditorAccount
    supplierSubAccount
    supplierType
    individualType
    isArchived
    internalADR
    quoteSectionDetails {
      quoteType
      categoryUuid
      subCategoryUuid
      categoryName
      subCategoryName
      categoryName_fr
      subCategoryName_fr
    }
    purchase {
      items {
        id
        tenantId
        activeFlag
        quoteId
        supplierId
        recapCostlineId
        quoteName
        projectName
        supplierName
        recapCostlineItem
        recapCostlineItem_fr
        currency
        provisionalTotal
        invoiceTotal
        taxAmount
        purchaseInvoiceDueDate
        purchaseArchivedDate
        purchasePaidDate
        supplierCreditorAccount
        purchaseOrderId
        poAvailable
        invoiceAvailable
        paymentStatus
        purchaseType
        supplierType
        invoiceKey
        tags
        invoiceDocuments {
          bucket
          region
          key
          identityId
        }
        quoteNumber
        projectNumber
        invoiceNumber
        purchaseToPayDate
        purchaseNumber
        purchaseOrderNumber
        projectId
        supplierTerms
        quantity
        number
        rate
        taxRate
        deliveryDate
        deliveryAddress
        poComments
        poGenerated
        createdOn
        updatedOn
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    _deleted
    _version
    _lastChangedAt
    createdOn
    updatedOn
  }
}
` as GeneratedMutation<
	APITypes.DeleteSuppliersMutationVariables,
	APITypes.DeleteSuppliersMutation
>
export const createUserInfo = /* GraphQL */ `mutation CreateUserInfo(
  $input: CreateUserInfoInput!
  $condition: ModelUserInfoConditionInput
) {
  createUserInfo(input: $input, condition: $condition) {
    id
    email
    activeFlag
    firstName
    lastName
    phone
    tenantId
    companyTenantId
    currentCompanyTenantId
    currentCompanyName
    cognitoGroup
    teamIds
    subTeamIds
    projectIds
    userLanguage
    hideTour
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
    owner
  }
}
` as GeneratedMutation<
	APITypes.CreateUserInfoMutationVariables,
	APITypes.CreateUserInfoMutation
>
export const updateUserInfo = /* GraphQL */ `mutation UpdateUserInfo(
  $input: UpdateUserInfoInput!
  $condition: ModelUserInfoConditionInput
) {
  updateUserInfo(input: $input, condition: $condition) {
    id
    email
    activeFlag
    firstName
    lastName
    phone
    tenantId
    companyTenantId
    currentCompanyTenantId
    currentCompanyName
    cognitoGroup
    teamIds
    subTeamIds
    projectIds
    userLanguage
    hideTour
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
    owner
  }
}
` as GeneratedMutation<
	APITypes.UpdateUserInfoMutationVariables,
	APITypes.UpdateUserInfoMutation
>
export const deleteUserInfo = /* GraphQL */ `mutation DeleteUserInfo(
  $input: DeleteUserInfoInput!
  $condition: ModelUserInfoConditionInput
) {
  deleteUserInfo(input: $input, condition: $condition) {
    id
    email
    activeFlag
    firstName
    lastName
    phone
    tenantId
    companyTenantId
    currentCompanyTenantId
    currentCompanyName
    cognitoGroup
    teamIds
    subTeamIds
    projectIds
    userLanguage
    hideTour
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
    owner
  }
}
` as GeneratedMutation<
	APITypes.DeleteUserInfoMutationVariables,
	APITypes.DeleteUserInfoMutation
>
export const addFreelancerToProject =
	/* GraphQL */ `mutation AddFreelancerToProject($projectId: ID!, $freelancerId: ID!) {
  addFreelancerToProject(projectId: $projectId, freelancerId: $freelancerId) {
    status
    message
  }
}
` as GeneratedMutation<
		APITypes.AddFreelancerToProjectMutationVariables,
		APITypes.AddFreelancerToProjectMutation
	>
export const createQuoteFromS3 = /* GraphQL */ `mutation CreateQuoteFromS3(
  $tenantId: ID!
  $parentProjectId: ID!
  $parentTeamId: ID!
  $parentSubTeamId: ID!
  $childFreelancers: [ID!]!
  $quoteId: ID!
  $quoteJson: QuoteS3InputDetails!
) {
  createQuoteFromS3(
    tenantId: $tenantId
    parentProjectId: $parentProjectId
    parentTeamId: $parentTeamId
    parentSubTeamId: $parentSubTeamId
    childFreelancers: $childFreelancers
    quoteId: $quoteId
    quoteJson: $quoteJson
  ) {
    status
    message
  }
}
` as GeneratedMutation<
	APITypes.CreateQuoteFromS3MutationVariables,
	APITypes.CreateQuoteFromS3Mutation
>
export const createNewCompanyQuoteTemplate =
	/* GraphQL */ `mutation CreateNewCompanyQuoteTemplate($quoteId: ID!) {
  createNewCompanyQuoteTemplate(quoteId: $quoteId) {
    status
    message
  }
}
` as GeneratedMutation<
		APITypes.CreateNewCompanyQuoteTemplateMutationVariables,
		APITypes.CreateNewCompanyQuoteTemplateMutation
	>
export const createNewCompanyQuoteTemplateIam =
	/* GraphQL */ `mutation CreateNewCompanyQuoteTemplateIam($quoteId: ID!) {
  createNewCompanyQuoteTemplateIam(quoteId: $quoteId) {
    status
    message
  }
}
` as GeneratedMutation<
		APITypes.CreateNewCompanyQuoteTemplateIamMutationVariables,
		APITypes.CreateNewCompanyQuoteTemplateIamMutation
	>
export const createUniqueEmailId =
	/* GraphQL */ `mutation CreateUniqueEmailId($companyId: ID!, $emailDomain: String!) {
  createUniqueEmailId(companyId: $companyId, emailDomain: $emailDomain) {
    status
    message
  }
}
` as GeneratedMutation<
		APITypes.CreateUniqueEmailIdMutationVariables,
		APITypes.CreateUniqueEmailIdMutation
	>
export const preparePurchaseOcr = /* GraphQL */ `mutation PreparePurchaseOcr(
  $bucket: String!
  $region: String!
  $key: String!
  $preparePurchaseId: ID!
) {
  preparePurchaseOcr(
    bucket: $bucket
    region: $region
    key: $key
    preparePurchaseId: $preparePurchaseId
  ) {
    status
    message
  }
}
` as GeneratedMutation<
	APITypes.PreparePurchaseOcrMutationVariables,
	APITypes.PreparePurchaseOcrMutation
>
export const newUserManagement = /* GraphQL */ `mutation NewUserManagement(
  $email: String!
  $tenantId: String!
  $teamIds: [String!]
  $subTeamIds: [String!]
  $projectIds: [String!]
  $cognitoGroup: String!
) {
  newUserManagement(
    email: $email
    tenantId: $tenantId
    teamIds: $teamIds
    subTeamIds: $subTeamIds
    projectIds: $projectIds
    cognitoGroup: $cognitoGroup
  ) {
    status
    message
  }
}
` as GeneratedMutation<
	APITypes.NewUserManagementMutationVariables,
	APITypes.NewUserManagementMutation
>
export const editUserManagement = /* GraphQL */ `mutation EditUserManagement(
  $email: String!
  $tenantId: String!
  $teamIds: [String!]
  $subTeamIds: [String!]
  $cognitoGroup: String!
) {
  editUserManagement(
    email: $email
    tenantId: $tenantId
    teamIds: $teamIds
    subTeamIds: $subTeamIds
    cognitoGroup: $cognitoGroup
  ) {
    status
    message
  }
}
` as GeneratedMutation<
	APITypes.EditUserManagementMutationVariables,
	APITypes.EditUserManagementMutation
>
export const newFreelanceUser = /* GraphQL */ `mutation NewFreelanceUser(
  $email: String!
  $tenantId: String!
  $projectIds: [String!]
  $cognitoGroup: String!
) {
  newFreelanceUser(
    email: $email
    tenantId: $tenantId
    projectIds: $projectIds
    cognitoGroup: $cognitoGroup
  ) {
    status
    message
  }
}
` as GeneratedMutation<
	APITypes.NewFreelanceUserMutationVariables,
	APITypes.NewFreelanceUserMutation
>
export const deleteUser =
	/* GraphQL */ `mutation DeleteUser($email: String!, $tenantId: String!) {
  deleteUser(email: $email, tenantId: $tenantId) {
    status
    message
  }
}
` as GeneratedMutation<
		APITypes.DeleteUserMutationVariables,
		APITypes.DeleteUserMutation
	>
export const createCompanyManagement =
	/* GraphQL */ `mutation CreateCompanyManagement(
  $companyName: String!
  $country: String!
  $currency: String!
  $idempotencyKey: String!
) {
  createCompanyManagement(
    companyName: $companyName
    country: $country
    currency: $currency
    idempotencyKey: $idempotencyKey
  ) {
    status
    message
    tenantId
    companyName
    errorCode
  }
}
` as GeneratedMutation<
		APITypes.CreateCompanyManagementMutationVariables,
		APITypes.CreateCompanyManagementMutation
	>
export const cleanUpAfterTestRun = /* GraphQL */ `mutation CleanUpAfterTestRun {
  cleanUpAfterTestRun {
    status
    message
  }
}
` as GeneratedMutation<
	APITypes.CleanUpAfterTestRunMutationVariables,
	APITypes.CleanUpAfterTestRunMutation
>
export const sendInvoiceToBillit =
	/* GraphQL */ `mutation SendInvoiceToBillit($tenantId: ID!, $invoiceId: ID!) {
  sendInvoiceToBillit(tenantId: $tenantId, invoiceId: $invoiceId) {
    status
    message
  }
}
` as GeneratedMutation<
		APITypes.SendInvoiceToBillitMutationVariables,
		APITypes.SendInvoiceToBillitMutation
	>
export const exportCostlines = /* GraphQL */ `mutation ExportCostlines(
  $tenantId: ID!
  $email: AWSEmail!
  $startDate: AWSDateTime
  $endDate: AWSDateTime
) {
  exportCostlines(
    tenantId: $tenantId
    email: $email
    startDate: $startDate
    endDate: $endDate
  ) {
    status
    message
  }
}
` as GeneratedMutation<
	APITypes.ExportCostlinesMutationVariables,
	APITypes.ExportCostlinesMutation
>
